import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AmadeusHotel = HotelBase & {
  __typename: 'AmadeusHotel';
  adaAccessibilityFeatures: Array<Scalars['String']['output']>;
  address: HotelAddress;
  amadeusHotelId: Scalars['ID']['output'];
  amenities: Array<Amenity>;
  chainCode?: Maybe<Scalars['String']['output']>;
  chainName?: Maybe<Scalars['String']['output']>;
  checkInTime?: Maybe<Scalars['String']['output']>;
  checkOutTime?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distributor: HotelDistributor;
  doNotBook: Scalars['Boolean']['output'];
  doNotBookReason?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  hotelChainGroup?: Maybe<HotelChainGroup>;
  id?: Maybe<Scalars['ID']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<HotelImage>>;
  latitude: Scalars['Float']['output'];
  lodgingType: LodgingType;
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  negotiatedRates: Array<NegotiatedRates>;
  ngIdentifier?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  starRating: Scalars['Int']['output'];
  status: HotelStatus;
  verified?: Maybe<Scalars['Boolean']['output']>;
};


export type AmadeusHotelNegotiatedRatesArgs = {
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
  roomQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export enum Amenity {
  /** ADA Accommodation */
  AdaAccommodation = 'ADA_ACCOMMODATION',
  /** Free parking */
  FreeParking = 'FREE_PARKING',
  /** Free Wifi */
  FreeWifi = 'FREE_WIFI',
  /** Has kitchen */
  HasKitchen = 'HAS_KITCHEN',
  /** Has kitchenette */
  HasKitchenette = 'HAS_KITCHENETTE',
  /** Washer and dryer */
  Laundry = 'LAUNDRY',
  /** Pet friendly */
  PetFriendly = 'PET_FRIENDLY',
  /** Truck parking */
  TruckParking = 'TRUCK_PARKING'
}

export enum AmenityRequirement {
  /** Nice to Have */
  NiceToHave = 'NICE_TO_HAVE',
  /** Not Required */
  NotRequired = 'NOT_REQUIRED',
  /** Required */
  Required = 'REQUIRED'
}

export type Booking = {
  __typename: 'Booking';
  amadeusCreatedAt?: Maybe<Scalars['String']['output']>;
  amadeusPnrNumber?: Maybe<Scalars['String']['output']>;
  avgPrice: Scalars['Int']['output'];
  basePrice: Scalars['Int']['output'];
  bookingHolder: BookingHolder;
  bookingRooms: Array<BookingRoom>;
  bookingSource: BookingSource;
  cancellationDetails?: Maybe<CancellationDetails>;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  confirmationNumber: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  creditCard?: Maybe<CreditCard>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedTax: Scalars['Int']['output'];
  grandTotalAfterTax: Scalars['Int']['output'];
  /** Selected guest cards for this booking, restricted to the current traveler when applicable. */
  guestPaymentMethods: Array<HotelGuestPayment>;
  guestsPerRoom: Scalars['Int']['output'];
  hotel: Hotel;
  hotelId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lineItems: Array<OrderLineItem>;
  nights: Scalars['Int']['output'];
  orderNumber: Scalars['String']['output'];
  rateChanges: Array<BookingRateChange>;
  rateCode?: Maybe<Scalars['String']['output']>;
  reservationId: Scalars['ID']['output'];
  roomBedType: Scalars['String']['output'];
  roomBeds: Scalars['Int']['output'];
  rooms: Scalars['Int']['output'];
  thsPrice: ThsPrice;
  totalPrice: Scalars['Int']['output'];
  /** Card selected when this booking was made; travelers can see only their own selection. */
  travelerPaymentMethod?: Maybe<HotelTravelerPayment>;
  user: User;
};

export type BookingGuest = {
  __typename: 'BookingGuest';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type BookingHolder = {
  __typename: 'BookingHolder';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  hotelRewardsNumber?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type BookingHolderInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  hotelRewardsNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type BookingRateChange = {
  __typename: 'BookingRateChange';
  effectiveDate: Scalars['String']['output'];
  expiryDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pretax: Scalars['Boolean']['output'];
  rate: Scalars['Int']['output'];
};

export type BookingRoom = {
  __typename: 'BookingRoom';
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  guests: Array<BookingGuest>;
  hotelRoomNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export enum BookingSource {
  /** Booked via Amadeus API */
  Amadeus = 'AMADEUS',
  /** Manually created/internal booking */
  Internal = 'INTERNAL'
}

export type CancellationDetails = {
  __typename: 'CancellationDetails';
  deadline?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  nonRefundable?: Maybe<Scalars['Boolean']['output']>;
};

export type CancellationDetailsInput = {
  deadline?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  nonRefundable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Client = {
  __typename: 'Client';
  clientPortalFlightRosterEnabled: Scalars['Boolean']['output'];
  clientPortalTravelerSelfBookingEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isInactive: Scalars['Boolean']['output'];
  thsPod?: Maybe<ClientPod>;
};

export type ClientFileUploadUrlResponse = {
  __typename: 'ClientFileUploadUrlResponse';
  path: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ClientGroupRequestCounts = {
  __typename: 'ClientGroupRequestCounts';
  all: Scalars['Int']['output'];
  awaitingConfirmation: Scalars['Int']['output'];
  canceled: Scalars['Int']['output'];
  confirmed: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  moreInfoRequired: Scalars['Int']['output'];
  requestReceived: Scalars['Int']['output'];
};

export type ClientGroupRequestsPagination = {
  __typename: 'ClientGroupRequestsPagination';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  items: Array<ClientTrip>;
  statusCounts: ClientGroupRequestCounts;
  total: Scalars['Int']['output'];
};

export enum ClientPod {
  /** Energy */
  Energy = 'ENERGY',
  /** Government Solutions */
  GovernmentSolutions = 'GOVERNMENT_SOLUTIONS',
  /** Other */
  Other = 'OTHER'
}

export type ClientSelfBookingCounts = {
  __typename: 'ClientSelfBookingCounts';
  all: Scalars['Int']['output'];
  inHouse: Scalars['Int']['output'];
  past: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  upcoming: Scalars['Int']['output'];
};

export type ClientSelfBookingsPagination = {
  __typename: 'ClientSelfBookingsPagination';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  items: Array<ClientTrip>;
  statusCounts: ClientSelfBookingCounts;
  total: Scalars['Int']['output'];
};

export type ClientTeamMember = {
  __typename: 'ClientTeamMember';
  company?: Maybe<Scalars['String']['output']>;
  edipi?: Maybe<Scalars['String']['output']>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  /** @deprecated Use requiredFieldValues.mission instead. This field is kept for backward compatibility. */
  mission?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['String']['output']>;
  semiUniqueIdentifier?: Maybe<Scalars['String']['output']>;
  taskForce?: Maybe<Scalars['String']['output']>;
  unknownGuest?: Maybe<Scalars['Boolean']['output']>;
};

export type ClientTeamMemberSelectOption = {
  __typename: 'ClientTeamMemberSelectOption';
  edipi?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  id?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  rank?: Maybe<Scalars['String']['output']>;
  semiUniqueIdentifier?: Maybe<Scalars['String']['output']>;
  unknownGuest?: Maybe<Scalars['Boolean']['output']>;
};

export type ClientTeamMemberSelectOptionInput = {
  edipi?: InputMaybe<Scalars['String']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  mission?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['String']['input']>;
  taskForce?: InputMaybe<Scalars['String']['input']>;
};

export type ClientTrip = {
  __typename: 'ClientTrip';
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  controlNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  guests: Scalars['Int']['output'];
  hasUnknownGuests: Scalars['Boolean']['output'];
  hotels: Array<Hotel>;
  id: Scalars['ID']['output'];
  rooms: Scalars['Int']['output'];
  status: TripStatus;
  tripType: TripType;
};

export type ClientTripCounts = {
  __typename: 'ClientTripCounts';
  all: Scalars['Int']['output'];
  inHouse: Scalars['Int']['output'];
  past: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  upcoming: Scalars['Int']['output'];
};

export type ClientTripsResponse = {
  __typename: 'ClientTripsResponse';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  statusCounts: ClientTripCounts;
  totalCount: Scalars['Int']['output'];
  trips: Array<ClientTrip>;
};

export type CreateAmadeusBookingClientInput = {
  amadeusHotelId: Scalars['String']['input'];
  bookingCode: Scalars['ID']['input'];
  bookingHolder: BookingHolderInput;
  bookingIntentId: Scalars['ID']['input'];
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
  clientId: Scalars['ID']['input'];
  expectedPricing?: InputMaybe<ExpectedPricingInput>;
  guestsByRoom: Array<Array<InputMaybe<Scalars['ID']['input']>>>;
  guestsPerRoom: Scalars['Int']['input'];
  location: ReservationLocationInput;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: Scalars['String']['input'];
  pricingFingerprint: Scalars['String']['input'];
  pricingId: Scalars['ID']['input'];
  rateCode: Scalars['String']['input'];
  requestKey: Scalars['ID']['input'];
  requiredFields?: InputMaybe<Array<RequiredFieldInput>>;
  roomBeds?: InputMaybe<Scalars['Int']['input']>;
  roomTypeCode: Scalars['String']['input'];
  rooms: Scalars['Int']['input'];
  skipGuestInfo?: InputMaybe<Scalars['Boolean']['input']>;
  travelerPaymentMethodId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateClientTeamMemberInput = {
  authorizedApprover?: InputMaybe<Scalars['Boolean']['input']>;
  clientSubgroup?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  edipi?: InputMaybe<Scalars['String']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  mission?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['String']['input']>;
  taskForce?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateRosterRequestInput = {
  controlNumber?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  requestDataDateChange?: InputMaybe<RosterRequestDataDateChangeInput>;
  requestDataNewReservation?: InputMaybe<NewReservationRequestInput>;
  requestType: RosterRequestType;
  rosterRoomAssignments?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateRosterRequestRemarkInput = {
  note: Scalars['String']['input'];
};

export type CreditCard = {
  __typename: 'CreditCard';
  bookingId: Scalars['ID']['output'];
  cardProvider?: Maybe<Scalars['String']['output']>;
  expiration: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
  providerCardId?: Maybe<Scalars['String']['output']>;
};

export type DashboardReport = {
  __typename: 'DashboardReport';
  checkins?: Maybe<RosterCheckinCheckoutReport>;
  cities?: Maybe<Array<RosterCityReport>>;
  summary?: Maybe<RosterSummaryReport>;
};

export type DateRangeInput = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type DoubleRoomOption = {
  __typename: 'DoubleRoomOption';
  firstBed: ClientTeamMemberSelectOption;
  secondBed?: Maybe<ClientTeamMemberSelectOption>;
};

export type DoubleRoomOptionInput = {
  firstBed: GuestInput;
  secondBed?: InputMaybe<GuestInput>;
};

export type DuplicateApproval = DuplicateApprovalAuthorized | DuplicateApprovalBlanket;

export type DuplicateApprovalAuthorized = {
  __typename: 'DuplicateApprovalAuthorized';
  approver?: Maybe<ClientTeamMember>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DuplicateApprovalBlanket = {
  __typename: 'DuplicateApprovalBlanket';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum DuplicateApprovalType {
  /** Authorized */
  Authorized = 'Authorized',
  /** Blanket */
  Blanket = 'BLANKET'
}

export type EvaluatedFeatureFlag = {
  __typename: 'EvaluatedFeatureFlag';
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

export type ExpectedPricingInput = {
  avgPrice?: InputMaybe<Scalars['Int']['input']>;
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  grandTotalAfterTax: Scalars['Int']['input'];
};

export type FeatureFlags = {
  __typename: 'FeatureFlags';
  enableHotelNetSuiteSync: Scalars['Boolean']['output'];
  enableRosterNetSuiteSync: Scalars['Boolean']['output'];
  flags: Array<EvaluatedFeatureFlag>;
  revision: Scalars['String']['output'];
};

export type FeatureFlagsUpdatedEvent = {
  __typename: 'FeatureFlagsUpdatedEvent';
  revision: Scalars['String']['output'];
};

export enum FlightDirectionFilter {
  Either = 'EITHER',
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type FlightLineItem = {
  __typename: 'FlightLineItem';
  clientPrice?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FlightRoster = {
  __typename: 'FlightRoster';
  chargeLineItems: Array<FlightLineItem>;
  clientTax: Scalars['Int']['output'];
  clientTicketPrice?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  guest: ClientTeamMember;
  id: Scalars['ID']['output'];
  inboundSegments: Array<FlightSegment>;
  noShowStatus?: Maybe<NoShowStatus>;
  outboundSegments: Array<FlightSegment>;
  requiredFieldValues: Array<FlightRosterRequiredFieldValue>;
  totalClientCost: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type FlightRosterFilter = {
  airlines?: InputMaybe<Array<Scalars['String']['input']>>;
  cabinClasses?: InputMaybe<Array<Scalars['String']['input']>>;
  confirmationNumber?: InputMaybe<Scalars['String']['input']>;
  datesDirection?: InputMaybe<FlightDirectionFilter>;
  datesFrom?: InputMaybe<Scalars['String']['input']>;
  datesTo?: InputMaybe<Scalars['String']['input']>;
  fromAirport?: InputMaybe<Scalars['String']['input']>;
  noShowStatus?: InputMaybe<Array<NoShowStatus>>;
  requiredFieldFilters?: InputMaybe<Array<FlightRosterRequiredFieldFilter>>;
  search?: InputMaybe<Scalars['String']['input']>;
  toAirport?: InputMaybe<Scalars['String']['input']>;
};

export type FlightRosterPagination = {
  __typename: 'FlightRosterPagination';
  items: Array<FlightRoster>;
  total: Scalars['Int']['output'];
};

export type FlightRosterRequiredFieldFilter = {
  name: ReservationRequiredField;
  searchString: Scalars['String']['input'];
};

export type FlightRosterRequiredFieldValue = {
  __typename: 'FlightRosterRequiredFieldValue';
  label: Scalars['String']['output'];
  name: ReservationRequiredField;
  value: Scalars['String']['output'];
};

export type FlightRosterSort = {
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  requiredFieldName?: InputMaybe<ReservationRequiredField>;
};

export type FlightSegment = {
  __typename: 'FlightSegment';
  airline?: Maybe<Scalars['String']['output']>;
  arriveAirport?: Maybe<Scalars['String']['output']>;
  arriveAt?: Maybe<Scalars['String']['output']>;
  cabinClass?: Maybe<Scalars['String']['output']>;
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  departAirport?: Maybe<Scalars['String']['output']>;
  departAt?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  seat?: Maybe<Scalars['String']['output']>;
};

export enum Gender {
  /** Female */
  F = 'F',
  /** Male */
  M = 'M'
}

export type GetClientFileUploadUrlInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
};

export type GuestInput = {
  edipi?: InputMaybe<Scalars['String']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mission?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['String']['input']>;
  taskForce?: InputMaybe<Scalars['String']['input']>;
};

export type Hotel = AmadeusHotel | ManualHotel;

export type HotelAddress = {
  __typename: 'HotelAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type HotelBase = {
  address: HotelAddress;
  chainCode?: Maybe<Scalars['String']['output']>;
  chainName?: Maybe<Scalars['String']['output']>;
  distributor: HotelDistributor;
  doNotBook: Scalars['Boolean']['output'];
  doNotBookReason?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  hotelChainGroup?: Maybe<HotelChainGroup>;
  lodgingType: LodgingType;
  name: Scalars['String']['output'];
  /**
   * Negotiated rates from contract data.
   * Pass booking parameters to get the applicable rate:
   * - checkInDate: selects the rate period covering this date
   * - checkOutDate: used with checkInDate to calculate nights for stay-length tiers
   * - roomQuantity: selects the correct volume tier
   * Returns an array of rate programs when a hotel has multiple rates (e.g., different rate programs or room types).
   */
  negotiatedRates: Array<NegotiatedRates>;
  ngIdentifier?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  status: HotelStatus;
};


export type HotelBaseNegotiatedRatesArgs = {
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
  roomQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type HotelBookingAttempt = {
  __typename: 'HotelBookingAttempt';
  bookingId?: Maybe<Scalars['ID']['output']>;
  bookingIntentId: Scalars['ID']['output'];
  confirmationNumbers: Array<Scalars['String']['output']>;
  failureCode?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  pricingId: Scalars['ID']['output'];
  recoveryAction?: Maybe<HotelBookingRecoveryAction>;
  replacementPricing?: Maybe<HotelBookingPricing>;
  requestKey: Scalars['ID']['output'];
  status: HotelBookingAttemptStatus;
};

export enum HotelBookingAttemptStatus {
  Confirmed = 'CONFIRMED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  ReconciliationRequired = 'RECONCILIATION_REQUIRED',
  ReconfirmationRequired = 'RECONFIRMATION_REQUIRED'
}

export type HotelBookingPricing = {
  __typename: 'HotelBookingPricing';
  bookingIntentId: Scalars['ID']['output'];
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  fingerprint: Scalars['String']['output'];
  guestsPerRoom: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  paymentMethod: Scalars['String']['output'];
  roomCount: Scalars['Int']['output'];
  roomDescription: Scalars['String']['output'];
  terms: Array<Scalars['String']['output']>;
  totalAfterTax: Scalars['Int']['output'];
  totalBeforeTax: Scalars['Int']['output'];
  totalTax: Scalars['Int']['output'];
};

export enum HotelBookingRecoveryAction {
  ContactSupport = 'CONTACT_SUPPORT',
  RefreshPricing = 'REFRESH_PRICING'
}

export type HotelBookingRequestCheck = {
  __typename: 'HotelBookingRequestCheck';
  attempt?: Maybe<HotelBookingAttempt>;
  closed: Scalars['Boolean']['output'];
};

export type HotelCardSetup = {
  __typename: 'HotelCardSetup';
  clientSecret?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum HotelCardSetupUiMode {
  Elements = 'ELEMENTS',
  EmbeddedPage = 'EMBEDDED_PAGE',
  HostedPage = 'HOSTED_PAGE'
}

export type HotelChain = {
  __typename: 'HotelChain';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type HotelChainGroup = {
  __typename: 'HotelChainGroup';
  chains: Array<HotelChain>;
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type HotelClientMembership = {
  __typename: 'HotelClientMembership';
  clientId: Scalars['ID']['output'];
  clientName: Scalars['String']['output'];
  clientTeamMemberId?: Maybe<Scalars['ID']['output']>;
  isInactive: Scalars['Boolean']['output'];
  roles: Array<UserRole>;
  status: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export enum HotelDistributor {
  /** Amadeus */
  Amadeus = 'AMADEUS',
  /** Booking.com */
  BookingCom = 'BOOKING_COM',
  /** Manual */
  Manual = 'MANUAL'
}

export type HotelGuestPayment = {
  __typename: 'HotelGuestPayment';
  brand: Scalars['String']['output'];
  expiryMonth: Scalars['Int']['output'];
  expiryYear: Scalars['Int']['output'];
  guestId: Scalars['ID']['output'];
  guestName: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  selectedAt: Scalars['String']['output'];
  status: HotelSavedCardStatus;
};

export type HotelImage = {
  __typename: 'HotelImage';
  description?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type HotelOffer = HotelOfferBase & {
  __typename: 'HotelOffer';
  amadeusHotelId: Scalars['ID']['output'];
  avgPrice: Scalars['Int']['output'];
  basePrice: Scalars['Int']['output'];
  bookingCode: Scalars['ID']['output'];
  cancellationDetails?: Maybe<CancellationDetails>;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  estimatedTax: Scalars['Int']['output'];
  guestsPerRoom: Scalars['Int']['output'];
  hotelId: Scalars['ID']['output'];
  nights: Scalars['Int']['output'];
  paymentMethod: Scalars['String']['output'];
  rateCode: Scalars['String']['output'];
  rateCodeCategory?: Maybe<Scalars['String']['output']>;
  roomBedType: Scalars['String']['output'];
  roomBeds: Scalars['Int']['output'];
  roomTypeCode: Scalars['String']['output'];
  rooms: Scalars['Int']['output'];
  thsPrice: ThsPrice;
  totalPrice: Scalars['Int']['output'];
};

export type HotelOfferBase = {
  avgPrice: Scalars['Int']['output'];
  basePrice: Scalars['Int']['output'];
  bookingCode: Scalars['ID']['output'];
  cancellationDetails?: Maybe<CancellationDetails>;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  estimatedTax: Scalars['Int']['output'];
  guestsPerRoom: Scalars['Int']['output'];
  nights: Scalars['Int']['output'];
  paymentMethod: Scalars['String']['output'];
  rateCode: Scalars['String']['output'];
  rateCodeCategory?: Maybe<Scalars['String']['output']>;
  roomBedType: Scalars['String']['output'];
  roomBeds: Scalars['Int']['output'];
  roomTypeCode: Scalars['String']['output'];
  rooms: Scalars['Int']['output'];
  thsPrice: ThsPrice;
  totalPrice: Scalars['Int']['output'];
};

export type HotelOfferDetails = {
  __typename: 'HotelOfferDetails';
  offer: HotelOffer;
  pricing: PricingResponse;
};

export type HotelPagination = {
  __typename: 'HotelPagination';
  items: Array<Hotel>;
  total: Scalars['Int']['output'];
};

export type HotelSavedCard = {
  __typename: 'HotelSavedCard';
  brand: Scalars['String']['output'];
  checkedAt: Scalars['String']['output'];
  expiryMonth: Scalars['Int']['output'];
  expiryYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  last4: Scalars['String']['output'];
  status: HotelSavedCardStatus;
};

export enum HotelSavedCardStatus {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Removed = 'REMOVED',
  Unknown = 'UNKNOWN'
}

export type HotelSavedCards = {
  __typename: 'HotelSavedCards';
  configured: Scalars['Boolean']['output'];
  methods: Array<HotelSavedCard>;
};

export type HotelSearchResponse = {
  __typename: 'HotelSearchResponse';
  moreIndicator?: Maybe<Scalars['String']['output']>;
  results: Array<HotelSearchResult>;
};

export type HotelSearchResult = {
  __typename: 'HotelSearchResult';
  hotel: AmadeusHotel;
  offers: Array<HotelOffer>;
};

export type HotelSearchSingleResult = {
  __typename: 'HotelSearchSingleResult';
  hotel: AmadeusHotel;
  offers: Array<HotelOffer>;
};

export enum HotelStatus {
  /** Hotel is active and available for booking */
  Active = 'ACTIVE',
  /** Hotel is closed and not available */
  Closed = 'CLOSED'
}

export type HotelTravelerCardPolicy = {
  __typename: 'HotelTravelerCardPolicy';
  required: Scalars['Boolean']['output'];
};

export type HotelTravelerPayment = {
  __typename: 'HotelTravelerPayment';
  brand: Scalars['String']['output'];
  expiryMonth: Scalars['Int']['output'];
  expiryYear: Scalars['Int']['output'];
  last4: Scalars['String']['output'];
  selectedAt: Scalars['String']['output'];
  status: HotelSavedCardStatus;
};

export type LineItemSelectionInput = {
  lineItemId: Scalars['ID']['input'];
  selected: Scalars['Boolean']['input'];
};

export enum LodgingType {
  /** Temporary worker housing/camp */
  Basecamp = 'BASECAMP',
  /** Traditional hotel */
  Hotel = 'HOTEL'
}

export type ManualHotel = HotelBase & {
  __typename: 'ManualHotel';
  address: HotelAddress;
  amenities: Array<Amenity>;
  chainCode?: Maybe<Scalars['String']['output']>;
  chainName?: Maybe<Scalars['String']['output']>;
  checkInTime?: Maybe<Scalars['String']['output']>;
  checkOutTime?: Maybe<Scalars['String']['output']>;
  distributor: HotelDistributor;
  doNotBook: Scalars['Boolean']['output'];
  doNotBookReason?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  hotelChainGroup?: Maybe<HotelChainGroup>;
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  lodgingType: LodgingType;
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  negotiatedRates: Array<NegotiatedRates>;
  ngIdentifier?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  status: HotelStatus;
  verified?: Maybe<Scalars['Boolean']['output']>;
};


export type ManualHotelNegotiatedRatesArgs = {
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
  roomQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MeetingSpaceRequirements = {
  __typename: 'MeetingSpaceRequirements';
  avRequirements: Scalars['String']['output'];
  setupDetails?: Maybe<Scalars['String']['output']>;
  squareFootage: Scalars['String']['output'];
};

export type MeetingSpaceRequirementsInput = {
  avRequirements: Scalars['String']['input'];
  setupDetails?: InputMaybe<Scalars['String']['input']>;
  squareFootage: Scalars['String']['input'];
};

export type Mutation = {
  __typename: 'Mutation';
  acceptHotelPortalTerms: PortalTermsStatus;
  cancelRosterRequest: RosterRequest;
  chooseProposalOption: Proposal;
  closeUnreceivedHotelBookingRequest: HotelBookingRequestCheck;
  createAmadeusBooking: Booking;
  createClientTeamMember: ClientTeamMember;
  createRosterRequest: RosterRequest;
  createRosterRequestRemark: RosterRequestRemark;
  /** Delete a file from a roster request (only the request owner can delete) */
  deleteRosterRequestFile: Scalars['Boolean']['output'];
  /** Generate a signed URL for uploading a file to temporary storage */
  getClientFileUploadUrl: ClientFileUploadUrlResponse;
  removeAssignmentFromRosterRequest: RosterRequest;
  removeHotelSavedCard: HotelSavedCard;
  requestNewGroupReservation: RosterRequest;
  requestNewReservation: RosterRequest;
  sendBookingConfirmationEmail: Scalars['Boolean']['output'];
  sendRemarkResponseEmail: Scalars['Boolean']['output'];
  setDefaultHotelSavedCard: HotelSavedCard;
  startHotelCardSetup: HotelCardSetup;
  updateGroupReservationRequest: RosterRequest;
  updateRosterRequest: RosterRequest;
  /** Finalize file upload by moving from temporary storage and creating database record */
  uploadRosterRequestFile: RosterRequestFile;
};


export type MutationAcceptHotelPortalTermsArgs = {
  versionId: Scalars['ID']['input'];
};


export type MutationCancelRosterRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChooseProposalOptionArgs = {
  id: Scalars['ID']['input'];
  lineItemSelections?: InputMaybe<Array<LineItemSelectionInput>>;
};


export type MutationCloseUnreceivedHotelBookingRequestArgs = {
  requestKey: Scalars['ID']['input'];
};


export type MutationCreateAmadeusBookingArgs = {
  input: CreateAmadeusBookingClientInput;
};


export type MutationCreateClientTeamMemberArgs = {
  input: CreateClientTeamMemberInput;
};


export type MutationCreateRosterRequestArgs = {
  input: CreateRosterRequestInput;
};


export type MutationCreateRosterRequestRemarkArgs = {
  input: CreateRosterRequestRemarkInput;
  rosterRequestId: Scalars['ID']['input'];
};


export type MutationDeleteRosterRequestFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGetClientFileUploadUrlArgs = {
  input: GetClientFileUploadUrlInput;
};


export type MutationRemoveAssignmentFromRosterRequestArgs = {
  rosterRequestId: Scalars['ID']['input'];
  rosterRoomAssignmentId: Scalars['ID']['input'];
};


export type MutationRemoveHotelSavedCardArgs = {
  methodId: Scalars['ID']['input'];
};


export type MutationRequestNewGroupReservationArgs = {
  input: NewGroupReservationRequestInput;
};


export type MutationRequestNewReservationArgs = {
  input: NewReservationRequestInput;
};


export type MutationSendBookingConfirmationEmailArgs = {
  input: SendBookingConfirmationEmailInput;
};


export type MutationSendRemarkResponseEmailArgs = {
  input: RemarkResponseInput;
};


export type MutationSetDefaultHotelSavedCardArgs = {
  methodId: Scalars['ID']['input'];
};


export type MutationStartHotelCardSetupArgs = {
  embedded?: Scalars['Boolean']['input'];
  requestKey: Scalars['ID']['input'];
  uiMode?: InputMaybe<HotelCardSetupUiMode>;
};


export type MutationUpdateGroupReservationRequestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGroupReservationRequestInput;
};


export type MutationUpdateRosterRequestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateRosterRequestInput;
};


export type MutationUploadRosterRequestFileArgs = {
  input: UploadRosterRequestFileInput;
};

/** Pricing details for a specific occupancy type (single/double) */
export type NegotiatedOccupancyPricing = {
  __typename: 'NegotiatedOccupancyPricing';
  /** The pricing mode determines how rates are structured */
  pricingMode: NegotiatedPricingMode;
  /** For SIMPLE mode: the flat rate in cents */
  rate?: Maybe<Scalars['Int']['output']>;
  /** For SIMPLE mode: formatted rate string */
  rateDisplay?: Maybe<Scalars['String']['output']>;
  /** Index of the selected tier based on booking params (null for SIMPLE) */
  selectedTierIndex?: Maybe<Scalars['Int']['output']>;
  /** For STAY_LENGTH_TIERED mode: list of stay length tiers */
  stayLengthTiers?: Maybe<Array<NegotiatedStayLengthTier>>;
  /** For VOLUME_TIERED mode: list of volume tiers */
  volumeTiers?: Maybe<Array<NegotiatedVolumeTier>>;
};

/** Pricing mode for negotiated rates */
export enum NegotiatedPricingMode {
  /** Simple flat rate */
  Simple = 'SIMPLE',
  /** Rate varies by length of stay */
  StayLengthTiered = 'STAY_LENGTH_TIERED',
  /** Rate varies by unit (nightly/weekly/monthly) */
  UnitBased = 'UNIT_BASED',
  /** Rate varies by number of rooms booked */
  VolumeTiered = 'VOLUME_TIERED'
}

/**
 * Negotiated rates for a hotel from contract data.
 * Pass booking parameters to get the applicable rate for your search.
 */
export type NegotiatedRates = {
  __typename: 'NegotiatedRates';
  /**
   * Legacy field - use effectiveEndDate instead
   * @deprecated Use effectiveEndDate instead
   */
  activeThrough?: Maybe<Scalars['String']['output']>;
  /** Rate program description (e.g., 'Corporate Travel', 'Gov't Project') */
  description?: Maybe<Scalars['String']['output']>;
  /** Formatted double rate string for display (e.g., '$119') */
  double?: Maybe<Scalars['String']['output']>;
  /** Double rate in cents */
  doubleCents?: Maybe<Scalars['Int']['output']>;
  /** Detailed pricing info for double occupancy (includes tiers) */
  doublePricing?: Maybe<NegotiatedOccupancyPricing>;
  /** End of the rate period */
  effectiveEndDate?: Maybe<Scalars['String']['output']>;
  /** Start of the rate period */
  effectiveStartDate?: Maybe<Scalars['String']['output']>;
  /** Whether a contract rate exists for the hotel */
  isActive: Scalars['Boolean']['output'];
  /** Formatted single rate string for display (e.g., '$109') */
  single?: Maybe<Scalars['String']['output']>;
  /** Single rate in cents */
  singleCents?: Maybe<Scalars['Int']['output']>;
  /** Detailed pricing info for single occupancy (includes tiers) */
  singlePricing?: Maybe<NegotiatedOccupancyPricing>;
  /** Description of rate terms/usage */
  usage?: Maybe<Scalars['String']['output']>;
};

/** Stay length tier for stay-length-based pricing */
export type NegotiatedStayLengthTier = {
  __typename: 'NegotiatedStayLengthTier';
  maxNights?: Maybe<Scalars['Int']['output']>;
  minNights: Scalars['Int']['output'];
  rate: Scalars['Int']['output'];
  /** Formatted rate string (e.g., '$109') */
  rateDisplay: Scalars['String']['output'];
};

/** Volume tier for volume-based pricing */
export type NegotiatedVolumeTier = {
  __typename: 'NegotiatedVolumeTier';
  maxRooms?: Maybe<Scalars['Int']['output']>;
  minRooms: Scalars['Int']['output'];
  rate: Scalars['Int']['output'];
  /** Formatted rate string (e.g., '$109') */
  rateDisplay: Scalars['String']['output'];
};

export type NewGroupReservationRequestInput = {
  additionalPreferences?: InputMaybe<Scalars['String']['input']>;
  brandPreference: Scalars['String']['input'];
  breakfast: Scalars['String']['input'];
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  distanceFromDestination: Scalars['Int']['input'];
  double: Array<DoubleRoomOptionInput>;
  freeParking: Scalars['String']['input'];
  guestQuantity: Scalars['Int']['input'];
  kitchen: Scalars['String']['input'];
  meetingSpace: Scalars['String']['input'];
  meetingSpaceRequirements?: InputMaybe<MeetingSpaceRequirementsInput>;
  otherAmenities?: InputMaybe<Scalars['String']['input']>;
  quantities: RoomQuantitiesInput;
  requiredFields?: InputMaybe<Array<RequiredFieldInput>>;
  roomConfigurations?: InputMaybe<RoomConfigurationsInput>;
  shortList: Array<ShortListHotelInput>;
  single: Array<GuestInput>;
  skipGuestList?: InputMaybe<Scalars['Boolean']['input']>;
  suite: Array<GuestInput>;
  washerDryer: Scalars['String']['input'];
};

export type NewReservationFileInput = {
  displayFilename?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  originalFilename: Scalars['String']['input'];
  tempFilePath: Scalars['String']['input'];
};

export type NewReservationRequestClientTeamMemberInput = {
  checkin: Scalars['String']['input'];
  checkout: Scalars['String']['input'];
  edipi?: InputMaybe<Scalars['String']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  mission?: InputMaybe<Scalars['String']['input']>;
  previousHotelAddress?: InputMaybe<Scalars['String']['input']>;
  previousHotelName?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['String']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  roomType?: InputMaybe<Scalars['String']['input']>;
  taskForce?: InputMaybe<Scalars['String']['input']>;
};

export type NewReservationRequestInput = {
  attachments?: InputMaybe<Array<NewReservationFileInput>>;
  controlNumber?: InputMaybe<Scalars['String']['input']>;
  existingGuests?: InputMaybe<Array<InputMaybe<NewReservationRequestClientTeamMemberInput>>>;
  newGuests?: InputMaybe<Array<InputMaybe<NewReservationRequestClientTeamMemberInput>>>;
  preferredHotelAddress?: InputMaybe<Scalars['String']['input']>;
  preferredHotelEmail?: InputMaybe<Scalars['String']['input']>;
  preferredHotelName?: InputMaybe<Scalars['String']['input']>;
  preferredHotelPhone?: InputMaybe<Scalars['String']['input']>;
  requiredFields?: InputMaybe<Array<RequiredFieldInput>>;
};

export enum NoShowStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** No Show */
  NoShow = 'NO_SHOW'
}

export type Order = {
  __typename: 'Order';
  clientId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  orderNumber?: Maybe<Scalars['String']['output']>;
  reservations: Array<Reservation>;
};

export type OrderLineItem = {
  __typename: 'OrderLineItem';
  attributedGuestName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hotel: Hotel;
  hotelId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderId: Scalars['ID']['output'];
  price: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PodRequiredFields = {
  __typename: 'PodRequiredFields';
  pod: ClientPod;
  requiredFields: Array<RequiredFieldOptions>;
};

export type PortalTermsAdmin = {
  __typename: 'PortalTermsAdmin';
  draft: PortalTermsSnapshot;
  hasDraft: Scalars['Boolean']['output'];
  published?: Maybe<PortalTermsVersion>;
  revision: Scalars['Int']['output'];
};

export type PortalTermsAuditEntry = {
  __typename: 'PortalTermsAuditEntry';
  action: Scalars['String']['output'];
  actorId: Scalars['String']['output'];
  actorLabel: Scalars['String']['output'];
  after: PortalTermsSnapshot;
  before: PortalTermsSnapshot;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type PortalTermsAuditPage = {
  __typename: 'PortalTermsAuditPage';
  entries: Array<PortalTermsAuditEntry>;
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['ID']['output']>;
};

export type PortalTermsDraftInput = {
  changeSummary: Scalars['String']['input'];
  content: Scalars['String']['input'];
  requiresAcceptance: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
};

export type PortalTermsSnapshot = {
  __typename: 'PortalTermsSnapshot';
  changeSummary: Scalars['String']['output'];
  content: Scalars['String']['output'];
  requiresAcceptance: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

export type PortalTermsStatus = {
  __typename: 'PortalTermsStatus';
  published?: Maybe<PortalTermsVersion>;
  requiresAcceptance: Scalars['Boolean']['output'];
};

export type PortalTermsVersion = {
  __typename: 'PortalTermsVersion';
  changeSummary: Scalars['String']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  publishedAt: Scalars['String']['output'];
  requiresAcceptance: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type PricingResponse = {
  __typename: 'PricingResponse';
  bookingCode: Scalars['String']['output'];
  bookingPricing?: Maybe<HotelBookingPricing>;
  grandTotalAfterTax: Scalars['Int']['output'];
  grandTotalBeforeTax: Scalars['Int']['output'];
  grandTotalTax: Scalars['Int']['output'];
  rateChanges: Array<RateChange>;
};

export type Profile = {
  __typename: 'Profile';
  client?: Maybe<Client>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientTeamMember?: Maybe<ClientTeamMember>;
  clientTeamMemberId?: Maybe<Scalars['ID']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
};

export type Proposal = {
  __typename: 'Proposal';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  preferredProposalOptionId?: Maybe<Scalars['ID']['output']>;
  proposalOptions: Array<ProposalOption>;
  requestData: RosterRequestDataNewGroupReservation;
  updatedAt: Scalars['String']['output'];
};

export type ProposalOption = {
  __typename: 'ProposalOption';
  hotels: Array<ProposalOptionHotel>;
  id: Scalars['ID']['output'];
  totalPrice: Scalars['Int']['output'];
  totalRooms: Scalars['Int']['output'];
};

export type ProposalOptionHotel = {
  __typename: 'ProposalOptionHotel';
  double?: Maybe<ProposalRoom>;
  hotel: Hotel;
  hotelId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lineItems: Array<ProposalOptionHotelLineItem>;
  single?: Maybe<ProposalRoom>;
  suite?: Maybe<ProposalRoom>;
};

export type ProposalOptionHotelLineItem = {
  __typename: 'ProposalOptionHotelLineItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
};

export type ProposalRoom = {
  __typename: 'ProposalRoom';
  avgPrice?: Maybe<Scalars['Int']['output']>;
  cancellationDeadline?: Maybe<Scalars['String']['output']>;
  roomAmount?: Maybe<Scalars['Int']['output']>;
  roomBedType?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename: 'Query';
  booking: Booking;
  clientGroupRequests: ClientGroupRequestsPagination;
  clientRequiredFields: PodRequiredFields;
  clientSelfBookings: ClientSelfBookingsPagination;
  clientSubgroups: Array<Scalars['String']['output']>;
  clientTeamMembers: Array<ClientTeamMember>;
  clientUser: User;
  dashboardReport: DashboardReport;
  duplicateRosterChangeRequests: Array<RosterRequest>;
  duplicateRosterNewReservationRequests: Array<RosterRequest>;
  featureFlags: FeatureFlags;
  findAssignmentsByGuestAndDate?: Maybe<Array<RosterRoomAssignment>>;
  flightRosterReport: Scalars['String']['output'];
  flightRosters: FlightRosterPagination;
  hotelBookingAttempts: Array<HotelBookingAttempt>;
  hotelChainGroups: Array<HotelChainGroup>;
  hotelChains: Array<HotelChain>;
  hotelMemberships: Array<HotelClientMembership>;
  hotelOfferDetailsWithSession: HotelOfferDetails;
  /** Format for checkOutDate/checkInDate is YYYY-MM-DD */
  hotelSearch: HotelSearchResponse;
  hotelSearchSingle: HotelSearchSingleResult;
  hotelTravelerCardPolicy: HotelTravelerCardPolicy;
  myHotelPortalTermsStatus: PortalTermsStatus;
  myHotelSavedCards: HotelSavedCards;
  proposal: Proposal;
  publicHotelPortalTerms?: Maybe<PortalTermsVersion>;
  roster: RosterRoomAssignmentPagination;
  rosterItems: Array<RosterRoomAssignment>;
  rosterReport: Scalars['String']['output'];
  rosterRequest: RosterRequest;
  /** Get a signed URL for viewing/downloading a roster request file */
  rosterRequestFileUrl: Scalars['String']['output'];
  rosterRequests: RosterRequestsPagination;
  savedHotel: Hotel;
  unknownGuest?: Maybe<ClientTeamMember>;
  users: Array<User>;
};


export type QueryBookingArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QueryClientGroupRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TripStatus>;
};


export type QueryClientSelfBookingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TripStatus>;
};


export type QueryClientTeamMembersArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  edipi?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  limit?: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: Scalars['Int']['input'];
  rank?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  semiUniqueIdentifier?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDuplicateRosterChangeRequestsArgs = {
  rosterRoomAssignmentIds: Array<Scalars['ID']['input']>;
};


export type QueryDuplicateRosterNewReservationRequestsArgs = {
  guestIds: Array<Scalars['ID']['input']>;
};


export type QueryFindAssignmentsByGuestAndDateArgs = {
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
  guestId: Scalars['ID']['input'];
};


export type QueryFlightRosterReportArgs = {
  filter?: InputMaybe<FlightRosterFilter>;
  sort?: InputMaybe<FlightRosterSort>;
};


export type QueryFlightRostersArgs = {
  filter?: InputMaybe<FlightRosterFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<FlightRosterSort>;
};


export type QueryHotelBookingAttemptsArgs = {
  bookingIntentId?: InputMaybe<Scalars['ID']['input']>;
  requestKey?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHotelOfferDetailsWithSessionArgs = {
  amadeusHotelId: Scalars['ID']['input'];
  bookingCode: Scalars['String']['input'];
  bookingIntentId?: InputMaybe<Scalars['ID']['input']>;
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
  guestQuantity?: InputMaybe<Scalars['Int']['input']>;
  roomBedType: Scalars['String']['input'];
  roomBeds: Scalars['Int']['input'];
  roomQuantity?: InputMaybe<Scalars['Int']['input']>;
  roomTypeCode: Scalars['String']['input'];
};


export type QueryHotelSearchArgs = {
  accessibleRoomsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
  guestQuantity?: InputMaybe<Scalars['Int']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  moreIndicator?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['Int']['input']>;
  roomQuantity?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHotelSearchSingleArgs = {
  accessibleRoomsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  amadeusHotelId: Scalars['ID']['input'];
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
  guestQuantity?: InputMaybe<Scalars['Int']['input']>;
  roomQuantity?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyHotelSavedCardsArgs = {
  onlyWhenRequired?: Scalars['Boolean']['input'];
};


export type QueryProposalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicHotelPortalTermsArgs = {
  versionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRosterArgs = {
  filter?: InputMaybe<RosterFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<SortInput>;
};


export type QueryRosterItemsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryRosterReportArgs = {
  filter?: InputMaybe<RosterFilterInput>;
  sort?: InputMaybe<SortInput>;
};


export type QueryRosterRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRosterRequestFileUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRosterRequestsArgs = {
  filter?: InputMaybe<RosterRequestsFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: InputMaybe<SortInput>;
};


export type QuerySavedHotelArgs = {
  id: Scalars['ID']['input'];
};

export type RateChange = {
  __typename: 'RateChange';
  effectiveDate: Scalars['String']['output'];
  expiryDate: Scalars['String']['output'];
  pretax: Scalars['Boolean']['output'];
  rate: Scalars['Int']['output'];
};

export type RateChangeInput = {
  effectiveDate: Scalars['String']['input'];
  expiryDate: Scalars['String']['input'];
  pretax: Scalars['Boolean']['input'];
  rate: Scalars['Int']['input'];
};

export type RemarkResponseInput = {
  remarkId: Scalars['ID']['input'];
  response: Scalars['String']['input'];
};

export type RequiredField = {
  __typename: 'RequiredField';
  name: ReservationRequiredField;
  value?: Maybe<Scalars['String']['output']>;
};

export type RequiredFieldInput = {
  name: ReservationRequiredField;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type RequiredFieldOptions = {
  __typename: 'RequiredFieldOptions';
  label: Scalars['String']['output'];
  readOnly: Scalars['Boolean']['output'];
  scope: RequiredFieldScope;
  value: ReservationRequiredField;
};

export enum RequiredFieldScope {
  Assignment = 'ASSIGNMENT',
  Guest = 'GUEST',
  Order = 'ORDER'
}

export type Reservation = {
  __typename: 'Reservation';
  booking?: Maybe<Booking>;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  guestsPerRoom: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  nights: Scalars['Int']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['ID']['output'];
  reservationNumber: Scalars['Int']['output'];
  rooms: Scalars['Int']['output'];
};

export type ReservationLocationInput = {
  city: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export enum ReservationRequiredField {
  /** Approver ID */
  ApproverId = 'APPROVER_ID',
  /** Contact Info */
  ContactInfo = 'CONTACT_INFO',
  /** Control # */
  ControlNumber = 'CONTROL_NUMBER',
  /** Cost center */
  CostCenter = 'COST_CENTER',
  /** Crew */
  Crew = 'CREW',
  /** Customer */
  Customer = 'CUSTOMER',
  /** Department Code */
  DepartmentCode = 'DEPARTMENT_CODE',
  /** District */
  District = 'DISTRICT',
  /** DoD ID */
  DodId = 'DOD_ID',
  /** Door Code */
  DoorCode = 'DOOR_CODE',
  /** Employee # */
  EmployeeNumber = 'EMPLOYEE_NUMBER',
  /** Fleet # */
  FleetNumber = 'FLEET_NUMBER',
  /** Gender */
  Gender = 'GENDER',
  /** Job # */
  JobNumber = 'JOB_NUMBER',
  /** Job/Project name */
  JobProjectName = 'JOB_PROJECT_NAME',
  /** Job Title */
  JobTitle = 'JOB_TITLE',
  /** Location/Base */
  LocationBase = 'LOCATION_BASE',
  /** Mission */
  Mission = 'MISSION',
  /** Ordered By */
  OrderedBy = 'ORDERED_BY',
  /** PO or GL */
  PoOrGl = 'PO_OR_GL',
  /** Rank */
  Rank = 'RANK',
  /** Request ID */
  RequestId = 'REQUEST_ID',
  /** Unit */
  TaskForce = 'TASK_FORCE',
  /** TRF # */
  TrfNumber = 'TRF_NUMBER',
  /** Unit Code */
  UnitCode = 'UNIT_CODE',
  /** Well */
  Well = 'WELL',
  /** WO # */
  WorkOrder = 'WORK_ORDER'
}

export type RoomConfiguration = {
  __typename: 'RoomConfiguration';
  guests: Scalars['Int']['output'];
  rooms: Scalars['Int']['output'];
};

export type RoomConfigurationInput = {
  guests: Scalars['Int']['input'];
  rooms: Scalars['Int']['input'];
};

export type RoomConfigurations = {
  __typename: 'RoomConfigurations';
  double: Array<RoomConfiguration>;
  single: Array<RoomConfiguration>;
  suite: Array<RoomConfiguration>;
};

export type RoomConfigurationsInput = {
  double: Array<RoomConfigurationInput>;
  single: Array<RoomConfigurationInput>;
  suite: Array<RoomConfigurationInput>;
};

export type RoomInput = {
  confirmationNumber: Scalars['String']['input'];
  guests: Array<GuestInput>;
};

export type RoomQuantities = {
  __typename: 'RoomQuantities';
  double: Scalars['Int']['output'];
  single: Scalars['Int']['output'];
  suite: Scalars['Int']['output'];
};

export type RoomQuantitiesInput = {
  double: Scalars['Int']['input'];
  single: Scalars['Int']['input'];
  suite: Scalars['Int']['input'];
};

export type RosterCheckinCheckoutReport = {
  __typename: 'RosterCheckinCheckoutReport';
  checkIns: Scalars['Int']['output'];
  checkInsWeekly: Scalars['Int']['output'];
  checkOuts: Scalars['Int']['output'];
  duplicateApprovals: Scalars['Int']['output'];
};

export type RosterCityReport = {
  __typename: 'RosterCityReport';
  city: Scalars['String']['output'];
  inHouse: Scalars['Int']['output'];
  state: Scalars['String']['output'];
  upcoming: Scalars['Int']['output'];
};

export enum RosterColumnId {
  AccountingUpdateStatus = 'ACCOUNTING_UPDATE_STATUS',
  ActionRequired = 'ACTION_REQUIRED',
  AddedBy = 'ADDED_BY',
  AddedDate = 'ADDED_DATE',
  ApproverId = 'APPROVER_ID',
  BedNumber = 'BED_NUMBER',
  CheckInDate = 'CHECK_IN_DATE',
  CheckOutDate = 'CHECK_OUT_DATE',
  ClientRate = 'CLIENT_RATE',
  ContactInfo = 'CONTACT_INFO',
  ControlNumber = 'CONTROL_NUMBER',
  CostCenter = 'COST_CENTER',
  Crew = 'CREW',
  Customer = 'CUSTOMER',
  District = 'DISTRICT',
  DodId = 'DOD_ID',
  DoorCode = 'DOOR_CODE',
  DuplicateApproved = 'DUPLICATE_APPROVED',
  EmployeeNumber = 'EMPLOYEE_NUMBER',
  FleetNumber = 'FLEET_NUMBER',
  Gender = 'GENDER',
  GuestName = 'GUEST_NAME',
  HotelAddress = 'HOTEL_ADDRESS',
  HotelCity = 'HOTEL_CITY',
  HotelConfirmationNumber = 'HOTEL_CONFIRMATION_NUMBER',
  HotelState = 'HOTEL_STATE',
  JobNumber = 'JOB_NUMBER',
  JobProjectName = 'JOB_PROJECT_NAME',
  JobTitle = 'JOB_TITLE',
  LocationBase = 'LOCATION_BASE',
  Mission = 'MISSION',
  NoShowStatus = 'NO_SHOW_STATUS',
  OrderedBy = 'ORDERED_BY',
  PoOrGl = 'PO_OR_GL',
  PropertyName = 'PROPERTY_NAME',
  PropId = 'PROP_ID',
  QuotedRate = 'QUOTED_RATE',
  Rank = 'RANK',
  Remarks = 'REMARKS',
  RequestId = 'REQUEST_ID',
  ReservationNumber = 'RESERVATION_NUMBER',
  RoomNumber = 'ROOM_NUMBER',
  RoomType = 'ROOM_TYPE',
  Status = 'STATUS',
  TaskForce = 'TASK_FORCE',
  ThsPo = 'THS_PO',
  ThsRate = 'THS_RATE',
  TrfNumber = 'TRF_NUMBER',
  Verified = 'VERIFIED',
  Well = 'WELL',
  WorkOrder = 'WORK_ORDER',
  Zip = 'ZIP'
}

export type RosterFilterInput = {
  approverId?: InputMaybe<Scalars['String']['input']>;
  checkInDate?: InputMaybe<DateRangeInput>;
  checkOutDate?: InputMaybe<DateRangeInput>;
  city?: InputMaybe<Array<Scalars['String']['input']>>;
  contactInfo?: InputMaybe<Scalars['String']['input']>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  crew?: InputMaybe<Scalars['String']['input']>;
  customer?: InputMaybe<Scalars['String']['input']>;
  departmentCode?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  doorCode?: InputMaybe<Scalars['String']['input']>;
  duplicateApproved?: InputMaybe<Scalars['Boolean']['input']>;
  edipi?: InputMaybe<Scalars['String']['input']>;
  employeeNumber?: InputMaybe<Scalars['String']['input']>;
  fleetNumber?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  hotelConfirmationNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobNumber?: InputMaybe<Scalars['String']['input']>;
  jobProjectName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  locationBase?: InputMaybe<Scalars['String']['input']>;
  mission?: InputMaybe<Scalars['String']['input']>;
  orderNumber?: InputMaybe<Scalars['String']['input']>;
  orderedBy?: InputMaybe<Scalars['String']['input']>;
  poOrGl?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['String']['input']>;
  roomBeds?: InputMaybe<Scalars['Int']['input']>;
  roommatesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  semiUniqueIdentifier?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<RosterRoomAssignmentStatus>>;
  taskForce?: InputMaybe<Scalars['String']['input']>;
  trfNumber?: InputMaybe<Scalars['String']['input']>;
  unitCode?: InputMaybe<Scalars['String']['input']>;
  well?: InputMaybe<Scalars['String']['input']>;
  workOrder?: InputMaybe<Scalars['String']['input']>;
};

export type RosterRequest = {
  __typename: 'RosterRequest';
  assignedGroup?: Maybe<RosterRequestGroup>;
  client: Client;
  clientAssignedTo?: Maybe<User>;
  controlNumber?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
  files: Array<RosterRequestFile>;
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  proposalId?: Maybe<Scalars['ID']['output']>;
  remarks: Array<RosterRequestRemark>;
  requestData?: Maybe<RosterRequestData>;
  requestType: RosterRequestType;
  requestedBy?: Maybe<User>;
  rosterRoomAssignments?: Maybe<Array<RosterRoomAssignment>>;
  status: RosterRequestStatus;
  thsAssignedTo?: Maybe<User>;
};

export type RosterRequestData = RosterRequestDataDateChange | RosterRequestDataNewGroupReservation | RosterRequestDataNewReservation;

export type RosterRequestDataDateChange = {
  __typename: 'RosterRequestDataDateChange';
  checkInDate?: Maybe<Scalars['String']['output']>;
  checkOutDate?: Maybe<Scalars['String']['output']>;
  requiredFields?: Maybe<Array<RequiredField>>;
};

export type RosterRequestDataDateChangeInput = {
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
};

export type RosterRequestDataNewGroupReservation = {
  __typename: 'RosterRequestDataNewGroupReservation';
  additionalPreferences?: Maybe<Scalars['String']['output']>;
  brandPreference?: Maybe<Scalars['String']['output']>;
  breakfast: AmenityRequirement;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  controlNum?: Maybe<Scalars['String']['output']>;
  distanceFromDestination?: Maybe<Scalars['Int']['output']>;
  double: Array<DoubleRoomOption>;
  freeParking: AmenityRequirement;
  guestQuantity: Scalars['Int']['output'];
  kitchen: AmenityRequirement;
  meetingSpace: AmenityRequirement;
  meetingSpaceRequirements?: Maybe<MeetingSpaceRequirements>;
  otherAmenities?: Maybe<Scalars['String']['output']>;
  quantities: RoomQuantities;
  requiredFields?: Maybe<Array<RequiredField>>;
  roomConfigurations?: Maybe<RoomConfigurations>;
  shortList: Array<ShortListHotel>;
  single: Array<ClientTeamMemberSelectOption>;
  skipGuestList?: Maybe<Scalars['Boolean']['output']>;
  suite: Array<ClientTeamMemberSelectOption>;
  washerDryer: AmenityRequirement;
};

export type RosterRequestDataNewReservation = {
  __typename: 'RosterRequestDataNewReservation';
  controlNumber?: Maybe<Scalars['String']['output']>;
  existingGuests: Array<RosterRequestDataNewReservationClientTeamMember>;
  newGuests: Array<RosterRequestDataNewReservationClientTeamMember>;
  preferredHotelAddress?: Maybe<Scalars['String']['output']>;
  preferredHotelEmail?: Maybe<Scalars['String']['output']>;
  preferredHotelName?: Maybe<Scalars['String']['output']>;
  preferredHotelPhone?: Maybe<Scalars['String']['output']>;
  requiredFields?: Maybe<Array<RequiredField>>;
};

export type RosterRequestDataNewReservationClientTeamMember = {
  __typename: 'RosterRequestDataNewReservationClientTeamMember';
  checkin?: Maybe<Scalars['String']['output']>;
  checkout?: Maybe<Scalars['String']['output']>;
  edipi?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  previousHotelAddress?: Maybe<Scalars['String']['output']>;
  previousHotelName?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['String']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  roomType?: Maybe<Scalars['String']['output']>;
};

export type RosterRequestFile = {
  __typename: 'RosterRequestFile';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayFilename: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rosterRequestId: Scalars['ID']['output'];
};

export enum RosterRequestGroup {
  /** Client */
  Client = 'CLIENT',
  /** J4 Lodging */
  J4Lodging = 'J4_LODGING',
  /** JLOC */
  Jloc = 'JLOC',
  /** Procurement */
  Procurement = 'PROCUREMENT',
  /** THS */
  Ths = 'THS'
}

export type RosterRequestRemark = {
  __typename: 'RosterRequestRemark';
  createdAt: Scalars['String']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  internal: Scalars['Boolean']['output'];
  note: Scalars['String']['output'];
};

export enum RosterRequestStatus {
  /** Awaiting Confirmation */
  AwaitingConfirmation = 'AWAITING_CONFIRMATION',
  /** Canceled */
  Canceled = 'CANCELED',
  /** Cancellation Requested */
  CancellationRequested = 'CANCELLATION_REQUESTED',
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** More Info Required */
  MoreInfoRequired = 'MORE_INFO_REQUIRED',
  /** Over Budget Approval Needed */
  OverPdApprovalNeeded = 'OVER_PD_APPROVAL_NEEDED',
  /** Request Received */
  RequestReceived = 'REQUEST_RECEIVED'
}

export enum RosterRequestType {
  /** Date Change (Early Check-In/Out/Extension) */
  DateChange = 'DATE_CHANGE',
  /** Hotel Transfer */
  HotelTransfer = 'HOTEL_TRANSFER',
  /** New Group Reservation */
  NewGroupReservation = 'NEW_GROUP_RESERVATION',
  /** New Reservation */
  NewReservation = 'NEW_RESERVATION',
  /** Other */
  Other = 'OTHER',
  /** Room Transfer */
  RoomTransfer = 'ROOM_TRANSFER'
}

export type RosterRequestsFilterInput = {
  assignedGroup?: InputMaybe<Scalars['String']['input']>;
  clientAssignedTo?: InputMaybe<Scalars['ID']['input']>;
  controlNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  requestType?: InputMaybe<Array<RosterRequestType>>;
  requestedBy?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<RosterRequestStatus>>;
  thsAssignedTo?: InputMaybe<Scalars['ID']['input']>;
};

export type RosterRequestsPagination = {
  __typename: 'RosterRequestsPagination';
  items: Array<RosterRequest>;
  total: Scalars['Int']['output'];
};

export type RosterRoomAssignment = {
  __typename: 'RosterRoomAssignment';
  bedNumber: Scalars['Int']['output'];
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  duplicateApproval?: Maybe<DuplicateApproval>;
  guest: ClientTeamMember;
  hasDuplicateApproval: Scalars['Boolean']['output'];
  hasRoommates: Scalars['Boolean']['output'];
  hotel: Hotel;
  hotelConfirmationNumber?: Maybe<Scalars['String']['output']>;
  hotelRoomNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ngRate?: Maybe<Scalars['Int']['output']>;
  noShowStatus?: Maybe<NoShowStatus>;
  order: Order;
  quotedRate?: Maybe<Scalars['Int']['output']>;
  requiredFields: Array<RequiredField>;
  reservationNumber?: Maybe<Scalars['String']['output']>;
  roomBeds: Scalars['Int']['output'];
  roommates?: Maybe<Array<ClientTeamMember>>;
  status?: Maybe<RosterRoomAssignmentStatus>;
};

export type RosterRoomAssignmentPagination = {
  __typename: 'RosterRoomAssignmentPagination';
  items: Array<RosterRoomAssignment>;
  total: Scalars['Int']['output'];
};

export enum RosterRoomAssignmentStatus {
  /** In-House */
  InHouse = 'IN_HOUSE',
  /** Past */
  Past = 'PAST',
  /** Upcoming */
  Upcoming = 'UPCOMING'
}

export type RosterSummaryReport = {
  __typename: 'RosterSummaryReport';
  inHouse: Scalars['Int']['output'];
  upcoming: Scalars['Int']['output'];
};

export type SendBookingConfirmationEmailInput = {
  bookingId: Scalars['ID']['input'];
  recipient: Scalars['String']['input'];
};

export type ShortListHotel = {
  __typename: 'ShortListHotel';
  amadeusHotelId: Scalars['String']['output'];
  formattedAddress?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  starRating?: Maybe<Scalars['Int']['output']>;
};

export type ShortListHotelInput = {
  amadeusHotelId: Scalars['String']['input'];
  formattedAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  starRating?: InputMaybe<Scalars['Int']['input']>;
};

export type SortInput = {
  desc: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export enum State {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type ThsPrice = {
  __typename: 'ThsPrice';
  includesTax: Scalars['Boolean']['output'];
  nightlyPrice: Scalars['Int']['output'];
};

export enum TripStatus {
  AwaitingConfirmation = 'AWAITING_CONFIRMATION',
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  InHouse = 'IN_HOUSE',
  InProgress = 'IN_PROGRESS',
  MoreInfoRequired = 'MORE_INFO_REQUIRED',
  Past = 'PAST',
  Pending = 'PENDING',
  RequestReceived = 'REQUEST_RECEIVED',
  Upcoming = 'UPCOMING'
}

export enum TripType {
  GroupRequest = 'GROUP_REQUEST',
  SelfBooking = 'SELF_BOOKING'
}

export type UpdateGroupReservationRequestInput = {
  double: Array<DoubleRoomOptionInput>;
  requiredFields?: InputMaybe<Array<RequiredFieldInput>>;
  roomConfigurations?: InputMaybe<RoomConfigurationsInput>;
  single: Array<ClientTeamMemberSelectOptionInput>;
  suite: Array<ClientTeamMemberSelectOptionInput>;
};

export type UpdateRosterRequestInput = {
  controlNumber?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  requestDataDateChange?: InputMaybe<RosterRequestDataDateChangeInput>;
  requestDataNewReservation?: InputMaybe<NewReservationRequestInput>;
};

export type UploadRosterRequestFileInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional display name for the file (defaults to original filename) */
  displayFilename?: InputMaybe<Scalars['String']['input']>;
  fileType: Scalars['String']['input'];
  originalFilename: Scalars['String']['input'];
  rosterRequestId: Scalars['ID']['input'];
  /** Path to the file in the temporary storage bucket */
  tempFilePath: Scalars['String']['input'];
};

export type User = {
  __typename: 'User';
  blocked: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  picture: Scalars['String']['output'];
  profile?: Maybe<Profile>;
  roles?: Maybe<Array<UserRole>>;
  username: Scalars['String']['output'];
};

export enum UserRole {
  /** Basecamp Admin */
  BasecampAdmin = 'BASECAMP_ADMIN',
  /** Basecamp Client Admin */
  BasecampClientAdmin = 'BASECAMP_CLIENT_ADMIN',
  /** Basecamp Housekeeping */
  BasecampHousekeeping = 'BASECAMP_HOUSEKEEPING',
  /** Basecamp Staff */
  BasecampStaff = 'BASECAMP_STAFF',
  /** Basecamp Technician */
  BasecampTechnician = 'BASECAMP_TECHNICIAN',
  /** Client Admin */
  ClientAdmin = 'CLIENT_ADMIN',
  /** Client Read-Only */
  ClientReadOnly = 'CLIENT_READ_ONLY',
  /** Client Traveler */
  ClientTraveler = 'CLIENT_TRAVELER',
  /** Client User */
  ClientUser = 'CLIENT_USER',
  /** Corporate Housing Admin */
  CorporateHousingAdmin = 'CORPORATE_HOUSING_ADMIN',
  /** Corporate Housing Staff */
  CorporateHousingStaff = 'CORPORATE_HOUSING_STAFF',
  /** Corporate Housing Traveler */
  CorporateHousingTraveler = 'CORPORATE_HOUSING_TRAVELER',
  /** Developer */
  Developer = 'DEVELOPER',
  /** Energy */
  Energy = 'ENERGY',
  /** Government Solutions */
  GovernmentSolutions = 'GOVERNMENT_SOLUTIONS',
  /** Other */
  Other = 'OTHER',
  /** Staff Accounting */
  StaffAccounting = 'STAFF_ACCOUNTING',
  /** Staff Admin */
  StaffAdmin = 'STAFF_ADMIN',
  /** Staff User */
  StaffUser = 'STAFF_USER'
}

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename: '__EnumValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename: '__Field';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename: '__InputValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByURL?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
  isOneOf?: Maybe<Scalars['Boolean']['output']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

export type CancelRosterRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelRosterRequestMutation = { __typename: 'Mutation', cancelRosterRequest: { __typename: 'RosterRequest', id: string, status: RosterRequestStatus } };

export type ChooseProposalOptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  lineItemSelections?: InputMaybe<Array<LineItemSelectionInput> | LineItemSelectionInput>;
}>;


export type ChooseProposalOptionMutation = { __typename: 'Mutation', chooseProposalOption: { __typename: 'Proposal', id: string, preferredProposalOptionId?: string | null } };

export type CloseUnreceivedHotelBookingRequestMutationVariables = Exact<{
  requestKey: Scalars['ID']['input'];
}>;


export type CloseUnreceivedHotelBookingRequestMutation = { __typename: 'Mutation', closeUnreceivedHotelBookingRequest: { __typename: 'HotelBookingRequestCheck', closed: boolean, attempt?: { __typename: 'HotelBookingAttempt', requestKey: string, status: HotelBookingAttemptStatus, failureCode?: string | null, failureMessage?: string | null, recoveryAction?: HotelBookingRecoveryAction | null, bookingId?: string | null, confirmationNumbers: Array<string>, pricingId: string, bookingIntentId: string, replacementPricing?: { __typename: 'HotelBookingPricing', id: string, bookingIntentId: string, fingerprint: string, currency: string, totalBeforeTax: number, totalTax: number, totalAfterTax: number, paymentMethod: string, roomCount: number, guestsPerRoom: number, checkInDate: string, checkOutDate: string, roomDescription: string, terms: Array<string> } | null } | null } };

export type CreateAmadeusBookingMutationVariables = Exact<{
  input: CreateAmadeusBookingClientInput;
}>;


export type CreateAmadeusBookingMutation = { __typename: 'Mutation', createAmadeusBooking: { __typename: 'Booking', id: string, confirmationNumber: string, reservationId: string, createdAt: string, checkInDate: string, checkOutDate: string, grandTotalAfterTax: number, orderNumber: string, avgPrice: number, basePrice: number, estimatedTax: number, nights: number, rooms: number, guestsPerRoom: number, roomBeds: number, roomBedType: string, thsPrice: { __typename: 'ThsPrice', nightlyPrice: number, includesTax: boolean }, cancellationDetails?: { __typename: 'CancellationDetails', deadline?: string | null, description?: string | null, nonRefundable?: boolean | null } | null, bookingHolder: { __typename: 'BookingHolder', firstName?: string | null, lastName?: string | null, email: string, phone: string }, hotel: { __typename: 'AmadeusHotel', name: string, formattedAddress?: string | null, imageUrl?: string | null } | { __typename: 'ManualHotel', name: string, formattedAddress?: string | null }, bookingRooms: Array<{ __typename: 'BookingRoom', id: string, confirmationNumber?: string | null, guests: Array<{ __typename: 'BookingGuest', id: string, firstName: string, lastName: string }> }>, lineItems: Array<{ __typename: 'OrderLineItem', id: string, name: string, description?: string | null, price: number, attributedGuestName?: string | null }>, creditCard?: { __typename: 'CreditCard', id: string, last4: string, expiration: string } | null } };

export type CreateClientTeamMemberMutationVariables = Exact<{
  input: CreateClientTeamMemberInput;
}>;


export type CreateClientTeamMemberMutation = { __typename: 'Mutation', createClientTeamMember: { __typename: 'ClientTeamMember', id: string, firstName: string, lastName: string, edipi?: string | null, rank?: string | null, gender?: Gender | null, semiUniqueIdentifier?: string | null, mission?: string | null, jobTitle?: string | null, taskForce?: string | null, unknownGuest?: boolean | null, employeeNumber?: string | null } };

export type CreateRosterRequestMutationVariables = Exact<{
  input: CreateRosterRequestInput;
}>;


export type CreateRosterRequestMutation = { __typename: 'Mutation', createRosterRequest: { __typename: 'RosterRequest', id: string } };

export type CreateRosterRequestRemarkMutationVariables = Exact<{
  rosterRequestId: Scalars['ID']['input'];
  input: CreateRosterRequestRemarkInput;
}>;


export type CreateRosterRequestRemarkMutation = { __typename: 'Mutation', createRosterRequestRemark: { __typename: 'RosterRequestRemark', id: string } };

export type RemoveHotelSavedCardMutationVariables = Exact<{
  methodId: Scalars['ID']['input'];
}>;


export type RemoveHotelSavedCardMutation = { __typename: 'Mutation', removeHotelSavedCard: { __typename: 'HotelSavedCard', id: string, brand: string, last4: string, expiryMonth: number, expiryYear: number, status: HotelSavedCardStatus, checkedAt: string, isDefault: boolean } };

export type RequestNewGroupReservationMutationVariables = Exact<{
  input: NewGroupReservationRequestInput;
}>;


export type RequestNewGroupReservationMutation = { __typename: 'Mutation', requestNewGroupReservation: { __typename: 'RosterRequest', id: string } };

export type RequestNewReservationMutationVariables = Exact<{
  input: NewReservationRequestInput;
}>;


export type RequestNewReservationMutation = { __typename: 'Mutation', requestNewReservation: { __typename: 'RosterRequest', id: string } };

export type GetClientFileUploadUrlMutationVariables = Exact<{
  input: GetClientFileUploadUrlInput;
}>;


export type GetClientFileUploadUrlMutation = { __typename: 'Mutation', getClientFileUploadUrl: { __typename: 'ClientFileUploadUrlResponse', url: string, path: string } };

export type UploadRosterRequestFileMutationVariables = Exact<{
  input: UploadRosterRequestFileInput;
}>;


export type UploadRosterRequestFileMutation = { __typename: 'Mutation', uploadRosterRequestFile: { __typename: 'RosterRequestFile', id: string, rosterRequestId: string, displayFilename: string, fileType: string, createdAt: string, createdBy: string, description?: string | null } };

export type DeleteRosterRequestFileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRosterRequestFileMutation = { __typename: 'Mutation', deleteRosterRequestFile: boolean };

export type SendBookingConfirmationEmailMutationVariables = Exact<{
  input: SendBookingConfirmationEmailInput;
}>;


export type SendBookingConfirmationEmailMutation = { __typename: 'Mutation', sendBookingConfirmationEmail: boolean };

export type SendRemarkResponseEmailMutationVariables = Exact<{
  input: RemarkResponseInput;
}>;


export type SendRemarkResponseEmailMutation = { __typename: 'Mutation', sendRemarkResponseEmail: boolean };

export type SetDefaultHotelSavedCardMutationVariables = Exact<{
  methodId: Scalars['ID']['input'];
}>;


export type SetDefaultHotelSavedCardMutation = { __typename: 'Mutation', setDefaultHotelSavedCard: { __typename: 'HotelSavedCard', id: string, brand: string, last4: string, expiryMonth: number, expiryYear: number, status: HotelSavedCardStatus, checkedAt: string, isDefault: boolean } };

export type StartHotelCardSetupMutationVariables = Exact<{
  requestKey: Scalars['ID']['input'];
}>;


export type StartHotelCardSetupMutation = { __typename: 'Mutation', startHotelCardSetup: { __typename: 'HotelCardSetup', clientSecret?: string | null } };

export type UpdateGroupReservationRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateGroupReservationRequestInput;
}>;


export type UpdateGroupReservationRequestMutation = { __typename: 'Mutation', updateGroupReservationRequest: { __typename: 'RosterRequest', id: string, requestData?: { __typename: 'RosterRequestDataDateChange' } | { __typename: 'RosterRequestDataNewGroupReservation', requiredFields?: Array<{ __typename: 'RequiredField', name: ReservationRequiredField, value?: string | null }> | null } | { __typename: 'RosterRequestDataNewReservation' } | null } };

export type BookingQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  includeTravelerPayments?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BookingQuery = { __typename: 'Query', booking: { __typename: 'Booking', id: string, confirmationNumber: string, reservationId: string, createdAt: string, checkInDate: string, checkOutDate: string, grandTotalAfterTax: number, orderNumber: string, avgPrice: number, basePrice: number, estimatedTax: number, nights: number, rooms: number, guestsPerRoom: number, roomBeds: number, roomBedType: string, travelerPaymentMethod?: { __typename: 'HotelTravelerPayment', brand: string, last4: string, expiryMonth: number, expiryYear: number, selectedAt: string, status: HotelSavedCardStatus } | null, guestPaymentMethods?: Array<{ __typename: 'HotelGuestPayment', guestId: string, guestName: string, brand: string, last4: string, expiryMonth: number, expiryYear: number, selectedAt: string, status: HotelSavedCardStatus }>, thsPrice: { __typename: 'ThsPrice', nightlyPrice: number, includesTax: boolean }, cancellationDetails?: { __typename: 'CancellationDetails', deadline?: string | null, description?: string | null, nonRefundable?: boolean | null } | null, bookingHolder: { __typename: 'BookingHolder', firstName?: string | null, lastName?: string | null, email: string, phone: string }, hotel: { __typename: 'AmadeusHotel', name: string, formattedAddress?: string | null, imageUrl?: string | null } | { __typename: 'ManualHotel', name: string, formattedAddress?: string | null }, bookingRooms: Array<{ __typename: 'BookingRoom', id: string, confirmationNumber?: string | null, guests: Array<{ __typename: 'BookingGuest', id: string, firstName: string, lastName: string }> }>, lineItems: Array<{ __typename: 'OrderLineItem', id: string, name: string, description?: string | null, price: number, attributedGuestName?: string | null }>, creditCard?: { __typename: 'CreditCard', id: string, last4: string, expiration: string } | null } };

export type CheckForDuplicateChangeRequestsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CheckForDuplicateChangeRequestsQuery = { __typename: 'Query', duplicateRosterChangeRequests: Array<{ __typename: 'RosterRequest', id: string, createdAt: string, requestType: RosterRequestType, status: RosterRequestStatus, requestedBy?: { __typename: 'User', id: string, picture: string, username: string, email: string, profile?: { __typename: 'Profile', firstName?: string | null, lastName?: string | null, id: string } | null } | null }> };

export type CheckForDuplicateNewReservationRequestsQueryVariables = Exact<{
  guestIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CheckForDuplicateNewReservationRequestsQuery = { __typename: 'Query', duplicateRosterNewReservationRequests: Array<{ __typename: 'RosterRequest', id: string, createdAt: string, requestType: RosterRequestType, status: RosterRequestStatus, requestedBy?: { __typename: 'User', id: string, picture: string, username: string, email: string, profile?: { __typename: 'Profile', firstName?: string | null, lastName?: string | null, id: string } | null } | null }> };

export type ClientGroupRequestsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  status?: InputMaybe<TripStatus>;
}>;


export type ClientGroupRequestsQuery = { __typename: 'Query', clientGroupRequests: { __typename: 'ClientGroupRequestsPagination', total: number, hasNextPage: boolean, hasPreviousPage: boolean, items: Array<{ __typename: 'ClientTrip', id: string, tripType: TripType, status: TripStatus, checkInDate: string, checkOutDate: string, guests: number, rooms: number, controlNumber?: string | null, hasUnknownGuests: boolean, createdAt: string, hotels: Array<{ __typename: 'AmadeusHotel', name: string, address: { __typename: 'HotelAddress', city?: string | null, state?: string | null } } | { __typename: 'ManualHotel', name: string, address: { __typename: 'HotelAddress', city?: string | null, state?: string | null } }> }>, statusCounts: { __typename: 'ClientGroupRequestCounts', all: number, requestReceived: number, inProgress: number, moreInfoRequired: number, awaitingConfirmation: number, confirmed: number, canceled: number } } };

export type ClientRequiredFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientRequiredFieldsQuery = { __typename: 'Query', clientRequiredFields: { __typename: 'PodRequiredFields', pod: ClientPod, requiredFields: Array<{ __typename: 'RequiredFieldOptions', value: ReservationRequiredField, label: string }> } };

export type ClientSelfBookingsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  status?: InputMaybe<TripStatus>;
}>;


export type ClientSelfBookingsQuery = { __typename: 'Query', clientSelfBookings: { __typename: 'ClientSelfBookingsPagination', total: number, hasNextPage: boolean, hasPreviousPage: boolean, items: Array<{ __typename: 'ClientTrip', id: string, tripType: TripType, status: TripStatus, checkInDate: string, checkOutDate: string, guests: number, rooms: number, controlNumber?: string | null, hasUnknownGuests: boolean, createdAt: string, hotels: Array<{ __typename: 'AmadeusHotel', name: string, address: { __typename: 'HotelAddress', city?: string | null, state?: string | null } } | { __typename: 'ManualHotel', name: string, address: { __typename: 'HotelAddress', city?: string | null, state?: string | null } }> }>, statusCounts: { __typename: 'ClientSelfBookingCounts', all: number, inHouse: number, upcoming: number, pending: number, past: number } } };

export type DashboardReportQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardReportQuery = { __typename: 'Query', dashboardReport: { __typename: 'DashboardReport', summary?: { __typename: 'RosterSummaryReport', inHouse: number, upcoming: number } | null, cities?: Array<{ __typename: 'RosterCityReport', inHouse: number, upcoming: number, city: string, state: string }> | null, checkins?: { __typename: 'RosterCheckinCheckoutReport', duplicateApprovals: number, checkOuts: number, checkInsWeekly: number, checkIns: number } | null } };

export type FindAssignmentsByGuestAndDateQueryVariables = Exact<{
  guestId: Scalars['ID']['input'];
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
}>;


export type FindAssignmentsByGuestAndDateQuery = { __typename: 'Query', findAssignmentsByGuestAndDate?: Array<{ __typename: 'RosterRoomAssignment', id: string, checkInDate: string, checkOutDate: string, hotelRoomNumber: string, roomBeds: number, hotel: { __typename: 'AmadeusHotel', name: string, address: { __typename: 'HotelAddress', city?: string | null, state?: string | null } } | { __typename: 'ManualHotel', name: string, address: { __typename: 'HotelAddress', city?: string | null, state?: string | null } } }> | null };

export type FlightRosterReportQueryVariables = Exact<{
  filter?: InputMaybe<FlightRosterFilter>;
  sort?: InputMaybe<FlightRosterSort>;
}>;


export type FlightRosterReportQuery = { __typename: 'Query', flightRosterReport: string };

export type FlightRosterFieldsFragment = { __typename: 'FlightRoster', id: string, clientTicketPrice?: number | null, clientTax: number, totalClientCost: number, noShowStatus?: NoShowStatus | null, createdAt: string, updatedAt: string, guest: { __typename: 'ClientTeamMember', id: string, semiUniqueIdentifier?: string | null, firstName: string, lastName: string }, outboundSegments: Array<{ __typename: 'FlightSegment', id: string, airline?: string | null, flightNumber?: string | null, departAirport?: string | null, departAt?: string | null, arriveAirport?: string | null, arriveAt?: string | null, confirmationNumber?: string | null, seat?: string | null, cabinClass?: string | null }>, inboundSegments: Array<{ __typename: 'FlightSegment', id: string, airline?: string | null, flightNumber?: string | null, departAirport?: string | null, departAt?: string | null, arriveAirport?: string | null, arriveAt?: string | null, confirmationNumber?: string | null, seat?: string | null, cabinClass?: string | null }>, chargeLineItems: Array<{ __typename: 'FlightLineItem', id: string, name: string, description?: string | null, clientPrice?: number | null }>, requiredFieldValues: Array<{ __typename: 'FlightRosterRequiredFieldValue', name: ReservationRequiredField, label: string, value: string }> };

export type FlightRostersQueryVariables = Exact<{
  filter?: InputMaybe<FlightRosterFilter>;
  sort?: InputMaybe<FlightRosterSort>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FlightRostersQuery = { __typename: 'Query', flightRosters: { __typename: 'FlightRosterPagination', total: number, items: Array<{ __typename: 'FlightRoster', id: string, clientTicketPrice?: number | null, clientTax: number, totalClientCost: number, noShowStatus?: NoShowStatus | null, createdAt: string, updatedAt: string, guest: { __typename: 'ClientTeamMember', id: string, semiUniqueIdentifier?: string | null, firstName: string, lastName: string }, outboundSegments: Array<{ __typename: 'FlightSegment', id: string, airline?: string | null, flightNumber?: string | null, departAirport?: string | null, departAt?: string | null, arriveAirport?: string | null, arriveAt?: string | null, confirmationNumber?: string | null, seat?: string | null, cabinClass?: string | null }>, inboundSegments: Array<{ __typename: 'FlightSegment', id: string, airline?: string | null, flightNumber?: string | null, departAirport?: string | null, departAt?: string | null, arriveAirport?: string | null, arriveAt?: string | null, confirmationNumber?: string | null, seat?: string | null, cabinClass?: string | null }>, chargeLineItems: Array<{ __typename: 'FlightLineItem', id: string, name: string, description?: string | null, clientPrice?: number | null }>, requiredFieldValues: Array<{ __typename: 'FlightRosterRequiredFieldValue', name: ReservationRequiredField, label: string, value: string }> }> } };

export type HotelBookingAttemptsQueryVariables = Exact<{
  requestKey?: InputMaybe<Scalars['ID']['input']>;
  bookingIntentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type HotelBookingAttemptsQuery = { __typename: 'Query', hotelBookingAttempts: Array<{ __typename: 'HotelBookingAttempt', requestKey: string, status: HotelBookingAttemptStatus, failureCode?: string | null, failureMessage?: string | null, recoveryAction?: HotelBookingRecoveryAction | null, bookingId?: string | null, confirmationNumbers: Array<string>, pricingId: string, bookingIntentId: string, replacementPricing?: { __typename: 'HotelBookingPricing', id: string, bookingIntentId: string, fingerprint: string, currency: string, totalBeforeTax: number, totalTax: number, totalAfterTax: number, paymentMethod: string, roomCount: number, guestsPerRoom: number, checkInDate: string, checkOutDate: string, roomDescription: string, terms: Array<string> } | null }> };

export type HotelBootstrapQueryVariables = Exact<{ [key: string]: never; }>;


export type HotelBootstrapQuery = { __typename: 'Query', clientSubgroups: Array<string>, noShowStatusTypes?: { __typename: '__Type', name?: string | null, enumValues?: Array<{ __typename: '__EnumValue', name: string, description?: string | null }> | null } | null, rosterRoomAssignmentStatuses?: { __typename: '__Type', name?: string | null, enumValues?: Array<{ __typename: '__EnumValue', name: string, description?: string | null }> | null } | null, states?: { __typename: '__Type', name?: string | null, enumValues?: Array<{ __typename: '__EnumValue', name: string }> | null } | null, genders?: { __typename: '__Type', name?: string | null, enumValues?: Array<{ __typename: '__EnumValue', name: string, description?: string | null }> | null } | null, rosterRequestType?: { __typename: '__Type', name?: string | null, enumValues?: Array<{ __typename: '__EnumValue', name: string, description?: string | null }> | null } | null, rosterRequestGroups?: { __typename: '__Type', name?: string | null, enumValues?: Array<{ __typename: '__EnumValue', name: string, description?: string | null }> | null } | null, rosterRequestStatus?: { __typename: '__Type', name?: string | null, enumValues?: Array<{ __typename: '__EnumValue', name: string, description?: string | null }> | null } | null, amenities?: { __typename: '__Type', name?: string | null, enumValues?: Array<{ __typename: '__EnumValue', name: string, description?: string | null }> | null } | null, unknownGuest?: { __typename: 'ClientTeamMember', id: string, firstName: string, lastName: string, semiUniqueIdentifier?: string | null, rank?: string | null, gender?: Gender | null, edipi?: string | null, unknownGuest?: boolean | null, mission?: string | null, taskForce?: string | null, employeeNumber?: string | null, jobTitle?: string | null } | null, clientRequiredFields: { __typename: 'PodRequiredFields', pod: ClientPod, requiredFields: Array<{ __typename: 'RequiredFieldOptions', value: ReservationRequiredField, label: string, readOnly: boolean, scope: RequiredFieldScope }> } };

export type HotelChainGroupFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type HotelChainGroupFiltersQuery = { __typename: 'Query', hotelChainGroups: Array<{ __typename: 'HotelChainGroup', code: string, name: string }> };

export type HotelMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type HotelMembershipsQuery = { __typename: 'Query', hotelMemberships: Array<{ __typename: 'HotelClientMembership', clientId: string, clientName: string, isInactive: boolean, roles: Array<UserRole>, status: string, clientTeamMemberId?: string | null, version: number }> };

export type HotelOfferDetailsWithSessionQueryVariables = Exact<{
  amadeusHotelId: Scalars['ID']['input'];
  bookingCode: Scalars['String']['input'];
  roomBedType: Scalars['String']['input'];
  roomBeds: Scalars['Int']['input'];
  roomTypeCode: Scalars['String']['input'];
  checkInDate: Scalars['String']['input'];
  checkOutDate: Scalars['String']['input'];
  roomQuantity?: InputMaybe<Scalars['Int']['input']>;
  guestQuantity?: InputMaybe<Scalars['Int']['input']>;
  bookingIntentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type HotelOfferDetailsWithSessionQuery = { __typename: 'Query', hotelOfferDetailsWithSession: { __typename: 'HotelOfferDetails', pricing: { __typename: 'PricingResponse', grandTotalTax: number, grandTotalBeforeTax: number, grandTotalAfterTax: number, bookingCode: string, bookingPricing?: { __typename: 'HotelBookingPricing', id: string, bookingIntentId: string, fingerprint: string, currency: string, totalBeforeTax: number, totalTax: number, totalAfterTax: number, paymentMethod: string, roomCount: number, guestsPerRoom: number, checkInDate: string, checkOutDate: string, roomDescription: string, terms: Array<string> } | null, rateChanges: Array<{ __typename: 'RateChange', rate: number, effectiveDate: string, expiryDate: string, pretax: boolean }> }, offer: { __typename: 'HotelOffer', amadeusHotelId: string, bookingCode: string, roomTypeCode: string, rateCode: string, rateCodeCategory?: string | null, roomBeds: number, roomBedType: string, avgPrice: number, basePrice: number, totalPrice: number, estimatedTax: number, paymentMethod: string, description?: string | null, nights: number, checkInDate: string, checkOutDate: string, rooms: number, guestsPerRoom: number, cancellationDetails?: { __typename: 'CancellationDetails', deadline?: string | null, nonRefundable?: boolean | null, description?: string | null } | null, thsPrice: { __typename: 'ThsPrice', nightlyPrice: number, includesTax: boolean } } } };

export type HotelTravelerCardPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type HotelTravelerCardPolicyQuery = { __typename: 'Query', hotelTravelerCardPolicy: { __typename: 'HotelTravelerCardPolicy', required: boolean } };

export type MyHotelSavedCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyHotelSavedCardsQuery = { __typename: 'Query', myHotelSavedCards: { __typename: 'HotelSavedCards', configured: boolean, methods: Array<{ __typename: 'HotelSavedCard', id: string, brand: string, last4: string, expiryMonth: number, expiryYear: number, status: HotelSavedCardStatus, checkedAt: string, isDefault: boolean }> } };

export type HotelCheckoutPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type HotelCheckoutPaymentMethodsQuery = { __typename: 'Query', hotelTravelerCardPolicy: { __typename: 'HotelTravelerCardPolicy', required: boolean }, myHotelSavedCards: { __typename: 'HotelSavedCards', configured: boolean, methods: Array<{ __typename: 'HotelSavedCard', id: string, brand: string, last4: string, expiryMonth: number, expiryYear: number, status: HotelSavedCardStatus, checkedAt: string, isDefault: boolean }> } };

export type HotelSearchQueryVariables = Exact<{
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  radius?: InputMaybe<Scalars['Int']['input']>;
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
  roomQuantity?: InputMaybe<Scalars['Int']['input']>;
  guestQuantity?: InputMaybe<Scalars['Int']['input']>;
  moreIndicator?: InputMaybe<Scalars['String']['input']>;
  accessibleRoomsOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HotelSearchQuery = { __typename: 'Query', hotelSearch: { __typename: 'HotelSearchResponse', moreIndicator?: string | null, results: Array<{ __typename: 'HotelSearchResult', hotel: { __typename: 'AmadeusHotel', distributor: HotelDistributor, amadeusHotelId: string, id?: string | null, name: string, formattedAddress?: string | null, latitude: number, longitude: number, amenities: Array<Amenity>, adaAccessibilityFeatures: Array<string>, description?: string | null, starRating: number, imageUrl?: string | null, checkInTime?: string | null, checkOutTime?: string | null, doNotBook: boolean, hotelChainGroup?: { __typename: 'HotelChainGroup', code: string } | null, address: { __typename: 'HotelAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null }, images?: Array<{ __typename: 'HotelImage', url: string, description?: string | null }> | null }, offers: Array<{ __typename: 'HotelOffer', bookingCode: string, roomTypeCode: string, rateCode: string, rateCodeCategory?: string | null, roomBeds: number, roomBedType: string, avgPrice: number, basePrice: number, totalPrice: number, estimatedTax: number, paymentMethod: string, description?: string | null, nights: number, checkInDate: string, checkOutDate: string, rooms: number, guestsPerRoom: number, cancellationDetails?: { __typename: 'CancellationDetails', deadline?: string | null, nonRefundable?: boolean | null, description?: string | null } | null, thsPrice: { __typename: 'ThsPrice', nightlyPrice: number, includesTax: boolean } }> }> } };

export type HotelSearchSingleQueryVariables = Exact<{
  amadeusHotelId: Scalars['ID']['input'];
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
  roomQuantity?: InputMaybe<Scalars['Int']['input']>;
  guestQuantity?: InputMaybe<Scalars['Int']['input']>;
  accessibleRoomsOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HotelSearchSingleQuery = { __typename: 'Query', hotelSearchSingle: { __typename: 'HotelSearchSingleResult', hotel: { __typename: 'AmadeusHotel', distributor: HotelDistributor, amadeusHotelId: string, id?: string | null, name: string, formattedAddress?: string | null, latitude: number, longitude: number, amenities: Array<Amenity>, adaAccessibilityFeatures: Array<string>, phone?: string | null, email?: string | null, description?: string | null, starRating: number, checkInTime?: string | null, checkOutTime?: string | null, doNotBook: boolean, address: { __typename: 'HotelAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null }, images?: Array<{ __typename: 'HotelImage', url: string, description?: string | null }> | null, negotiatedRates: Array<{ __typename: 'NegotiatedRates', single?: string | null, double?: string | null, singleCents?: number | null, doubleCents?: number | null, effectiveStartDate?: string | null, effectiveEndDate?: string | null, isActive: boolean, usage?: string | null, singlePricing?: { __typename: 'NegotiatedOccupancyPricing', pricingMode: NegotiatedPricingMode, selectedTierIndex?: number | null } | null, doublePricing?: { __typename: 'NegotiatedOccupancyPricing', pricingMode: NegotiatedPricingMode, selectedTierIndex?: number | null } | null }> }, offers: Array<{ __typename: 'HotelOffer', bookingCode: string, roomTypeCode: string, rateCode: string, rateCodeCategory?: string | null, roomBeds: number, roomBedType: string, avgPrice: number, basePrice: number, totalPrice: number, estimatedTax: number, paymentMethod: string, description?: string | null, nights: number, checkInDate: string, checkOutDate: string, rooms: number, guestsPerRoom: number, cancellationDetails?: { __typename: 'CancellationDetails', deadline?: string | null, nonRefundable?: boolean | null, description?: string | null } | null, thsPrice: { __typename: 'ThsPrice', nightlyPrice: number, includesTax: boolean } }> } };

export type InitializeQueryVariables = Exact<{ [key: string]: never; }>;


export type InitializeQuery = { __typename: 'Query', clientUser: { __typename: 'User', id: string, username: string, email: string, picture: string, roles?: Array<UserRole> | null, profile?: { __typename: 'Profile', clientId?: string | null, clientTeamMemberId?: string | null, firstName?: string | null, id: string, lastName?: string | null, client?: { __typename: 'Client', id: string, thsPod?: ClientPod | null, isInactive: boolean, clientPortalTravelerSelfBookingEnabled: boolean, clientPortalFlightRosterEnabled: boolean } | null } | null }, featureFlags: { __typename: 'FeatureFlags', revision: string, flags: Array<{ __typename: 'EvaluatedFeatureFlag', key: string, enabled: boolean }> } };

export type PortalTermsVersionFieldsFragment = { __typename: 'PortalTermsVersion', id: string, versionNumber: number, title: string, content: string, changeSummary: string, requiresAcceptance: boolean, publishedAt: string };

export type PublicHotelPortalTermsQueryVariables = Exact<{
  versionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PublicHotelPortalTermsQuery = { __typename: 'Query', publicHotelPortalTerms?: { __typename: 'PortalTermsVersion', id: string, versionNumber: number, title: string, content: string, changeSummary: string, requiresAcceptance: boolean, publishedAt: string } | null };

export type MyHotelPortalTermsStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MyHotelPortalTermsStatusQuery = { __typename: 'Query', myHotelPortalTermsStatus: { __typename: 'PortalTermsStatus', requiresAcceptance: boolean, published?: { __typename: 'PortalTermsVersion', id: string, versionNumber: number, title: string, content: string, changeSummary: string, requiresAcceptance: boolean, publishedAt: string } | null } };

export type AcceptHotelPortalTermsMutationVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type AcceptHotelPortalTermsMutation = { __typename: 'Mutation', acceptHotelPortalTerms: { __typename: 'PortalTermsStatus', requiresAcceptance: boolean, published?: { __typename: 'PortalTermsVersion', id: string, versionNumber: number, title: string, content: string, changeSummary: string, requiresAcceptance: boolean, publishedAt: string } | null } };

export type ProposalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProposalQuery = { __typename: 'Query', proposal: { __typename: 'Proposal', id: string, preferredProposalOptionId?: string | null, requestData: { __typename: 'RosterRequestDataNewGroupReservation', breakfast: AmenityRequirement, freeParking: AmenityRequirement, kitchen: AmenityRequirement, washerDryer: AmenityRequirement, meetingSpace: AmenityRequirement, otherAmenities?: string | null, distanceFromDestination?: number | null, brandPreference?: string | null, contactEmail?: string | null, contactPhone?: string | null, controlNum?: string | null, skipGuestList?: boolean | null, additionalPreferences?: string | null, checkInDate: string, checkOutDate: string, guestQuantity: number, meetingSpaceRequirements?: { __typename: 'MeetingSpaceRequirements', squareFootage: string, avRequirements: string, setupDetails?: string | null } | null, shortList: Array<{ __typename: 'ShortListHotel', amadeusHotelId: string, id?: string | null, formattedAddress?: string | null, imageUrl?: string | null, name: string, starRating?: number | null }>, quantities: { __typename: 'RoomQuantities', single: number, double: number, suite: number }, single: Array<{ __typename: 'ClientTeamMemberSelectOption', id?: string | null, firstName: string, gender?: Gender | null, lastName: string, rank?: string | null, edipi?: string | null, semiUniqueIdentifier?: string | null }>, suite: Array<{ __typename: 'ClientTeamMemberSelectOption', id?: string | null, firstName: string, gender?: Gender | null, lastName: string, rank?: string | null, edipi?: string | null, semiUniqueIdentifier?: string | null }>, double: Array<{ __typename: 'DoubleRoomOption', firstBed: { __typename: 'ClientTeamMemberSelectOption', id?: string | null, firstName: string, gender?: Gender | null, lastName: string, rank?: string | null, edipi?: string | null, semiUniqueIdentifier?: string | null }, secondBed?: { __typename: 'ClientTeamMemberSelectOption', id?: string | null, firstName: string, gender?: Gender | null, lastName: string, rank?: string | null, edipi?: string | null, semiUniqueIdentifier?: string | null } | null }> }, proposalOptions: Array<{ __typename: 'ProposalOption', id: string, totalRooms: number, totalPrice: number, hotels: Array<{ __typename: 'ProposalOptionHotel', id: string, hotelId: string, hotel: { __typename: 'AmadeusHotel', name: string, formattedAddress?: string | null } | { __typename: 'ManualHotel', name: string, formattedAddress?: string | null }, single?: { __typename: 'ProposalRoom', roomBedType?: string | null, roomAmount?: number | null, avgPrice?: number | null, cancellationDeadline?: string | null } | null, double?: { __typename: 'ProposalRoom', roomBedType?: string | null, roomAmount?: number | null, avgPrice?: number | null, cancellationDeadline?: string | null } | null, suite?: { __typename: 'ProposalRoom', roomBedType?: string | null, roomAmount?: number | null, avgPrice?: number | null, cancellationDeadline?: string | null } | null, lineItems: Array<{ __typename: 'ProposalOptionHotelLineItem', id: string, name: string, description?: string | null, price: number, selected: boolean }> }> }> } };

export type RosterListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<RosterFilterInput>;
  sort?: InputMaybe<SortInput>;
}>;


export type RosterListQuery = { __typename: 'Query', roster: { __typename: 'RosterRoomAssignmentPagination', total: number, items: Array<{ __typename: 'RosterRoomAssignment', checkInDate: string, checkOutDate: string, id: string, status?: RosterRoomAssignmentStatus | null, noShowStatus?: NoShowStatus | null, hotelRoomNumber: string, hotelConfirmationNumber?: string | null, bedNumber: number, roomBeds: number, ngRate?: number | null, quotedRate?: number | null, hasDuplicateApproval: boolean, guest: { __typename: 'ClientTeamMember', edipi?: string | null, semiUniqueIdentifier?: string | null, firstName: string, id: string, lastName: string, gender?: Gender | null, rank?: string | null, mission?: string | null, taskForce?: string | null }, order: { __typename: 'Order', orderNumber?: string | null }, hotel: { __typename: 'AmadeusHotel', name: string, address: { __typename: 'HotelAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null } } | { __typename: 'ManualHotel', name: string, address: { __typename: 'HotelAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null } }, duplicateApproval?: { __typename: 'DuplicateApprovalAuthorized', id: string, createdAt: string, approver?: { __typename: 'ClientTeamMember', id: string, firstName: string, lastName: string, rank?: string | null, edipi?: string | null } | null } | { __typename: 'DuplicateApprovalBlanket', id: string, createdAt: string } | null, requiredFields: Array<{ __typename: 'RequiredField', name: ReservationRequiredField, value?: string | null }>, roommates?: Array<{ __typename: 'ClientTeamMember', id: string, firstName: string, lastName: string, semiUniqueIdentifier?: string | null }> | null }> } };

export type RosterFindGuestByEdipiQueryVariables = Exact<{
  edipi?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
}>;


export type RosterFindGuestByEdipiQuery = { __typename: 'Query', clientTeamMembers: Array<{ __typename: 'ClientTeamMember', id: string, firstName: string, lastName: string, edipi?: string | null, semiUniqueIdentifier?: string | null, rank?: string | null, gender?: Gender | null, mission?: string | null, taskForce?: string | null, unknownGuest?: boolean | null }> };

export type RosterItemsForRequestQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RosterItemsForRequestQuery = { __typename: 'Query', rosterItems: Array<{ __typename: 'RosterRoomAssignment', id: string, checkInDate: string, checkOutDate: string, guest: { __typename: 'ClientTeamMember', id: string, firstName: string, lastName: string, semiUniqueIdentifier?: string | null }, hotel: { __typename: 'AmadeusHotel', name: string, databaseId?: string | null } | { __typename: 'ManualHotel', id: string, name: string }, requiredFields: Array<{ __typename: 'RequiredField', name: ReservationRequiredField, value?: string | null }> }> };

export type RosterReportQueryVariables = Exact<{
  filter?: InputMaybe<RosterFilterInput>;
  sort?: InputMaybe<SortInput>;
}>;


export type RosterReportQuery = { __typename: 'Query', rosterReport: string };

export type RosterRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RosterRequestQuery = { __typename: 'Query', rosterRequest: { __typename: 'RosterRequest', details?: string | null, controlNumber?: string | null, id: string, proposalId?: string | null, status: RosterRequestStatus, requestType: RosterRequestType, createdAt: string, files: Array<{ __typename: 'RosterRequestFile', id: string, rosterRequestId: string, displayFilename: string, fileType: string, createdAt: string, createdBy: string, description?: string | null }>, order?: { __typename: 'Order', id: string, reservations: Array<{ __typename: 'Reservation', id: string, orderId: string, reservationNumber: number, checkInDate: string, checkOutDate: string, rooms: number, guestsPerRoom: number, nights: number, notes?: string | null, booking?: { __typename: 'Booking', id: string, confirmationNumber: string, reservationId: string, orderNumber: string, createdAt: string, amadeusPnrNumber?: string | null, amadeusCreatedAt?: string | null, roomBeds: number, rooms: number, roomBedType: string, avgPrice: number, totalPrice: number, estimatedTax: number, basePrice: number, grandTotalAfterTax: number, nights: number, checkInDate: string, checkOutDate: string, guestsPerRoom: number, hotel: { __typename: 'AmadeusHotel', name: string, formattedAddress?: string | null, phone?: string | null, email?: string | null, imageUrl?: string | null, amadeusId?: string | null, address: { __typename: 'HotelAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null } } | { __typename: 'ManualHotel', name: string, formattedAddress?: string | null, phone?: string | null, email?: string | null, manualId: string, address: { __typename: 'HotelAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zip?: string | null } }, cancellationDetails?: { __typename: 'CancellationDetails', deadline?: string | null, nonRefundable?: boolean | null, description?: string | null } | null, thsPrice: { __typename: 'ThsPrice', nightlyPrice: number, includesTax: boolean }, lineItems: Array<{ __typename: 'OrderLineItem', id: string, name: string, description?: string | null, price: number }>, bookingHolder: { __typename: 'BookingHolder', email: string, phone: string, firstName?: string | null, lastName?: string | null }, bookingRooms: Array<{ __typename: 'BookingRoom', id: string, confirmationNumber?: string | null, guests: Array<{ __typename: 'BookingGuest', id: string, firstName: string, lastName: string }> }> } | null }> } | null, rosterRoomAssignments?: Array<{ __typename: 'RosterRoomAssignment', id: string, checkOutDate: string, checkInDate: string, hotel: { __typename: 'AmadeusHotel', name: string, databaseId?: string | null, address: { __typename: 'HotelAddress', city?: string | null, state?: string | null } } | { __typename: 'ManualHotel', id: string, name: string, address: { __typename: 'HotelAddress', city?: string | null, state?: string | null } }, guest: { __typename: 'ClientTeamMember', id: string, firstName: string, lastName: string, semiUniqueIdentifier?: string | null }, requiredFields: Array<{ __typename: 'RequiredField', name: ReservationRequiredField, value?: string | null }> }> | null, client: { __typename: 'Client', id: string }, requestedBy?: { __typename: 'User', id: string, picture: string, username: string, email: string, group?: string | null, profile?: { __typename: 'Profile', firstName?: string | null, lastName?: string | null, id: string } | null } | null, remarks: Array<{ __typename: 'RosterRequestRemark', id: string, note: string, internal: boolean, createdAt: string, createdBy: { __typename: 'User', picture: string, email: string, username: string, profile?: { __typename: 'Profile', firstName?: string | null, lastName?: string | null, id: string } | null } }>, requestData?: { __typename: 'RosterRequestDataDateChange', checkOutDate?: string | null, checkInDate?: string | null } | { __typename: 'RosterRequestDataNewGroupReservation', breakfast: AmenityRequirement, freeParking: AmenityRequirement, kitchen: AmenityRequirement, washerDryer: AmenityRequirement, meetingSpace: AmenityRequirement, otherAmenities?: string | null, distanceFromDestination?: number | null, brandPreference?: string | null, contactEmail?: string | null, contactPhone?: string | null, controlNum?: string | null, skipGuestList?: boolean | null, guestQuantity: number, groupCheckInDate: string, groupCheckOutDate: string, meetingSpaceRequirements?: { __typename: 'MeetingSpaceRequirements', squareFootage: string, avRequirements: string, setupDetails?: string | null } | null, requiredFields?: Array<{ __typename: 'RequiredField', name: ReservationRequiredField, value?: string | null }> | null, shortList: Array<{ __typename: 'ShortListHotel', amadeusHotelId: string, id?: string | null, formattedAddress?: string | null, imageUrl?: string | null, name: string, starRating?: number | null }>, quantities: { __typename: 'RoomQuantities', single: number, double: number, suite: number }, roomConfigurations?: { __typename: 'RoomConfigurations', single: Array<{ __typename: 'RoomConfiguration', rooms: number, guests: number }>, double: Array<{ __typename: 'RoomConfiguration', rooms: number, guests: number }>, suite: Array<{ __typename: 'RoomConfiguration', rooms: number, guests: number }> } | null, single: Array<{ __typename: 'ClientTeamMemberSelectOption', id?: string | null, firstName: string, gender?: Gender | null, lastName: string, rank?: string | null, edipi?: string | null, semiUniqueIdentifier?: string | null }>, suite: Array<{ __typename: 'ClientTeamMemberSelectOption', id?: string | null, firstName: string, gender?: Gender | null, lastName: string, rank?: string | null, edipi?: string | null, semiUniqueIdentifier?: string | null }>, double: Array<{ __typename: 'DoubleRoomOption', firstBed: { __typename: 'ClientTeamMemberSelectOption', id?: string | null, firstName: string, gender?: Gender | null, lastName: string, rank?: string | null, edipi?: string | null, semiUniqueIdentifier?: string | null }, secondBed?: { __typename: 'ClientTeamMemberSelectOption', id?: string | null, firstName: string, gender?: Gender | null, lastName: string, rank?: string | null, edipi?: string | null, semiUniqueIdentifier?: string | null } | null }> } | { __typename: 'RosterRequestDataNewReservation', preferredHotelPhone?: string | null, preferredHotelName?: string | null, preferredHotelEmail?: string | null, preferredHotelAddress?: string | null, requiredFields?: Array<{ __typename: 'RequiredField', name: ReservationRequiredField, value?: string | null }> | null, newGuests: Array<{ __typename: 'RosterRequestDataNewReservationClientTeamMember', checkin?: string | null, checkout?: string | null, edipi?: string | null, firstName?: string | null, gender?: string | null, id?: string | null, lastName?: string | null, previousHotelAddress?: string | null, previousHotelName?: string | null, rank?: string | null, remarks?: string | null, roomType?: string | null }>, existingGuests: Array<{ __typename: 'RosterRequestDataNewReservationClientTeamMember', checkin?: string | null, checkout?: string | null, edipi?: string | null, firstName?: string | null, gender?: string | null, id?: string | null, lastName?: string | null, previousHotelAddress?: string | null, previousHotelName?: string | null, rank?: string | null, remarks?: string | null, roomType?: string | null }> } | null } };

export type RosterRequestFileUrlQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RosterRequestFileUrlQuery = { __typename: 'Query', rosterRequestFileUrl: string };

export type RosterRequestsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<SortInput>;
  filter?: InputMaybe<RosterRequestsFilterInput>;
}>;


export type RosterRequestsQuery = { __typename: 'Query', rosterRequests: { __typename: 'RosterRequestsPagination', total: number, items: Array<{ __typename: 'RosterRequest', id: string, createdAt: string, details?: string | null, requestType: RosterRequestType, status: RosterRequestStatus, assignedGroup?: RosterRequestGroup | null, controlNumber?: string | null, requestedBy?: { __typename: 'User', id: string, picture: string, username: string, profile?: { __typename: 'Profile', firstName?: string | null, lastName?: string | null, id: string } | null } | null }> } };

export type SavedHotelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SavedHotelQuery = { __typename: 'Query', savedHotel: { __typename: 'AmadeusHotel', amadeusHotelId: string, name: string, chainCode?: string | null, chainName?: string | null, doNotBook: boolean, formattedAddress?: string | null, email?: string | null, phone?: string | null, amenities: Array<Amenity>, imageUrl?: string | null, verified?: boolean | null, databaseId?: string | null, hotelChainGroup?: { __typename: 'HotelChainGroup', name: string } | null } | { __typename: 'ManualHotel', id: string, name: string, chainCode?: string | null, chainName?: string | null, doNotBook: boolean, formattedAddress?: string | null, email?: string | null, phone?: string | null, amenities: Array<Amenity>, hotelChainGroup?: { __typename: 'HotelChainGroup', name: string } | null } };

export type UsersWithProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersWithProfileQuery = { __typename: 'Query', users: Array<{ __typename: 'User', id: string, username: string, email: string, picture: string, blocked: boolean, roles?: Array<UserRole> | null, profile?: { __typename: 'Profile', id: string, firstName?: string | null, lastName?: string | null, client?: { __typename: 'Client', id: string } | null } | null }> };

export const FlightRosterFieldsFragmentDoc = gql`
    fragment FlightRosterFields on FlightRoster {
  id
  guest {
    id
    semiUniqueIdentifier
    firstName
    lastName
  }
  outboundSegments {
    id
    airline
    flightNumber
    departAirport
    departAt
    arriveAirport
    arriveAt
    confirmationNumber
    seat
    cabinClass
  }
  inboundSegments {
    id
    airline
    flightNumber
    departAirport
    departAt
    arriveAirport
    arriveAt
    confirmationNumber
    seat
    cabinClass
  }
  clientTicketPrice
  clientTax
  totalClientCost
  noShowStatus
  chargeLineItems {
    id
    name
    description
    clientPrice
  }
  requiredFieldValues {
    name
    label
    value
  }
  createdAt
  updatedAt
}
    `;
export const PortalTermsVersionFieldsFragmentDoc = gql`
    fragment PortalTermsVersionFields on PortalTermsVersion {
  id
  versionNumber
  title
  content
  changeSummary
  requiresAcceptance
  publishedAt
}
    `;
export const CancelRosterRequestDocument = gql`
    mutation cancelRosterRequest($id: ID!) {
  cancelRosterRequest(id: $id) {
    id
    status
  }
}
    `;
export type CancelRosterRequestMutationFn = Apollo.MutationFunction<CancelRosterRequestMutation, CancelRosterRequestMutationVariables>;

/**
 * __useCancelRosterRequestMutation__
 *
 * To run a mutation, you first call `useCancelRosterRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelRosterRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelRosterRequestMutation, { data, loading, error }] = useCancelRosterRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelRosterRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelRosterRequestMutation, CancelRosterRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelRosterRequestMutation, CancelRosterRequestMutationVariables>(CancelRosterRequestDocument, options);
      }
export type CancelRosterRequestMutationHookResult = ReturnType<typeof useCancelRosterRequestMutation>;
export type CancelRosterRequestMutationResult = Apollo.MutationResult<CancelRosterRequestMutation>;
export type CancelRosterRequestMutationOptions = Apollo.BaseMutationOptions<CancelRosterRequestMutation, CancelRosterRequestMutationVariables>;
export const ChooseProposalOptionDocument = gql`
    mutation chooseProposalOption($id: ID!, $lineItemSelections: [LineItemSelectionInput!]) {
  chooseProposalOption(id: $id, lineItemSelections: $lineItemSelections) {
    id
    preferredProposalOptionId
  }
}
    `;
export type ChooseProposalOptionMutationFn = Apollo.MutationFunction<ChooseProposalOptionMutation, ChooseProposalOptionMutationVariables>;

/**
 * __useChooseProposalOptionMutation__
 *
 * To run a mutation, you first call `useChooseProposalOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseProposalOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseProposalOptionMutation, { data, loading, error }] = useChooseProposalOptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      lineItemSelections: // value for 'lineItemSelections'
 *   },
 * });
 */
export function useChooseProposalOptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChooseProposalOptionMutation, ChooseProposalOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChooseProposalOptionMutation, ChooseProposalOptionMutationVariables>(ChooseProposalOptionDocument, options);
      }
export type ChooseProposalOptionMutationHookResult = ReturnType<typeof useChooseProposalOptionMutation>;
export type ChooseProposalOptionMutationResult = Apollo.MutationResult<ChooseProposalOptionMutation>;
export type ChooseProposalOptionMutationOptions = Apollo.BaseMutationOptions<ChooseProposalOptionMutation, ChooseProposalOptionMutationVariables>;
export const CloseUnreceivedHotelBookingRequestDocument = gql`
    mutation closeUnreceivedHotelBookingRequest($requestKey: ID!) {
  closeUnreceivedHotelBookingRequest(requestKey: $requestKey) {
    closed
    attempt {
      requestKey
      status
      failureCode
      failureMessage
      recoveryAction
      bookingId
      confirmationNumbers
      pricingId
      bookingIntentId
      replacementPricing {
        id
        bookingIntentId
        fingerprint
        currency
        totalBeforeTax
        totalTax
        totalAfterTax
        paymentMethod
        roomCount
        guestsPerRoom
        checkInDate
        checkOutDate
        roomDescription
        terms
      }
    }
  }
}
    `;
export type CloseUnreceivedHotelBookingRequestMutationFn = Apollo.MutationFunction<CloseUnreceivedHotelBookingRequestMutation, CloseUnreceivedHotelBookingRequestMutationVariables>;

/**
 * __useCloseUnreceivedHotelBookingRequestMutation__
 *
 * To run a mutation, you first call `useCloseUnreceivedHotelBookingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseUnreceivedHotelBookingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeUnreceivedHotelBookingRequestMutation, { data, loading, error }] = useCloseUnreceivedHotelBookingRequestMutation({
 *   variables: {
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useCloseUnreceivedHotelBookingRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CloseUnreceivedHotelBookingRequestMutation, CloseUnreceivedHotelBookingRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CloseUnreceivedHotelBookingRequestMutation, CloseUnreceivedHotelBookingRequestMutationVariables>(CloseUnreceivedHotelBookingRequestDocument, options);
      }
export type CloseUnreceivedHotelBookingRequestMutationHookResult = ReturnType<typeof useCloseUnreceivedHotelBookingRequestMutation>;
export type CloseUnreceivedHotelBookingRequestMutationResult = Apollo.MutationResult<CloseUnreceivedHotelBookingRequestMutation>;
export type CloseUnreceivedHotelBookingRequestMutationOptions = Apollo.BaseMutationOptions<CloseUnreceivedHotelBookingRequestMutation, CloseUnreceivedHotelBookingRequestMutationVariables>;
export const CreateAmadeusBookingDocument = gql`
    mutation createAmadeusBooking($input: CreateAmadeusBookingClientInput!) {
  createAmadeusBooking(input: $input) {
    id
    confirmationNumber
    reservationId
    createdAt
    checkInDate
    checkOutDate
    grandTotalAfterTax
    orderNumber
    avgPrice
    basePrice
    estimatedTax
    nights
    rooms
    guestsPerRoom
    roomBeds
    roomBedType
    thsPrice {
      nightlyPrice
      includesTax
    }
    cancellationDetails {
      deadline
      description
      nonRefundable
    }
    bookingHolder {
      firstName
      lastName
      email
      phone
    }
    hotel {
      ... on AmadeusHotel {
        name
        formattedAddress
        imageUrl
      }
      ... on ManualHotel {
        name
        formattedAddress
      }
    }
    bookingRooms {
      id
      confirmationNumber
      guests {
        id
        firstName
        lastName
      }
    }
    lineItems {
      id
      name
      description
      price
      attributedGuestName
    }
    creditCard {
      id
      last4
      expiration
    }
  }
}
    `;
export type CreateAmadeusBookingMutationFn = Apollo.MutationFunction<CreateAmadeusBookingMutation, CreateAmadeusBookingMutationVariables>;

/**
 * __useCreateAmadeusBookingMutation__
 *
 * To run a mutation, you first call `useCreateAmadeusBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAmadeusBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAmadeusBookingMutation, { data, loading, error }] = useCreateAmadeusBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAmadeusBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAmadeusBookingMutation, CreateAmadeusBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAmadeusBookingMutation, CreateAmadeusBookingMutationVariables>(CreateAmadeusBookingDocument, options);
      }
export type CreateAmadeusBookingMutationHookResult = ReturnType<typeof useCreateAmadeusBookingMutation>;
export type CreateAmadeusBookingMutationResult = Apollo.MutationResult<CreateAmadeusBookingMutation>;
export type CreateAmadeusBookingMutationOptions = Apollo.BaseMutationOptions<CreateAmadeusBookingMutation, CreateAmadeusBookingMutationVariables>;
export const CreateClientTeamMemberDocument = gql`
    mutation createClientTeamMember($input: CreateClientTeamMemberInput!) {
  createClientTeamMember(input: $input) {
    id
    firstName
    lastName
    edipi
    rank
    gender
    semiUniqueIdentifier
    mission
    jobTitle
    taskForce
    unknownGuest
    employeeNumber
  }
}
    `;
export type CreateClientTeamMemberMutationFn = Apollo.MutationFunction<CreateClientTeamMemberMutation, CreateClientTeamMemberMutationVariables>;

/**
 * __useCreateClientTeamMemberMutation__
 *
 * To run a mutation, you first call `useCreateClientTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientTeamMemberMutation, { data, loading, error }] = useCreateClientTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientTeamMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateClientTeamMemberMutation, CreateClientTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateClientTeamMemberMutation, CreateClientTeamMemberMutationVariables>(CreateClientTeamMemberDocument, options);
      }
export type CreateClientTeamMemberMutationHookResult = ReturnType<typeof useCreateClientTeamMemberMutation>;
export type CreateClientTeamMemberMutationResult = Apollo.MutationResult<CreateClientTeamMemberMutation>;
export type CreateClientTeamMemberMutationOptions = Apollo.BaseMutationOptions<CreateClientTeamMemberMutation, CreateClientTeamMemberMutationVariables>;
export const CreateRosterRequestDocument = gql`
    mutation createRosterRequest($input: CreateRosterRequestInput!) {
  createRosterRequest(input: $input) {
    id
  }
}
    `;
export type CreateRosterRequestMutationFn = Apollo.MutationFunction<CreateRosterRequestMutation, CreateRosterRequestMutationVariables>;

/**
 * __useCreateRosterRequestMutation__
 *
 * To run a mutation, you first call `useCreateRosterRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRosterRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRosterRequestMutation, { data, loading, error }] = useCreateRosterRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRosterRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRosterRequestMutation, CreateRosterRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRosterRequestMutation, CreateRosterRequestMutationVariables>(CreateRosterRequestDocument, options);
      }
export type CreateRosterRequestMutationHookResult = ReturnType<typeof useCreateRosterRequestMutation>;
export type CreateRosterRequestMutationResult = Apollo.MutationResult<CreateRosterRequestMutation>;
export type CreateRosterRequestMutationOptions = Apollo.BaseMutationOptions<CreateRosterRequestMutation, CreateRosterRequestMutationVariables>;
export const CreateRosterRequestRemarkDocument = gql`
    mutation createRosterRequestRemark($rosterRequestId: ID!, $input: CreateRosterRequestRemarkInput!) {
  createRosterRequestRemark(rosterRequestId: $rosterRequestId, input: $input) {
    id
  }
}
    `;
export type CreateRosterRequestRemarkMutationFn = Apollo.MutationFunction<CreateRosterRequestRemarkMutation, CreateRosterRequestRemarkMutationVariables>;

/**
 * __useCreateRosterRequestRemarkMutation__
 *
 * To run a mutation, you first call `useCreateRosterRequestRemarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRosterRequestRemarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRosterRequestRemarkMutation, { data, loading, error }] = useCreateRosterRequestRemarkMutation({
 *   variables: {
 *      rosterRequestId: // value for 'rosterRequestId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRosterRequestRemarkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRosterRequestRemarkMutation, CreateRosterRequestRemarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRosterRequestRemarkMutation, CreateRosterRequestRemarkMutationVariables>(CreateRosterRequestRemarkDocument, options);
      }
export type CreateRosterRequestRemarkMutationHookResult = ReturnType<typeof useCreateRosterRequestRemarkMutation>;
export type CreateRosterRequestRemarkMutationResult = Apollo.MutationResult<CreateRosterRequestRemarkMutation>;
export type CreateRosterRequestRemarkMutationOptions = Apollo.BaseMutationOptions<CreateRosterRequestRemarkMutation, CreateRosterRequestRemarkMutationVariables>;
export const RemoveHotelSavedCardDocument = gql`
    mutation removeHotelSavedCard($methodId: ID!) {
  removeHotelSavedCard(methodId: $methodId) {
    id
    brand
    last4
    expiryMonth
    expiryYear
    status
    checkedAt
    isDefault
  }
}
    `;
export type RemoveHotelSavedCardMutationFn = Apollo.MutationFunction<RemoveHotelSavedCardMutation, RemoveHotelSavedCardMutationVariables>;

/**
 * __useRemoveHotelSavedCardMutation__
 *
 * To run a mutation, you first call `useRemoveHotelSavedCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveHotelSavedCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeHotelSavedCardMutation, { data, loading, error }] = useRemoveHotelSavedCardMutation({
 *   variables: {
 *      methodId: // value for 'methodId'
 *   },
 * });
 */
export function useRemoveHotelSavedCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveHotelSavedCardMutation, RemoveHotelSavedCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveHotelSavedCardMutation, RemoveHotelSavedCardMutationVariables>(RemoveHotelSavedCardDocument, options);
      }
export type RemoveHotelSavedCardMutationHookResult = ReturnType<typeof useRemoveHotelSavedCardMutation>;
export type RemoveHotelSavedCardMutationResult = Apollo.MutationResult<RemoveHotelSavedCardMutation>;
export type RemoveHotelSavedCardMutationOptions = Apollo.BaseMutationOptions<RemoveHotelSavedCardMutation, RemoveHotelSavedCardMutationVariables>;
export const RequestNewGroupReservationDocument = gql`
    mutation requestNewGroupReservation($input: NewGroupReservationRequestInput!) {
  requestNewGroupReservation(input: $input) {
    id
  }
}
    `;
export type RequestNewGroupReservationMutationFn = Apollo.MutationFunction<RequestNewGroupReservationMutation, RequestNewGroupReservationMutationVariables>;

/**
 * __useRequestNewGroupReservationMutation__
 *
 * To run a mutation, you first call `useRequestNewGroupReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestNewGroupReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestNewGroupReservationMutation, { data, loading, error }] = useRequestNewGroupReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestNewGroupReservationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestNewGroupReservationMutation, RequestNewGroupReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestNewGroupReservationMutation, RequestNewGroupReservationMutationVariables>(RequestNewGroupReservationDocument, options);
      }
export type RequestNewGroupReservationMutationHookResult = ReturnType<typeof useRequestNewGroupReservationMutation>;
export type RequestNewGroupReservationMutationResult = Apollo.MutationResult<RequestNewGroupReservationMutation>;
export type RequestNewGroupReservationMutationOptions = Apollo.BaseMutationOptions<RequestNewGroupReservationMutation, RequestNewGroupReservationMutationVariables>;
export const RequestNewReservationDocument = gql`
    mutation requestNewReservation($input: NewReservationRequestInput!) {
  requestNewReservation(input: $input) {
    id
  }
}
    `;
export type RequestNewReservationMutationFn = Apollo.MutationFunction<RequestNewReservationMutation, RequestNewReservationMutationVariables>;

/**
 * __useRequestNewReservationMutation__
 *
 * To run a mutation, you first call `useRequestNewReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestNewReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestNewReservationMutation, { data, loading, error }] = useRequestNewReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestNewReservationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestNewReservationMutation, RequestNewReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestNewReservationMutation, RequestNewReservationMutationVariables>(RequestNewReservationDocument, options);
      }
export type RequestNewReservationMutationHookResult = ReturnType<typeof useRequestNewReservationMutation>;
export type RequestNewReservationMutationResult = Apollo.MutationResult<RequestNewReservationMutation>;
export type RequestNewReservationMutationOptions = Apollo.BaseMutationOptions<RequestNewReservationMutation, RequestNewReservationMutationVariables>;
export const GetClientFileUploadUrlDocument = gql`
    mutation getClientFileUploadUrl($input: GetClientFileUploadUrlInput!) {
  getClientFileUploadUrl(input: $input) {
    url
    path
  }
}
    `;
export type GetClientFileUploadUrlMutationFn = Apollo.MutationFunction<GetClientFileUploadUrlMutation, GetClientFileUploadUrlMutationVariables>;

/**
 * __useGetClientFileUploadUrlMutation__
 *
 * To run a mutation, you first call `useGetClientFileUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetClientFileUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getClientFileUploadUrlMutation, { data, loading, error }] = useGetClientFileUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientFileUploadUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GetClientFileUploadUrlMutation, GetClientFileUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GetClientFileUploadUrlMutation, GetClientFileUploadUrlMutationVariables>(GetClientFileUploadUrlDocument, options);
      }
export type GetClientFileUploadUrlMutationHookResult = ReturnType<typeof useGetClientFileUploadUrlMutation>;
export type GetClientFileUploadUrlMutationResult = Apollo.MutationResult<GetClientFileUploadUrlMutation>;
export type GetClientFileUploadUrlMutationOptions = Apollo.BaseMutationOptions<GetClientFileUploadUrlMutation, GetClientFileUploadUrlMutationVariables>;
export const UploadRosterRequestFileDocument = gql`
    mutation uploadRosterRequestFile($input: UploadRosterRequestFileInput!) {
  uploadRosterRequestFile(input: $input) {
    id
    rosterRequestId
    displayFilename
    fileType
    createdAt
    createdBy
    description
  }
}
    `;
export type UploadRosterRequestFileMutationFn = Apollo.MutationFunction<UploadRosterRequestFileMutation, UploadRosterRequestFileMutationVariables>;

/**
 * __useUploadRosterRequestFileMutation__
 *
 * To run a mutation, you first call `useUploadRosterRequestFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadRosterRequestFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadRosterRequestFileMutation, { data, loading, error }] = useUploadRosterRequestFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadRosterRequestFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadRosterRequestFileMutation, UploadRosterRequestFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UploadRosterRequestFileMutation, UploadRosterRequestFileMutationVariables>(UploadRosterRequestFileDocument, options);
      }
export type UploadRosterRequestFileMutationHookResult = ReturnType<typeof useUploadRosterRequestFileMutation>;
export type UploadRosterRequestFileMutationResult = Apollo.MutationResult<UploadRosterRequestFileMutation>;
export type UploadRosterRequestFileMutationOptions = Apollo.BaseMutationOptions<UploadRosterRequestFileMutation, UploadRosterRequestFileMutationVariables>;
export const DeleteRosterRequestFileDocument = gql`
    mutation deleteRosterRequestFile($id: ID!) {
  deleteRosterRequestFile(id: $id)
}
    `;
export type DeleteRosterRequestFileMutationFn = Apollo.MutationFunction<DeleteRosterRequestFileMutation, DeleteRosterRequestFileMutationVariables>;

/**
 * __useDeleteRosterRequestFileMutation__
 *
 * To run a mutation, you first call `useDeleteRosterRequestFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRosterRequestFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRosterRequestFileMutation, { data, loading, error }] = useDeleteRosterRequestFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRosterRequestFileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteRosterRequestFileMutation, DeleteRosterRequestFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteRosterRequestFileMutation, DeleteRosterRequestFileMutationVariables>(DeleteRosterRequestFileDocument, options);
      }
export type DeleteRosterRequestFileMutationHookResult = ReturnType<typeof useDeleteRosterRequestFileMutation>;
export type DeleteRosterRequestFileMutationResult = Apollo.MutationResult<DeleteRosterRequestFileMutation>;
export type DeleteRosterRequestFileMutationOptions = Apollo.BaseMutationOptions<DeleteRosterRequestFileMutation, DeleteRosterRequestFileMutationVariables>;
export const SendBookingConfirmationEmailDocument = gql`
    mutation SendBookingConfirmationEmail($input: SendBookingConfirmationEmailInput!) {
  sendBookingConfirmationEmail(input: $input)
}
    `;
export type SendBookingConfirmationEmailMutationFn = Apollo.MutationFunction<SendBookingConfirmationEmailMutation, SendBookingConfirmationEmailMutationVariables>;

/**
 * __useSendBookingConfirmationEmailMutation__
 *
 * To run a mutation, you first call `useSendBookingConfirmationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBookingConfirmationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBookingConfirmationEmailMutation, { data, loading, error }] = useSendBookingConfirmationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendBookingConfirmationEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendBookingConfirmationEmailMutation, SendBookingConfirmationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendBookingConfirmationEmailMutation, SendBookingConfirmationEmailMutationVariables>(SendBookingConfirmationEmailDocument, options);
      }
export type SendBookingConfirmationEmailMutationHookResult = ReturnType<typeof useSendBookingConfirmationEmailMutation>;
export type SendBookingConfirmationEmailMutationResult = Apollo.MutationResult<SendBookingConfirmationEmailMutation>;
export type SendBookingConfirmationEmailMutationOptions = Apollo.BaseMutationOptions<SendBookingConfirmationEmailMutation, SendBookingConfirmationEmailMutationVariables>;
export const SendRemarkResponseEmailDocument = gql`
    mutation sendRemarkResponseEmail($input: RemarkResponseInput!) {
  sendRemarkResponseEmail(input: $input)
}
    `;
export type SendRemarkResponseEmailMutationFn = Apollo.MutationFunction<SendRemarkResponseEmailMutation, SendRemarkResponseEmailMutationVariables>;

/**
 * __useSendRemarkResponseEmailMutation__
 *
 * To run a mutation, you first call `useSendRemarkResponseEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRemarkResponseEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRemarkResponseEmailMutation, { data, loading, error }] = useSendRemarkResponseEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendRemarkResponseEmailMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendRemarkResponseEmailMutation, SendRemarkResponseEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendRemarkResponseEmailMutation, SendRemarkResponseEmailMutationVariables>(SendRemarkResponseEmailDocument, options);
      }
export type SendRemarkResponseEmailMutationHookResult = ReturnType<typeof useSendRemarkResponseEmailMutation>;
export type SendRemarkResponseEmailMutationResult = Apollo.MutationResult<SendRemarkResponseEmailMutation>;
export type SendRemarkResponseEmailMutationOptions = Apollo.BaseMutationOptions<SendRemarkResponseEmailMutation, SendRemarkResponseEmailMutationVariables>;
export const SetDefaultHotelSavedCardDocument = gql`
    mutation setDefaultHotelSavedCard($methodId: ID!) {
  setDefaultHotelSavedCard(methodId: $methodId) {
    id
    brand
    last4
    expiryMonth
    expiryYear
    status
    checkedAt
    isDefault
  }
}
    `;
export type SetDefaultHotelSavedCardMutationFn = Apollo.MutationFunction<SetDefaultHotelSavedCardMutation, SetDefaultHotelSavedCardMutationVariables>;

/**
 * __useSetDefaultHotelSavedCardMutation__
 *
 * To run a mutation, you first call `useSetDefaultHotelSavedCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultHotelSavedCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultHotelSavedCardMutation, { data, loading, error }] = useSetDefaultHotelSavedCardMutation({
 *   variables: {
 *      methodId: // value for 'methodId'
 *   },
 * });
 */
export function useSetDefaultHotelSavedCardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetDefaultHotelSavedCardMutation, SetDefaultHotelSavedCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetDefaultHotelSavedCardMutation, SetDefaultHotelSavedCardMutationVariables>(SetDefaultHotelSavedCardDocument, options);
      }
export type SetDefaultHotelSavedCardMutationHookResult = ReturnType<typeof useSetDefaultHotelSavedCardMutation>;
export type SetDefaultHotelSavedCardMutationResult = Apollo.MutationResult<SetDefaultHotelSavedCardMutation>;
export type SetDefaultHotelSavedCardMutationOptions = Apollo.BaseMutationOptions<SetDefaultHotelSavedCardMutation, SetDefaultHotelSavedCardMutationVariables>;
export const StartHotelCardSetupDocument = gql`
    mutation startHotelCardSetup($requestKey: ID!) {
  startHotelCardSetup(requestKey: $requestKey, uiMode: ELEMENTS) {
    clientSecret
  }
}
    `;
export type StartHotelCardSetupMutationFn = Apollo.MutationFunction<StartHotelCardSetupMutation, StartHotelCardSetupMutationVariables>;

/**
 * __useStartHotelCardSetupMutation__
 *
 * To run a mutation, you first call `useStartHotelCardSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartHotelCardSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startHotelCardSetupMutation, { data, loading, error }] = useStartHotelCardSetupMutation({
 *   variables: {
 *      requestKey: // value for 'requestKey'
 *   },
 * });
 */
export function useStartHotelCardSetupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartHotelCardSetupMutation, StartHotelCardSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartHotelCardSetupMutation, StartHotelCardSetupMutationVariables>(StartHotelCardSetupDocument, options);
      }
export type StartHotelCardSetupMutationHookResult = ReturnType<typeof useStartHotelCardSetupMutation>;
export type StartHotelCardSetupMutationResult = Apollo.MutationResult<StartHotelCardSetupMutation>;
export type StartHotelCardSetupMutationOptions = Apollo.BaseMutationOptions<StartHotelCardSetupMutation, StartHotelCardSetupMutationVariables>;
export const UpdateGroupReservationRequestDocument = gql`
    mutation updateGroupReservationRequest($id: ID!, $input: UpdateGroupReservationRequestInput!) {
  updateGroupReservationRequest(id: $id, input: $input) {
    id
    requestData {
      ... on RosterRequestDataNewGroupReservation {
        requiredFields {
          name
          value
        }
      }
    }
  }
}
    `;
export type UpdateGroupReservationRequestMutationFn = Apollo.MutationFunction<UpdateGroupReservationRequestMutation, UpdateGroupReservationRequestMutationVariables>;

/**
 * __useUpdateGroupReservationRequestMutation__
 *
 * To run a mutation, you first call `useUpdateGroupReservationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupReservationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupReservationRequestMutation, { data, loading, error }] = useUpdateGroupReservationRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupReservationRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGroupReservationRequestMutation, UpdateGroupReservationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateGroupReservationRequestMutation, UpdateGroupReservationRequestMutationVariables>(UpdateGroupReservationRequestDocument, options);
      }
export type UpdateGroupReservationRequestMutationHookResult = ReturnType<typeof useUpdateGroupReservationRequestMutation>;
export type UpdateGroupReservationRequestMutationResult = Apollo.MutationResult<UpdateGroupReservationRequestMutation>;
export type UpdateGroupReservationRequestMutationOptions = Apollo.BaseMutationOptions<UpdateGroupReservationRequestMutation, UpdateGroupReservationRequestMutationVariables>;
export const BookingDocument = gql`
    query Booking($bookingId: ID!, $includeTravelerPayments: Boolean = false) {
  booking(bookingId: $bookingId) {
    id
    travelerPaymentMethod @include(if: $includeTravelerPayments) {
      brand
      last4
      expiryMonth
      expiryYear
      selectedAt
      status
    }
    guestPaymentMethods @include(if: $includeTravelerPayments) {
      guestId
      guestName
      brand
      last4
      expiryMonth
      expiryYear
      selectedAt
      status
    }
    confirmationNumber
    reservationId
    createdAt
    checkInDate
    checkOutDate
    grandTotalAfterTax
    orderNumber
    avgPrice
    basePrice
    estimatedTax
    nights
    rooms
    guestsPerRoom
    roomBeds
    roomBedType
    thsPrice {
      nightlyPrice
      includesTax
    }
    cancellationDetails {
      deadline
      description
      nonRefundable
    }
    bookingHolder {
      firstName
      lastName
      email
      phone
    }
    hotel {
      ... on AmadeusHotel {
        name
        formattedAddress
        imageUrl
      }
      ... on ManualHotel {
        name
        formattedAddress
      }
    }
    bookingRooms {
      id
      confirmationNumber
      guests {
        id
        firstName
        lastName
      }
    }
    lineItems {
      id
      name
      description
      price
      attributedGuestName
    }
    creditCard {
      id
      last4
      expiration
    }
  }
}
    `;

/**
 * __useBookingQuery__
 *
 * To run a query within a React component, call `useBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      includeTravelerPayments: // value for 'includeTravelerPayments'
 *   },
 * });
 */
export function useBookingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BookingQuery, BookingQueryVariables> & ({ variables: BookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
      }
export function useBookingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookingQuery, BookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
        }
export function useBookingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BookingQuery, BookingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
        }
export type BookingQueryHookResult = ReturnType<typeof useBookingQuery>;
export type BookingLazyQueryHookResult = ReturnType<typeof useBookingLazyQuery>;
export type BookingSuspenseQueryHookResult = ReturnType<typeof useBookingSuspenseQuery>;
export type BookingQueryResult = Apollo.QueryResult<BookingQuery, BookingQueryVariables>;
export const CheckForDuplicateChangeRequestsDocument = gql`
    query checkForDuplicateChangeRequests($ids: [ID!]!) {
  duplicateRosterChangeRequests(rosterRoomAssignmentIds: $ids) {
    id
    createdAt
    requestType
    requestedBy {
      id
      picture
      username
      email
      profile {
        firstName
        lastName
        id
      }
    }
    status
  }
}
    `;

/**
 * __useCheckForDuplicateChangeRequestsQuery__
 *
 * To run a query within a React component, call `useCheckForDuplicateChangeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckForDuplicateChangeRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckForDuplicateChangeRequestsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCheckForDuplicateChangeRequestsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckForDuplicateChangeRequestsQuery, CheckForDuplicateChangeRequestsQueryVariables> & ({ variables: CheckForDuplicateChangeRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckForDuplicateChangeRequestsQuery, CheckForDuplicateChangeRequestsQueryVariables>(CheckForDuplicateChangeRequestsDocument, options);
      }
export function useCheckForDuplicateChangeRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckForDuplicateChangeRequestsQuery, CheckForDuplicateChangeRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckForDuplicateChangeRequestsQuery, CheckForDuplicateChangeRequestsQueryVariables>(CheckForDuplicateChangeRequestsDocument, options);
        }
export function useCheckForDuplicateChangeRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckForDuplicateChangeRequestsQuery, CheckForDuplicateChangeRequestsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckForDuplicateChangeRequestsQuery, CheckForDuplicateChangeRequestsQueryVariables>(CheckForDuplicateChangeRequestsDocument, options);
        }
export type CheckForDuplicateChangeRequestsQueryHookResult = ReturnType<typeof useCheckForDuplicateChangeRequestsQuery>;
export type CheckForDuplicateChangeRequestsLazyQueryHookResult = ReturnType<typeof useCheckForDuplicateChangeRequestsLazyQuery>;
export type CheckForDuplicateChangeRequestsSuspenseQueryHookResult = ReturnType<typeof useCheckForDuplicateChangeRequestsSuspenseQuery>;
export type CheckForDuplicateChangeRequestsQueryResult = Apollo.QueryResult<CheckForDuplicateChangeRequestsQuery, CheckForDuplicateChangeRequestsQueryVariables>;
export const CheckForDuplicateNewReservationRequestsDocument = gql`
    query checkForDuplicateNewReservationRequests($guestIds: [ID!]!) {
  duplicateRosterNewReservationRequests(guestIds: $guestIds) {
    id
    createdAt
    requestType
    requestedBy {
      id
      picture
      username
      email
      profile {
        firstName
        lastName
        id
      }
    }
    status
  }
}
    `;

/**
 * __useCheckForDuplicateNewReservationRequestsQuery__
 *
 * To run a query within a React component, call `useCheckForDuplicateNewReservationRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckForDuplicateNewReservationRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckForDuplicateNewReservationRequestsQuery({
 *   variables: {
 *      guestIds: // value for 'guestIds'
 *   },
 * });
 */
export function useCheckForDuplicateNewReservationRequestsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckForDuplicateNewReservationRequestsQuery, CheckForDuplicateNewReservationRequestsQueryVariables> & ({ variables: CheckForDuplicateNewReservationRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckForDuplicateNewReservationRequestsQuery, CheckForDuplicateNewReservationRequestsQueryVariables>(CheckForDuplicateNewReservationRequestsDocument, options);
      }
export function useCheckForDuplicateNewReservationRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckForDuplicateNewReservationRequestsQuery, CheckForDuplicateNewReservationRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckForDuplicateNewReservationRequestsQuery, CheckForDuplicateNewReservationRequestsQueryVariables>(CheckForDuplicateNewReservationRequestsDocument, options);
        }
export function useCheckForDuplicateNewReservationRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CheckForDuplicateNewReservationRequestsQuery, CheckForDuplicateNewReservationRequestsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CheckForDuplicateNewReservationRequestsQuery, CheckForDuplicateNewReservationRequestsQueryVariables>(CheckForDuplicateNewReservationRequestsDocument, options);
        }
export type CheckForDuplicateNewReservationRequestsQueryHookResult = ReturnType<typeof useCheckForDuplicateNewReservationRequestsQuery>;
export type CheckForDuplicateNewReservationRequestsLazyQueryHookResult = ReturnType<typeof useCheckForDuplicateNewReservationRequestsLazyQuery>;
export type CheckForDuplicateNewReservationRequestsSuspenseQueryHookResult = ReturnType<typeof useCheckForDuplicateNewReservationRequestsSuspenseQuery>;
export type CheckForDuplicateNewReservationRequestsQueryResult = Apollo.QueryResult<CheckForDuplicateNewReservationRequestsQuery, CheckForDuplicateNewReservationRequestsQueryVariables>;
export const ClientGroupRequestsDocument = gql`
    query ClientGroupRequests($limit: Int!, $offset: Int!, $status: TripStatus) {
  clientGroupRequests(limit: $limit, offset: $offset, status: $status) {
    items {
      id
      tripType
      status
      checkInDate
      checkOutDate
      guests
      rooms
      controlNumber
      hasUnknownGuests
      createdAt
      hotels {
        ... on AmadeusHotel {
          name
          address {
            city
            state
          }
        }
        ... on ManualHotel {
          name
          address {
            city
            state
          }
        }
      }
    }
    total
    hasNextPage
    hasPreviousPage
    statusCounts {
      all
      requestReceived
      inProgress
      moreInfoRequired
      awaitingConfirmation
      confirmed
      canceled
    }
  }
}
    `;

/**
 * __useClientGroupRequestsQuery__
 *
 * To run a query within a React component, call `useClientGroupRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientGroupRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientGroupRequestsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useClientGroupRequestsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ClientGroupRequestsQuery, ClientGroupRequestsQueryVariables> & ({ variables: ClientGroupRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientGroupRequestsQuery, ClientGroupRequestsQueryVariables>(ClientGroupRequestsDocument, options);
      }
export function useClientGroupRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientGroupRequestsQuery, ClientGroupRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientGroupRequestsQuery, ClientGroupRequestsQueryVariables>(ClientGroupRequestsDocument, options);
        }
export function useClientGroupRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClientGroupRequestsQuery, ClientGroupRequestsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClientGroupRequestsQuery, ClientGroupRequestsQueryVariables>(ClientGroupRequestsDocument, options);
        }
export type ClientGroupRequestsQueryHookResult = ReturnType<typeof useClientGroupRequestsQuery>;
export type ClientGroupRequestsLazyQueryHookResult = ReturnType<typeof useClientGroupRequestsLazyQuery>;
export type ClientGroupRequestsSuspenseQueryHookResult = ReturnType<typeof useClientGroupRequestsSuspenseQuery>;
export type ClientGroupRequestsQueryResult = Apollo.QueryResult<ClientGroupRequestsQuery, ClientGroupRequestsQueryVariables>;
export const ClientRequiredFieldsDocument = gql`
    query ClientRequiredFields {
  clientRequiredFields {
    pod
    requiredFields {
      value
      label
    }
  }
}
    `;

/**
 * __useClientRequiredFieldsQuery__
 *
 * To run a query within a React component, call `useClientRequiredFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientRequiredFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientRequiredFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientRequiredFieldsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientRequiredFieldsQuery, ClientRequiredFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientRequiredFieldsQuery, ClientRequiredFieldsQueryVariables>(ClientRequiredFieldsDocument, options);
      }
export function useClientRequiredFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientRequiredFieldsQuery, ClientRequiredFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientRequiredFieldsQuery, ClientRequiredFieldsQueryVariables>(ClientRequiredFieldsDocument, options);
        }
export function useClientRequiredFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClientRequiredFieldsQuery, ClientRequiredFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClientRequiredFieldsQuery, ClientRequiredFieldsQueryVariables>(ClientRequiredFieldsDocument, options);
        }
export type ClientRequiredFieldsQueryHookResult = ReturnType<typeof useClientRequiredFieldsQuery>;
export type ClientRequiredFieldsLazyQueryHookResult = ReturnType<typeof useClientRequiredFieldsLazyQuery>;
export type ClientRequiredFieldsSuspenseQueryHookResult = ReturnType<typeof useClientRequiredFieldsSuspenseQuery>;
export type ClientRequiredFieldsQueryResult = Apollo.QueryResult<ClientRequiredFieldsQuery, ClientRequiredFieldsQueryVariables>;
export const ClientSelfBookingsDocument = gql`
    query ClientSelfBookings($limit: Int!, $offset: Int!, $status: TripStatus) {
  clientSelfBookings(limit: $limit, offset: $offset, status: $status) {
    items {
      id
      tripType
      status
      checkInDate
      checkOutDate
      guests
      rooms
      controlNumber
      hasUnknownGuests
      createdAt
      hotels {
        ... on AmadeusHotel {
          name
          address {
            city
            state
          }
        }
        ... on ManualHotel {
          name
          address {
            city
            state
          }
        }
      }
    }
    total
    hasNextPage
    hasPreviousPage
    statusCounts {
      all
      inHouse
      upcoming
      pending
      past
    }
  }
}
    `;

/**
 * __useClientSelfBookingsQuery__
 *
 * To run a query within a React component, call `useClientSelfBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientSelfBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientSelfBookingsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useClientSelfBookingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ClientSelfBookingsQuery, ClientSelfBookingsQueryVariables> & ({ variables: ClientSelfBookingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientSelfBookingsQuery, ClientSelfBookingsQueryVariables>(ClientSelfBookingsDocument, options);
      }
export function useClientSelfBookingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientSelfBookingsQuery, ClientSelfBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientSelfBookingsQuery, ClientSelfBookingsQueryVariables>(ClientSelfBookingsDocument, options);
        }
export function useClientSelfBookingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ClientSelfBookingsQuery, ClientSelfBookingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ClientSelfBookingsQuery, ClientSelfBookingsQueryVariables>(ClientSelfBookingsDocument, options);
        }
export type ClientSelfBookingsQueryHookResult = ReturnType<typeof useClientSelfBookingsQuery>;
export type ClientSelfBookingsLazyQueryHookResult = ReturnType<typeof useClientSelfBookingsLazyQuery>;
export type ClientSelfBookingsSuspenseQueryHookResult = ReturnType<typeof useClientSelfBookingsSuspenseQuery>;
export type ClientSelfBookingsQueryResult = Apollo.QueryResult<ClientSelfBookingsQuery, ClientSelfBookingsQueryVariables>;
export const DashboardReportDocument = gql`
    query dashboardReport {
  dashboardReport {
    summary {
      inHouse
      upcoming
    }
    cities {
      inHouse
      upcoming
      city
      state
    }
    checkins {
      duplicateApprovals
      checkOuts
      checkInsWeekly
      checkIns
    }
  }
}
    `;

/**
 * __useDashboardReportQuery__
 *
 * To run a query within a React component, call `useDashboardReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DashboardReportQuery, DashboardReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DashboardReportQuery, DashboardReportQueryVariables>(DashboardReportDocument, options);
      }
export function useDashboardReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DashboardReportQuery, DashboardReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DashboardReportQuery, DashboardReportQueryVariables>(DashboardReportDocument, options);
        }
export function useDashboardReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DashboardReportQuery, DashboardReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DashboardReportQuery, DashboardReportQueryVariables>(DashboardReportDocument, options);
        }
export type DashboardReportQueryHookResult = ReturnType<typeof useDashboardReportQuery>;
export type DashboardReportLazyQueryHookResult = ReturnType<typeof useDashboardReportLazyQuery>;
export type DashboardReportSuspenseQueryHookResult = ReturnType<typeof useDashboardReportSuspenseQuery>;
export type DashboardReportQueryResult = Apollo.QueryResult<DashboardReportQuery, DashboardReportQueryVariables>;
export const FindAssignmentsByGuestAndDateDocument = gql`
    query findAssignmentsByGuestAndDate($guestId: ID!, $checkInDate: String!, $checkOutDate: String!) {
  findAssignmentsByGuestAndDate(
    guestId: $guestId
    checkInDate: $checkInDate
    checkOutDate: $checkOutDate
  ) {
    id
    checkInDate
    checkOutDate
    hotelRoomNumber
    roomBeds
    hotel {
      ... on AmadeusHotel {
        name
        address {
          city
          state
        }
      }
      ... on ManualHotel {
        name
        address {
          city
          state
        }
      }
    }
  }
}
    `;

/**
 * __useFindAssignmentsByGuestAndDateQuery__
 *
 * To run a query within a React component, call `useFindAssignmentsByGuestAndDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindAssignmentsByGuestAndDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindAssignmentsByGuestAndDateQuery({
 *   variables: {
 *      guestId: // value for 'guestId'
 *      checkInDate: // value for 'checkInDate'
 *      checkOutDate: // value for 'checkOutDate'
 *   },
 * });
 */
export function useFindAssignmentsByGuestAndDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindAssignmentsByGuestAndDateQuery, FindAssignmentsByGuestAndDateQueryVariables> & ({ variables: FindAssignmentsByGuestAndDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindAssignmentsByGuestAndDateQuery, FindAssignmentsByGuestAndDateQueryVariables>(FindAssignmentsByGuestAndDateDocument, options);
      }
export function useFindAssignmentsByGuestAndDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindAssignmentsByGuestAndDateQuery, FindAssignmentsByGuestAndDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindAssignmentsByGuestAndDateQuery, FindAssignmentsByGuestAndDateQueryVariables>(FindAssignmentsByGuestAndDateDocument, options);
        }
export function useFindAssignmentsByGuestAndDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FindAssignmentsByGuestAndDateQuery, FindAssignmentsByGuestAndDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FindAssignmentsByGuestAndDateQuery, FindAssignmentsByGuestAndDateQueryVariables>(FindAssignmentsByGuestAndDateDocument, options);
        }
export type FindAssignmentsByGuestAndDateQueryHookResult = ReturnType<typeof useFindAssignmentsByGuestAndDateQuery>;
export type FindAssignmentsByGuestAndDateLazyQueryHookResult = ReturnType<typeof useFindAssignmentsByGuestAndDateLazyQuery>;
export type FindAssignmentsByGuestAndDateSuspenseQueryHookResult = ReturnType<typeof useFindAssignmentsByGuestAndDateSuspenseQuery>;
export type FindAssignmentsByGuestAndDateQueryResult = Apollo.QueryResult<FindAssignmentsByGuestAndDateQuery, FindAssignmentsByGuestAndDateQueryVariables>;
export const FlightRosterReportDocument = gql`
    query flightRosterReport($filter: FlightRosterFilter, $sort: FlightRosterSort) {
  flightRosterReport(filter: $filter, sort: $sort)
}
    `;

/**
 * __useFlightRosterReportQuery__
 *
 * To run a query within a React component, call `useFlightRosterReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlightRosterReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlightRosterReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useFlightRosterReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FlightRosterReportQuery, FlightRosterReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FlightRosterReportQuery, FlightRosterReportQueryVariables>(FlightRosterReportDocument, options);
      }
export function useFlightRosterReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FlightRosterReportQuery, FlightRosterReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FlightRosterReportQuery, FlightRosterReportQueryVariables>(FlightRosterReportDocument, options);
        }
export function useFlightRosterReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FlightRosterReportQuery, FlightRosterReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FlightRosterReportQuery, FlightRosterReportQueryVariables>(FlightRosterReportDocument, options);
        }
export type FlightRosterReportQueryHookResult = ReturnType<typeof useFlightRosterReportQuery>;
export type FlightRosterReportLazyQueryHookResult = ReturnType<typeof useFlightRosterReportLazyQuery>;
export type FlightRosterReportSuspenseQueryHookResult = ReturnType<typeof useFlightRosterReportSuspenseQuery>;
export type FlightRosterReportQueryResult = Apollo.QueryResult<FlightRosterReportQuery, FlightRosterReportQueryVariables>;
export const FlightRostersDocument = gql`
    query flightRosters($filter: FlightRosterFilter, $sort: FlightRosterSort, $offset: Int, $limit: Int) {
  flightRosters(filter: $filter, sort: $sort, offset: $offset, limit: $limit) {
    items {
      ...FlightRosterFields
    }
    total
  }
}
    ${FlightRosterFieldsFragmentDoc}`;

/**
 * __useFlightRostersQuery__
 *
 * To run a query within a React component, call `useFlightRostersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlightRostersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlightRostersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFlightRostersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FlightRostersQuery, FlightRostersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FlightRostersQuery, FlightRostersQueryVariables>(FlightRostersDocument, options);
      }
export function useFlightRostersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FlightRostersQuery, FlightRostersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FlightRostersQuery, FlightRostersQueryVariables>(FlightRostersDocument, options);
        }
export function useFlightRostersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FlightRostersQuery, FlightRostersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FlightRostersQuery, FlightRostersQueryVariables>(FlightRostersDocument, options);
        }
export type FlightRostersQueryHookResult = ReturnType<typeof useFlightRostersQuery>;
export type FlightRostersLazyQueryHookResult = ReturnType<typeof useFlightRostersLazyQuery>;
export type FlightRostersSuspenseQueryHookResult = ReturnType<typeof useFlightRostersSuspenseQuery>;
export type FlightRostersQueryResult = Apollo.QueryResult<FlightRostersQuery, FlightRostersQueryVariables>;
export const HotelBookingAttemptsDocument = gql`
    query hotelBookingAttempts($requestKey: ID, $bookingIntentId: ID) {
  hotelBookingAttempts(requestKey: $requestKey, bookingIntentId: $bookingIntentId) {
    requestKey
    status
    failureCode
    failureMessage
    recoveryAction
    bookingId
    confirmationNumbers
    pricingId
    bookingIntentId
    replacementPricing {
      id
      bookingIntentId
      fingerprint
      currency
      totalBeforeTax
      totalTax
      totalAfterTax
      paymentMethod
      roomCount
      guestsPerRoom
      checkInDate
      checkOutDate
      roomDescription
      terms
    }
  }
}
    `;

/**
 * __useHotelBookingAttemptsQuery__
 *
 * To run a query within a React component, call `useHotelBookingAttemptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelBookingAttemptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelBookingAttemptsQuery({
 *   variables: {
 *      requestKey: // value for 'requestKey'
 *      bookingIntentId: // value for 'bookingIntentId'
 *   },
 * });
 */
export function useHotelBookingAttemptsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelBookingAttemptsQuery, HotelBookingAttemptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HotelBookingAttemptsQuery, HotelBookingAttemptsQueryVariables>(HotelBookingAttemptsDocument, options);
      }
export function useHotelBookingAttemptsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelBookingAttemptsQuery, HotelBookingAttemptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HotelBookingAttemptsQuery, HotelBookingAttemptsQueryVariables>(HotelBookingAttemptsDocument, options);
        }
export function useHotelBookingAttemptsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HotelBookingAttemptsQuery, HotelBookingAttemptsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HotelBookingAttemptsQuery, HotelBookingAttemptsQueryVariables>(HotelBookingAttemptsDocument, options);
        }
export type HotelBookingAttemptsQueryHookResult = ReturnType<typeof useHotelBookingAttemptsQuery>;
export type HotelBookingAttemptsLazyQueryHookResult = ReturnType<typeof useHotelBookingAttemptsLazyQuery>;
export type HotelBookingAttemptsSuspenseQueryHookResult = ReturnType<typeof useHotelBookingAttemptsSuspenseQuery>;
export type HotelBookingAttemptsQueryResult = Apollo.QueryResult<HotelBookingAttemptsQuery, HotelBookingAttemptsQueryVariables>;
export const HotelBootstrapDocument = gql`
    query hotelBootstrap {
  noShowStatusTypes: __type(name: "NoShowStatus") {
    name
    enumValues {
      name
      description
    }
  }
  rosterRoomAssignmentStatuses: __type(name: "RosterRoomAssignmentStatus") {
    name
    enumValues {
      name
      description
    }
  }
  states: __type(name: "State") {
    name
    enumValues {
      name
    }
  }
  genders: __type(name: "Gender") {
    name
    enumValues {
      name
      description
    }
  }
  rosterRequestType: __type(name: "RosterRequestType") {
    name
    enumValues {
      name
      description
    }
  }
  rosterRequestGroups: __type(name: "RosterRequestGroup") {
    name
    enumValues {
      name
      description
    }
  }
  rosterRequestStatus: __type(name: "RosterRequestStatus") {
    name
    enumValues {
      name
      description
    }
  }
  amenities: __type(name: "Amenity") {
    name
    enumValues {
      name
      description
    }
  }
  clientSubgroups
  unknownGuest {
    id
    firstName
    lastName
    semiUniqueIdentifier
    rank
    gender
    edipi
    unknownGuest
    mission
    taskForce
    employeeNumber
    jobTitle
  }
  clientRequiredFields {
    pod
    requiredFields {
      value
      label
      readOnly
      scope
    }
  }
}
    `;

/**
 * __useHotelBootstrapQuery__
 *
 * To run a query within a React component, call `useHotelBootstrapQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelBootstrapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelBootstrapQuery({
 *   variables: {
 *   },
 * });
 */
export function useHotelBootstrapQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelBootstrapQuery, HotelBootstrapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HotelBootstrapQuery, HotelBootstrapQueryVariables>(HotelBootstrapDocument, options);
      }
export function useHotelBootstrapLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelBootstrapQuery, HotelBootstrapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HotelBootstrapQuery, HotelBootstrapQueryVariables>(HotelBootstrapDocument, options);
        }
export function useHotelBootstrapSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HotelBootstrapQuery, HotelBootstrapQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HotelBootstrapQuery, HotelBootstrapQueryVariables>(HotelBootstrapDocument, options);
        }
export type HotelBootstrapQueryHookResult = ReturnType<typeof useHotelBootstrapQuery>;
export type HotelBootstrapLazyQueryHookResult = ReturnType<typeof useHotelBootstrapLazyQuery>;
export type HotelBootstrapSuspenseQueryHookResult = ReturnType<typeof useHotelBootstrapSuspenseQuery>;
export type HotelBootstrapQueryResult = Apollo.QueryResult<HotelBootstrapQuery, HotelBootstrapQueryVariables>;
export const HotelChainGroupFiltersDocument = gql`
    query hotelChainGroupFilters {
  hotelChainGroups {
    code
    name
  }
}
    `;

/**
 * __useHotelChainGroupFiltersQuery__
 *
 * To run a query within a React component, call `useHotelChainGroupFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelChainGroupFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelChainGroupFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useHotelChainGroupFiltersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelChainGroupFiltersQuery, HotelChainGroupFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HotelChainGroupFiltersQuery, HotelChainGroupFiltersQueryVariables>(HotelChainGroupFiltersDocument, options);
      }
export function useHotelChainGroupFiltersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelChainGroupFiltersQuery, HotelChainGroupFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HotelChainGroupFiltersQuery, HotelChainGroupFiltersQueryVariables>(HotelChainGroupFiltersDocument, options);
        }
export function useHotelChainGroupFiltersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HotelChainGroupFiltersQuery, HotelChainGroupFiltersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HotelChainGroupFiltersQuery, HotelChainGroupFiltersQueryVariables>(HotelChainGroupFiltersDocument, options);
        }
export type HotelChainGroupFiltersQueryHookResult = ReturnType<typeof useHotelChainGroupFiltersQuery>;
export type HotelChainGroupFiltersLazyQueryHookResult = ReturnType<typeof useHotelChainGroupFiltersLazyQuery>;
export type HotelChainGroupFiltersSuspenseQueryHookResult = ReturnType<typeof useHotelChainGroupFiltersSuspenseQuery>;
export type HotelChainGroupFiltersQueryResult = Apollo.QueryResult<HotelChainGroupFiltersQuery, HotelChainGroupFiltersQueryVariables>;
export const HotelMembershipsDocument = gql`
    query hotelMemberships {
  hotelMemberships {
    clientId
    clientName
    isInactive
    roles
    status
    clientTeamMemberId
    version
  }
}
    `;

/**
 * __useHotelMembershipsQuery__
 *
 * To run a query within a React component, call `useHotelMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHotelMembershipsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelMembershipsQuery, HotelMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HotelMembershipsQuery, HotelMembershipsQueryVariables>(HotelMembershipsDocument, options);
      }
export function useHotelMembershipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelMembershipsQuery, HotelMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HotelMembershipsQuery, HotelMembershipsQueryVariables>(HotelMembershipsDocument, options);
        }
export function useHotelMembershipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HotelMembershipsQuery, HotelMembershipsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HotelMembershipsQuery, HotelMembershipsQueryVariables>(HotelMembershipsDocument, options);
        }
export type HotelMembershipsQueryHookResult = ReturnType<typeof useHotelMembershipsQuery>;
export type HotelMembershipsLazyQueryHookResult = ReturnType<typeof useHotelMembershipsLazyQuery>;
export type HotelMembershipsSuspenseQueryHookResult = ReturnType<typeof useHotelMembershipsSuspenseQuery>;
export type HotelMembershipsQueryResult = Apollo.QueryResult<HotelMembershipsQuery, HotelMembershipsQueryVariables>;
export const HotelOfferDetailsWithSessionDocument = gql`
    query hotelOfferDetailsWithSession($amadeusHotelId: ID!, $bookingCode: String!, $roomBedType: String!, $roomBeds: Int!, $roomTypeCode: String!, $checkInDate: String!, $checkOutDate: String!, $roomQuantity: Int, $guestQuantity: Int, $bookingIntentId: ID) {
  hotelOfferDetailsWithSession(
    amadeusHotelId: $amadeusHotelId
    bookingCode: $bookingCode
    roomBedType: $roomBedType
    roomBeds: $roomBeds
    roomTypeCode: $roomTypeCode
    checkInDate: $checkInDate
    checkOutDate: $checkOutDate
    roomQuantity: $roomQuantity
    guestQuantity: $guestQuantity
    bookingIntentId: $bookingIntentId
  ) {
    pricing {
      bookingPricing {
        id
        bookingIntentId
        fingerprint
        currency
        totalBeforeTax
        totalTax
        totalAfterTax
        paymentMethod
        roomCount
        guestsPerRoom
        checkInDate
        checkOutDate
        roomDescription
        terms
      }
      rateChanges {
        rate
        effectiveDate
        expiryDate
        pretax
      }
      grandTotalTax
      grandTotalBeforeTax
      grandTotalAfterTax
      bookingCode
    }
    offer {
      amadeusHotelId
      bookingCode
      roomTypeCode
      rateCode
      rateCodeCategory
      roomBeds
      roomBedType
      cancellationDetails {
        deadline
        nonRefundable
        description
      }
      avgPrice
      basePrice
      totalPrice
      estimatedTax
      paymentMethod
      description
      nights
      checkInDate
      checkOutDate
      rooms
      guestsPerRoom
      thsPrice {
        nightlyPrice
        includesTax
      }
    }
  }
}
    `;

/**
 * __useHotelOfferDetailsWithSessionQuery__
 *
 * To run a query within a React component, call `useHotelOfferDetailsWithSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelOfferDetailsWithSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelOfferDetailsWithSessionQuery({
 *   variables: {
 *      amadeusHotelId: // value for 'amadeusHotelId'
 *      bookingCode: // value for 'bookingCode'
 *      roomBedType: // value for 'roomBedType'
 *      roomBeds: // value for 'roomBeds'
 *      roomTypeCode: // value for 'roomTypeCode'
 *      checkInDate: // value for 'checkInDate'
 *      checkOutDate: // value for 'checkOutDate'
 *      roomQuantity: // value for 'roomQuantity'
 *      guestQuantity: // value for 'guestQuantity'
 *      bookingIntentId: // value for 'bookingIntentId'
 *   },
 * });
 */
export function useHotelOfferDetailsWithSessionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HotelOfferDetailsWithSessionQuery, HotelOfferDetailsWithSessionQueryVariables> & ({ variables: HotelOfferDetailsWithSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HotelOfferDetailsWithSessionQuery, HotelOfferDetailsWithSessionQueryVariables>(HotelOfferDetailsWithSessionDocument, options);
      }
export function useHotelOfferDetailsWithSessionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelOfferDetailsWithSessionQuery, HotelOfferDetailsWithSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HotelOfferDetailsWithSessionQuery, HotelOfferDetailsWithSessionQueryVariables>(HotelOfferDetailsWithSessionDocument, options);
        }
export function useHotelOfferDetailsWithSessionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HotelOfferDetailsWithSessionQuery, HotelOfferDetailsWithSessionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HotelOfferDetailsWithSessionQuery, HotelOfferDetailsWithSessionQueryVariables>(HotelOfferDetailsWithSessionDocument, options);
        }
export type HotelOfferDetailsWithSessionQueryHookResult = ReturnType<typeof useHotelOfferDetailsWithSessionQuery>;
export type HotelOfferDetailsWithSessionLazyQueryHookResult = ReturnType<typeof useHotelOfferDetailsWithSessionLazyQuery>;
export type HotelOfferDetailsWithSessionSuspenseQueryHookResult = ReturnType<typeof useHotelOfferDetailsWithSessionSuspenseQuery>;
export type HotelOfferDetailsWithSessionQueryResult = Apollo.QueryResult<HotelOfferDetailsWithSessionQuery, HotelOfferDetailsWithSessionQueryVariables>;
export const HotelTravelerCardPolicyDocument = gql`
    query hotelTravelerCardPolicy {
  hotelTravelerCardPolicy {
    required
  }
}
    `;

/**
 * __useHotelTravelerCardPolicyQuery__
 *
 * To run a query within a React component, call `useHotelTravelerCardPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelTravelerCardPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelTravelerCardPolicyQuery({
 *   variables: {
 *   },
 * });
 */
export function useHotelTravelerCardPolicyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelTravelerCardPolicyQuery, HotelTravelerCardPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HotelTravelerCardPolicyQuery, HotelTravelerCardPolicyQueryVariables>(HotelTravelerCardPolicyDocument, options);
      }
export function useHotelTravelerCardPolicyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelTravelerCardPolicyQuery, HotelTravelerCardPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HotelTravelerCardPolicyQuery, HotelTravelerCardPolicyQueryVariables>(HotelTravelerCardPolicyDocument, options);
        }
export function useHotelTravelerCardPolicySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HotelTravelerCardPolicyQuery, HotelTravelerCardPolicyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HotelTravelerCardPolicyQuery, HotelTravelerCardPolicyQueryVariables>(HotelTravelerCardPolicyDocument, options);
        }
export type HotelTravelerCardPolicyQueryHookResult = ReturnType<typeof useHotelTravelerCardPolicyQuery>;
export type HotelTravelerCardPolicyLazyQueryHookResult = ReturnType<typeof useHotelTravelerCardPolicyLazyQuery>;
export type HotelTravelerCardPolicySuspenseQueryHookResult = ReturnType<typeof useHotelTravelerCardPolicySuspenseQuery>;
export type HotelTravelerCardPolicyQueryResult = Apollo.QueryResult<HotelTravelerCardPolicyQuery, HotelTravelerCardPolicyQueryVariables>;
export const MyHotelSavedCardsDocument = gql`
    query myHotelSavedCards {
  myHotelSavedCards {
    configured
    methods {
      id
      brand
      last4
      expiryMonth
      expiryYear
      status
      checkedAt
      isDefault
    }
  }
}
    `;

/**
 * __useMyHotelSavedCardsQuery__
 *
 * To run a query within a React component, call `useMyHotelSavedCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyHotelSavedCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyHotelSavedCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyHotelSavedCardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyHotelSavedCardsQuery, MyHotelSavedCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyHotelSavedCardsQuery, MyHotelSavedCardsQueryVariables>(MyHotelSavedCardsDocument, options);
      }
export function useMyHotelSavedCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyHotelSavedCardsQuery, MyHotelSavedCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyHotelSavedCardsQuery, MyHotelSavedCardsQueryVariables>(MyHotelSavedCardsDocument, options);
        }
export function useMyHotelSavedCardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyHotelSavedCardsQuery, MyHotelSavedCardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyHotelSavedCardsQuery, MyHotelSavedCardsQueryVariables>(MyHotelSavedCardsDocument, options);
        }
export type MyHotelSavedCardsQueryHookResult = ReturnType<typeof useMyHotelSavedCardsQuery>;
export type MyHotelSavedCardsLazyQueryHookResult = ReturnType<typeof useMyHotelSavedCardsLazyQuery>;
export type MyHotelSavedCardsSuspenseQueryHookResult = ReturnType<typeof useMyHotelSavedCardsSuspenseQuery>;
export type MyHotelSavedCardsQueryResult = Apollo.QueryResult<MyHotelSavedCardsQuery, MyHotelSavedCardsQueryVariables>;
export const HotelCheckoutPaymentMethodsDocument = gql`
    query hotelCheckoutPaymentMethods {
  hotelTravelerCardPolicy {
    required
  }
  myHotelSavedCards(onlyWhenRequired: true) {
    configured
    methods {
      id
      brand
      last4
      expiryMonth
      expiryYear
      status
      checkedAt
      isDefault
    }
  }
}
    `;

/**
 * __useHotelCheckoutPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useHotelCheckoutPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelCheckoutPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelCheckoutPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHotelCheckoutPaymentMethodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HotelCheckoutPaymentMethodsQuery, HotelCheckoutPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HotelCheckoutPaymentMethodsQuery, HotelCheckoutPaymentMethodsQueryVariables>(HotelCheckoutPaymentMethodsDocument, options);
      }
export function useHotelCheckoutPaymentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelCheckoutPaymentMethodsQuery, HotelCheckoutPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HotelCheckoutPaymentMethodsQuery, HotelCheckoutPaymentMethodsQueryVariables>(HotelCheckoutPaymentMethodsDocument, options);
        }
export function useHotelCheckoutPaymentMethodsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HotelCheckoutPaymentMethodsQuery, HotelCheckoutPaymentMethodsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HotelCheckoutPaymentMethodsQuery, HotelCheckoutPaymentMethodsQueryVariables>(HotelCheckoutPaymentMethodsDocument, options);
        }
export type HotelCheckoutPaymentMethodsQueryHookResult = ReturnType<typeof useHotelCheckoutPaymentMethodsQuery>;
export type HotelCheckoutPaymentMethodsLazyQueryHookResult = ReturnType<typeof useHotelCheckoutPaymentMethodsLazyQuery>;
export type HotelCheckoutPaymentMethodsSuspenseQueryHookResult = ReturnType<typeof useHotelCheckoutPaymentMethodsSuspenseQuery>;
export type HotelCheckoutPaymentMethodsQueryResult = Apollo.QueryResult<HotelCheckoutPaymentMethodsQuery, HotelCheckoutPaymentMethodsQueryVariables>;
export const HotelSearchDocument = gql`
    query hotelSearch($latitude: Float!, $longitude: Float!, $radius: Int, $checkInDate: String, $checkOutDate: String, $roomQuantity: Int, $guestQuantity: Int, $moreIndicator: String, $accessibleRoomsOnly: Boolean) {
  hotelSearch(
    latitude: $latitude
    longitude: $longitude
    radius: $radius
    checkInDate: $checkInDate
    checkOutDate: $checkOutDate
    roomQuantity: $roomQuantity
    guestQuantity: $guestQuantity
    moreIndicator: $moreIndicator
    accessibleRoomsOnly: $accessibleRoomsOnly
  ) {
    moreIndicator
    results {
      hotel {
        distributor
        amadeusHotelId
        hotelChainGroup {
          code
        }
        id
        name
        address {
          addressLine1
          addressLine2
          city
          state
          zip
        }
        formattedAddress
        latitude
        longitude
        amenities
        adaAccessibilityFeatures
        description
        starRating
        imageUrl
        images {
          url
          description
        }
        checkInTime
        checkOutTime
        doNotBook
      }
      offers {
        bookingCode
        roomTypeCode
        rateCode
        rateCodeCategory
        roomBeds
        roomBedType
        cancellationDetails {
          deadline
          nonRefundable
          description
        }
        avgPrice
        basePrice
        totalPrice
        estimatedTax
        paymentMethod
        description
        nights
        checkInDate
        checkOutDate
        rooms
        guestsPerRoom
        thsPrice {
          nightlyPrice
          includesTax
        }
      }
    }
  }
}
    `;

/**
 * __useHotelSearchQuery__
 *
 * To run a query within a React component, call `useHotelSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelSearchQuery({
 *   variables: {
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      radius: // value for 'radius'
 *      checkInDate: // value for 'checkInDate'
 *      checkOutDate: // value for 'checkOutDate'
 *      roomQuantity: // value for 'roomQuantity'
 *      guestQuantity: // value for 'guestQuantity'
 *      moreIndicator: // value for 'moreIndicator'
 *      accessibleRoomsOnly: // value for 'accessibleRoomsOnly'
 *   },
 * });
 */
export function useHotelSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HotelSearchQuery, HotelSearchQueryVariables> & ({ variables: HotelSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HotelSearchQuery, HotelSearchQueryVariables>(HotelSearchDocument, options);
      }
export function useHotelSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelSearchQuery, HotelSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HotelSearchQuery, HotelSearchQueryVariables>(HotelSearchDocument, options);
        }
export function useHotelSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HotelSearchQuery, HotelSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HotelSearchQuery, HotelSearchQueryVariables>(HotelSearchDocument, options);
        }
export type HotelSearchQueryHookResult = ReturnType<typeof useHotelSearchQuery>;
export type HotelSearchLazyQueryHookResult = ReturnType<typeof useHotelSearchLazyQuery>;
export type HotelSearchSuspenseQueryHookResult = ReturnType<typeof useHotelSearchSuspenseQuery>;
export type HotelSearchQueryResult = Apollo.QueryResult<HotelSearchQuery, HotelSearchQueryVariables>;
export const HotelSearchSingleDocument = gql`
    query hotelSearchSingle($amadeusHotelId: ID!, $checkInDate: String, $checkOutDate: String, $roomQuantity: Int, $guestQuantity: Int, $accessibleRoomsOnly: Boolean) {
  hotelSearchSingle(
    amadeusHotelId: $amadeusHotelId
    checkInDate: $checkInDate
    checkOutDate: $checkOutDate
    roomQuantity: $roomQuantity
    guestQuantity: $guestQuantity
    accessibleRoomsOnly: $accessibleRoomsOnly
  ) {
    hotel {
      distributor
      amadeusHotelId
      id
      name
      address {
        addressLine1
        addressLine2
        city
        state
        zip
      }
      formattedAddress
      latitude
      longitude
      amenities
      adaAccessibilityFeatures
      phone
      email
      description
      starRating
      images {
        url
        description
      }
      checkInTime
      checkOutTime
      negotiatedRates(
        checkInDate: $checkInDate
        checkOutDate: $checkOutDate
        roomQuantity: $roomQuantity
      ) {
        single
        double
        singleCents
        doubleCents
        effectiveStartDate
        effectiveEndDate
        isActive
        usage
        singlePricing {
          pricingMode
          selectedTierIndex
        }
        doublePricing {
          pricingMode
          selectedTierIndex
        }
      }
      doNotBook
    }
    offers {
      bookingCode
      roomTypeCode
      rateCode
      rateCodeCategory
      roomBeds
      roomBedType
      cancellationDetails {
        deadline
        nonRefundable
        description
      }
      avgPrice
      basePrice
      totalPrice
      estimatedTax
      paymentMethod
      description
      nights
      checkInDate
      checkOutDate
      rooms
      guestsPerRoom
      thsPrice {
        nightlyPrice
        includesTax
      }
    }
  }
}
    `;

/**
 * __useHotelSearchSingleQuery__
 *
 * To run a query within a React component, call `useHotelSearchSingleQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotelSearchSingleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHotelSearchSingleQuery({
 *   variables: {
 *      amadeusHotelId: // value for 'amadeusHotelId'
 *      checkInDate: // value for 'checkInDate'
 *      checkOutDate: // value for 'checkOutDate'
 *      roomQuantity: // value for 'roomQuantity'
 *      guestQuantity: // value for 'guestQuantity'
 *      accessibleRoomsOnly: // value for 'accessibleRoomsOnly'
 *   },
 * });
 */
export function useHotelSearchSingleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<HotelSearchSingleQuery, HotelSearchSingleQueryVariables> & ({ variables: HotelSearchSingleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HotelSearchSingleQuery, HotelSearchSingleQueryVariables>(HotelSearchSingleDocument, options);
      }
export function useHotelSearchSingleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HotelSearchSingleQuery, HotelSearchSingleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HotelSearchSingleQuery, HotelSearchSingleQueryVariables>(HotelSearchSingleDocument, options);
        }
export function useHotelSearchSingleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HotelSearchSingleQuery, HotelSearchSingleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HotelSearchSingleQuery, HotelSearchSingleQueryVariables>(HotelSearchSingleDocument, options);
        }
export type HotelSearchSingleQueryHookResult = ReturnType<typeof useHotelSearchSingleQuery>;
export type HotelSearchSingleLazyQueryHookResult = ReturnType<typeof useHotelSearchSingleLazyQuery>;
export type HotelSearchSingleSuspenseQueryHookResult = ReturnType<typeof useHotelSearchSingleSuspenseQuery>;
export type HotelSearchSingleQueryResult = Apollo.QueryResult<HotelSearchSingleQuery, HotelSearchSingleQueryVariables>;
export const InitializeDocument = gql`
    query initialize {
  clientUser {
    id
    username
    email
    picture
    roles
    profile {
      clientId
      clientTeamMemberId
      firstName
      id
      lastName
      client {
        id
        thsPod
        isInactive
        clientPortalTravelerSelfBookingEnabled
        clientPortalFlightRosterEnabled
      }
    }
  }
  featureFlags {
    revision
    flags {
      key
      enabled
    }
  }
}
    `;

/**
 * __useInitializeQuery__
 *
 * To run a query within a React component, call `useInitializeQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitializeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitializeQuery({
 *   variables: {
 *   },
 * });
 */
export function useInitializeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InitializeQuery, InitializeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InitializeQuery, InitializeQueryVariables>(InitializeDocument, options);
      }
export function useInitializeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InitializeQuery, InitializeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InitializeQuery, InitializeQueryVariables>(InitializeDocument, options);
        }
export function useInitializeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InitializeQuery, InitializeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InitializeQuery, InitializeQueryVariables>(InitializeDocument, options);
        }
export type InitializeQueryHookResult = ReturnType<typeof useInitializeQuery>;
export type InitializeLazyQueryHookResult = ReturnType<typeof useInitializeLazyQuery>;
export type InitializeSuspenseQueryHookResult = ReturnType<typeof useInitializeSuspenseQuery>;
export type InitializeQueryResult = Apollo.QueryResult<InitializeQuery, InitializeQueryVariables>;
export const PublicHotelPortalTermsDocument = gql`
    query PublicHotelPortalTerms($versionId: ID) {
  publicHotelPortalTerms(versionId: $versionId) {
    ...PortalTermsVersionFields
  }
}
    ${PortalTermsVersionFieldsFragmentDoc}`;

/**
 * __usePublicHotelPortalTermsQuery__
 *
 * To run a query within a React component, call `usePublicHotelPortalTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicHotelPortalTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicHotelPortalTermsQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function usePublicHotelPortalTermsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PublicHotelPortalTermsQuery, PublicHotelPortalTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublicHotelPortalTermsQuery, PublicHotelPortalTermsQueryVariables>(PublicHotelPortalTermsDocument, options);
      }
export function usePublicHotelPortalTermsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublicHotelPortalTermsQuery, PublicHotelPortalTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublicHotelPortalTermsQuery, PublicHotelPortalTermsQueryVariables>(PublicHotelPortalTermsDocument, options);
        }
export function usePublicHotelPortalTermsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublicHotelPortalTermsQuery, PublicHotelPortalTermsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublicHotelPortalTermsQuery, PublicHotelPortalTermsQueryVariables>(PublicHotelPortalTermsDocument, options);
        }
export type PublicHotelPortalTermsQueryHookResult = ReturnType<typeof usePublicHotelPortalTermsQuery>;
export type PublicHotelPortalTermsLazyQueryHookResult = ReturnType<typeof usePublicHotelPortalTermsLazyQuery>;
export type PublicHotelPortalTermsSuspenseQueryHookResult = ReturnType<typeof usePublicHotelPortalTermsSuspenseQuery>;
export type PublicHotelPortalTermsQueryResult = Apollo.QueryResult<PublicHotelPortalTermsQuery, PublicHotelPortalTermsQueryVariables>;
export const MyHotelPortalTermsStatusDocument = gql`
    query MyHotelPortalTermsStatus {
  myHotelPortalTermsStatus {
    requiresAcceptance
    published {
      ...PortalTermsVersionFields
    }
  }
}
    ${PortalTermsVersionFieldsFragmentDoc}`;

/**
 * __useMyHotelPortalTermsStatusQuery__
 *
 * To run a query within a React component, call `useMyHotelPortalTermsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyHotelPortalTermsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyHotelPortalTermsStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyHotelPortalTermsStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MyHotelPortalTermsStatusQuery, MyHotelPortalTermsStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MyHotelPortalTermsStatusQuery, MyHotelPortalTermsStatusQueryVariables>(MyHotelPortalTermsStatusDocument, options);
      }
export function useMyHotelPortalTermsStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MyHotelPortalTermsStatusQuery, MyHotelPortalTermsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MyHotelPortalTermsStatusQuery, MyHotelPortalTermsStatusQueryVariables>(MyHotelPortalTermsStatusDocument, options);
        }
export function useMyHotelPortalTermsStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MyHotelPortalTermsStatusQuery, MyHotelPortalTermsStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MyHotelPortalTermsStatusQuery, MyHotelPortalTermsStatusQueryVariables>(MyHotelPortalTermsStatusDocument, options);
        }
export type MyHotelPortalTermsStatusQueryHookResult = ReturnType<typeof useMyHotelPortalTermsStatusQuery>;
export type MyHotelPortalTermsStatusLazyQueryHookResult = ReturnType<typeof useMyHotelPortalTermsStatusLazyQuery>;
export type MyHotelPortalTermsStatusSuspenseQueryHookResult = ReturnType<typeof useMyHotelPortalTermsStatusSuspenseQuery>;
export type MyHotelPortalTermsStatusQueryResult = Apollo.QueryResult<MyHotelPortalTermsStatusQuery, MyHotelPortalTermsStatusQueryVariables>;
export const AcceptHotelPortalTermsDocument = gql`
    mutation AcceptHotelPortalTerms($versionId: ID!) {
  acceptHotelPortalTerms(versionId: $versionId) {
    requiresAcceptance
    published {
      ...PortalTermsVersionFields
    }
  }
}
    ${PortalTermsVersionFieldsFragmentDoc}`;
export type AcceptHotelPortalTermsMutationFn = Apollo.MutationFunction<AcceptHotelPortalTermsMutation, AcceptHotelPortalTermsMutationVariables>;

/**
 * __useAcceptHotelPortalTermsMutation__
 *
 * To run a mutation, you first call `useAcceptHotelPortalTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptHotelPortalTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptHotelPortalTermsMutation, { data, loading, error }] = useAcceptHotelPortalTermsMutation({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useAcceptHotelPortalTermsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptHotelPortalTermsMutation, AcceptHotelPortalTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcceptHotelPortalTermsMutation, AcceptHotelPortalTermsMutationVariables>(AcceptHotelPortalTermsDocument, options);
      }
export type AcceptHotelPortalTermsMutationHookResult = ReturnType<typeof useAcceptHotelPortalTermsMutation>;
export type AcceptHotelPortalTermsMutationResult = Apollo.MutationResult<AcceptHotelPortalTermsMutation>;
export type AcceptHotelPortalTermsMutationOptions = Apollo.BaseMutationOptions<AcceptHotelPortalTermsMutation, AcceptHotelPortalTermsMutationVariables>;
export const ProposalDocument = gql`
    query proposal($id: ID!) {
  proposal(id: $id) {
    id
    preferredProposalOptionId
    requestData {
      ... on RosterRequestDataNewGroupReservation {
        breakfast
        freeParking
        kitchen
        washerDryer
        meetingSpace
        meetingSpaceRequirements {
          squareFootage
          avRequirements
          setupDetails
        }
        otherAmenities
        distanceFromDestination
        brandPreference
        contactEmail
        contactPhone
        controlNum
        skipGuestList
        additionalPreferences
        checkInDate
        checkOutDate
        guestQuantity
        shortList {
          amadeusHotelId
          id
          formattedAddress
          imageUrl
          name
          starRating
        }
        quantities {
          single
          double
          suite
        }
        single {
          id
          firstName
          gender
          lastName
          rank
          edipi
          semiUniqueIdentifier
        }
        suite {
          id
          firstName
          gender
          lastName
          rank
          edipi
          semiUniqueIdentifier
        }
        double {
          firstBed {
            id
            firstName
            gender
            lastName
            rank
            edipi
            semiUniqueIdentifier
          }
          secondBed {
            id
            firstName
            gender
            lastName
            rank
            edipi
            semiUniqueIdentifier
          }
        }
      }
    }
    proposalOptions {
      id
      totalRooms
      totalPrice
      hotels {
        id
        hotelId
        hotel {
          ... on AmadeusHotel {
            name
            formattedAddress
          }
          ... on ManualHotel {
            name
            formattedAddress
          }
        }
        single {
          roomBedType
          roomAmount
          avgPrice
          cancellationDeadline
        }
        double {
          roomBedType
          roomAmount
          avgPrice
          cancellationDeadline
        }
        suite {
          roomBedType
          roomAmount
          avgPrice
          cancellationDeadline
        }
        lineItems {
          id
          name
          description
          price
          selected
        }
      }
    }
  }
}
    `;

/**
 * __useProposalQuery__
 *
 * To run a query within a React component, call `useProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProposalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProposalQuery, ProposalQueryVariables> & ({ variables: ProposalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProposalQuery, ProposalQueryVariables>(ProposalDocument, options);
      }
export function useProposalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProposalQuery, ProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProposalQuery, ProposalQueryVariables>(ProposalDocument, options);
        }
export function useProposalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProposalQuery, ProposalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProposalQuery, ProposalQueryVariables>(ProposalDocument, options);
        }
export type ProposalQueryHookResult = ReturnType<typeof useProposalQuery>;
export type ProposalLazyQueryHookResult = ReturnType<typeof useProposalLazyQuery>;
export type ProposalSuspenseQueryHookResult = ReturnType<typeof useProposalSuspenseQuery>;
export type ProposalQueryResult = Apollo.QueryResult<ProposalQuery, ProposalQueryVariables>;
export const RosterListDocument = gql`
    query rosterList($limit: Int, $offset: Int, $filter: RosterFilterInput, $sort: SortInput) {
  roster(limit: $limit, offset: $offset, filter: $filter, sort: $sort) {
    items {
      checkInDate
      checkOutDate
      id
      status
      noShowStatus
      hotelRoomNumber
      hotelConfirmationNumber
      bedNumber
      roomBeds
      ngRate
      quotedRate
      guest {
        edipi
        semiUniqueIdentifier
        firstName
        id
        lastName
        gender
        rank
        mission
        taskForce
      }
      order {
        orderNumber
      }
      hotel {
        ... on AmadeusHotel {
          address {
            addressLine1
            addressLine2
            city
            state
            zip
          }
          name
        }
        ... on ManualHotel {
          address {
            addressLine1
            addressLine2
            city
            state
            zip
          }
          name
        }
      }
      hasDuplicateApproval
      duplicateApproval {
        ... on DuplicateApprovalBlanket {
          id
          createdAt
        }
        ... on DuplicateApprovalAuthorized {
          id
          approver {
            id
            firstName
            lastName
            rank
            edipi
          }
          createdAt
        }
      }
      requiredFields {
        name
        value
      }
      roommates {
        id
        firstName
        lastName
        semiUniqueIdentifier
      }
    }
    total
  }
}
    `;

/**
 * __useRosterListQuery__
 *
 * To run a query within a React component, call `useRosterListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterListQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useRosterListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RosterListQuery, RosterListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RosterListQuery, RosterListQueryVariables>(RosterListDocument, options);
      }
export function useRosterListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RosterListQuery, RosterListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RosterListQuery, RosterListQueryVariables>(RosterListDocument, options);
        }
export function useRosterListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RosterListQuery, RosterListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RosterListQuery, RosterListQueryVariables>(RosterListDocument, options);
        }
export type RosterListQueryHookResult = ReturnType<typeof useRosterListQuery>;
export type RosterListLazyQueryHookResult = ReturnType<typeof useRosterListLazyQuery>;
export type RosterListSuspenseQueryHookResult = ReturnType<typeof useRosterListSuspenseQuery>;
export type RosterListQueryResult = Apollo.QueryResult<RosterListQuery, RosterListQueryVariables>;
export const RosterFindGuestByEdipiDocument = gql`
    query rosterFindGuestByEdipi($edipi: String, $searchText: String, $limit: Int!) {
  clientTeamMembers(edipi: $edipi, searchText: $searchText, limit: $limit) {
    id
    firstName
    lastName
    edipi
    semiUniqueIdentifier
    rank
    gender
    mission
    taskForce
    unknownGuest
  }
}
    `;

/**
 * __useRosterFindGuestByEdipiQuery__
 *
 * To run a query within a React component, call `useRosterFindGuestByEdipiQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterFindGuestByEdipiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterFindGuestByEdipiQuery({
 *   variables: {
 *      edipi: // value for 'edipi'
 *      searchText: // value for 'searchText'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRosterFindGuestByEdipiQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RosterFindGuestByEdipiQuery, RosterFindGuestByEdipiQueryVariables> & ({ variables: RosterFindGuestByEdipiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RosterFindGuestByEdipiQuery, RosterFindGuestByEdipiQueryVariables>(RosterFindGuestByEdipiDocument, options);
      }
export function useRosterFindGuestByEdipiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RosterFindGuestByEdipiQuery, RosterFindGuestByEdipiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RosterFindGuestByEdipiQuery, RosterFindGuestByEdipiQueryVariables>(RosterFindGuestByEdipiDocument, options);
        }
export function useRosterFindGuestByEdipiSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RosterFindGuestByEdipiQuery, RosterFindGuestByEdipiQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RosterFindGuestByEdipiQuery, RosterFindGuestByEdipiQueryVariables>(RosterFindGuestByEdipiDocument, options);
        }
export type RosterFindGuestByEdipiQueryHookResult = ReturnType<typeof useRosterFindGuestByEdipiQuery>;
export type RosterFindGuestByEdipiLazyQueryHookResult = ReturnType<typeof useRosterFindGuestByEdipiLazyQuery>;
export type RosterFindGuestByEdipiSuspenseQueryHookResult = ReturnType<typeof useRosterFindGuestByEdipiSuspenseQuery>;
export type RosterFindGuestByEdipiQueryResult = Apollo.QueryResult<RosterFindGuestByEdipiQuery, RosterFindGuestByEdipiQueryVariables>;
export const RosterItemsForRequestDocument = gql`
    query rosterItemsForRequest($ids: [ID!]!) {
  rosterItems(ids: $ids) {
    id
    checkInDate
    checkOutDate
    guest {
      id
      firstName
      lastName
      semiUniqueIdentifier
    }
    hotel {
      ... on AmadeusHotel {
        databaseId: id
        name
      }
      ... on ManualHotel {
        id
        name
      }
    }
    requiredFields {
      name
      value
    }
  }
}
    `;

/**
 * __useRosterItemsForRequestQuery__
 *
 * To run a query within a React component, call `useRosterItemsForRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterItemsForRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterItemsForRequestQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRosterItemsForRequestQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RosterItemsForRequestQuery, RosterItemsForRequestQueryVariables> & ({ variables: RosterItemsForRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RosterItemsForRequestQuery, RosterItemsForRequestQueryVariables>(RosterItemsForRequestDocument, options);
      }
export function useRosterItemsForRequestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RosterItemsForRequestQuery, RosterItemsForRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RosterItemsForRequestQuery, RosterItemsForRequestQueryVariables>(RosterItemsForRequestDocument, options);
        }
export function useRosterItemsForRequestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RosterItemsForRequestQuery, RosterItemsForRequestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RosterItemsForRequestQuery, RosterItemsForRequestQueryVariables>(RosterItemsForRequestDocument, options);
        }
export type RosterItemsForRequestQueryHookResult = ReturnType<typeof useRosterItemsForRequestQuery>;
export type RosterItemsForRequestLazyQueryHookResult = ReturnType<typeof useRosterItemsForRequestLazyQuery>;
export type RosterItemsForRequestSuspenseQueryHookResult = ReturnType<typeof useRosterItemsForRequestSuspenseQuery>;
export type RosterItemsForRequestQueryResult = Apollo.QueryResult<RosterItemsForRequestQuery, RosterItemsForRequestQueryVariables>;
export const RosterReportDocument = gql`
    query rosterReport($filter: RosterFilterInput, $sort: SortInput) {
  rosterReport(filter: $filter, sort: $sort)
}
    `;

/**
 * __useRosterReportQuery__
 *
 * To run a query within a React component, call `useRosterReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useRosterReportQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RosterReportQuery, RosterReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RosterReportQuery, RosterReportQueryVariables>(RosterReportDocument, options);
      }
export function useRosterReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RosterReportQuery, RosterReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RosterReportQuery, RosterReportQueryVariables>(RosterReportDocument, options);
        }
export function useRosterReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RosterReportQuery, RosterReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RosterReportQuery, RosterReportQueryVariables>(RosterReportDocument, options);
        }
export type RosterReportQueryHookResult = ReturnType<typeof useRosterReportQuery>;
export type RosterReportLazyQueryHookResult = ReturnType<typeof useRosterReportLazyQuery>;
export type RosterReportSuspenseQueryHookResult = ReturnType<typeof useRosterReportSuspenseQuery>;
export type RosterReportQueryResult = Apollo.QueryResult<RosterReportQuery, RosterReportQueryVariables>;
export const RosterRequestDocument = gql`
    query rosterRequest($id: ID!) {
  rosterRequest(id: $id) {
    details
    controlNumber
    id
    proposalId
    files {
      id
      rosterRequestId
      displayFilename
      fileType
      createdAt
      createdBy
      description
    }
    order {
      id
      reservations {
        id
        orderId
        reservationNumber
        checkInDate
        checkOutDate
        rooms
        guestsPerRoom
        nights
        notes
        booking {
          id
          confirmationNumber
          reservationId
          orderNumber
          createdAt
          amadeusPnrNumber
          amadeusCreatedAt
          hotel {
            ... on AmadeusHotel {
              amadeusId: id
              name
              formattedAddress
              phone
              email
              imageUrl
              address {
                addressLine1
                addressLine2
                city
                state
                zip
              }
            }
            ... on ManualHotel {
              manualId: id
              name
              formattedAddress
              phone
              email
              address {
                addressLine1
                addressLine2
                city
                state
                zip
              }
            }
          }
          roomBeds
          rooms
          roomBedType
          cancellationDetails {
            deadline
            nonRefundable
            description
          }
          avgPrice
          totalPrice
          estimatedTax
          basePrice
          grandTotalAfterTax
          thsPrice {
            nightlyPrice
            includesTax
          }
          nights
          checkInDate
          checkOutDate
          guestsPerRoom
          lineItems {
            id
            name
            description
            price
          }
          bookingHolder {
            email
            phone
            firstName
            lastName
          }
          bookingRooms {
            id
            confirmationNumber
            guests {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
    status
    requestType
    rosterRoomAssignments {
      id
      checkOutDate
      checkInDate
      hotel {
        ... on AmadeusHotel {
          databaseId: id
          name
          address {
            city
            state
          }
        }
        ... on ManualHotel {
          id
          name
          address {
            city
            state
          }
        }
      }
      guest {
        id
        firstName
        lastName
        semiUniqueIdentifier
      }
      requiredFields {
        name
        value
      }
    }
    client {
      id
    }
    requestedBy {
      id
      picture
      username
      profile {
        firstName
        lastName
        id
      }
      email
      group
    }
    createdAt
    remarks {
      id
      note
      internal
      createdAt
      createdBy {
        picture
        email
        picture
        username
        profile {
          firstName
          lastName
          id
        }
      }
    }
    requestData {
      ... on RosterRequestDataNewReservation {
        preferredHotelPhone
        preferredHotelName
        preferredHotelEmail
        preferredHotelAddress
        requiredFields {
          name
          value
        }
        newGuests {
          checkin
          checkout
          edipi
          firstName
          gender
          id
          lastName
          previousHotelAddress
          previousHotelName
          rank
          remarks
          roomType
        }
        existingGuests {
          checkin
          checkout
          edipi
          firstName
          gender
          id
          lastName
          previousHotelAddress
          previousHotelName
          rank
          remarks
          roomType
        }
      }
      ... on RosterRequestDataDateChange {
        checkOutDate
        checkInDate
      }
      ... on RosterRequestDataNewGroupReservation {
        breakfast
        freeParking
        kitchen
        washerDryer
        meetingSpace
        meetingSpaceRequirements {
          squareFootage
          avRequirements
          setupDetails
        }
        otherAmenities
        distanceFromDestination
        brandPreference
        contactEmail
        contactPhone
        controlNum
        skipGuestList
        groupCheckInDate: checkInDate
        groupCheckOutDate: checkOutDate
        guestQuantity
        requiredFields {
          name
          value
        }
        shortList {
          amadeusHotelId
          id
          formattedAddress
          imageUrl
          name
          starRating
        }
        quantities {
          single
          double
          suite
        }
        roomConfigurations {
          single {
            rooms
            guests
          }
          double {
            rooms
            guests
          }
          suite {
            rooms
            guests
          }
        }
        single {
          id
          firstName
          gender
          lastName
          rank
          edipi
          semiUniqueIdentifier
        }
        suite {
          id
          firstName
          gender
          lastName
          rank
          edipi
          semiUniqueIdentifier
        }
        double {
          firstBed {
            id
            firstName
            gender
            lastName
            rank
            edipi
            semiUniqueIdentifier
          }
          secondBed {
            id
            firstName
            gender
            lastName
            rank
            edipi
            semiUniqueIdentifier
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRosterRequestQuery__
 *
 * To run a query within a React component, call `useRosterRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRosterRequestQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RosterRequestQuery, RosterRequestQueryVariables> & ({ variables: RosterRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RosterRequestQuery, RosterRequestQueryVariables>(RosterRequestDocument, options);
      }
export function useRosterRequestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RosterRequestQuery, RosterRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RosterRequestQuery, RosterRequestQueryVariables>(RosterRequestDocument, options);
        }
export function useRosterRequestSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RosterRequestQuery, RosterRequestQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RosterRequestQuery, RosterRequestQueryVariables>(RosterRequestDocument, options);
        }
export type RosterRequestQueryHookResult = ReturnType<typeof useRosterRequestQuery>;
export type RosterRequestLazyQueryHookResult = ReturnType<typeof useRosterRequestLazyQuery>;
export type RosterRequestSuspenseQueryHookResult = ReturnType<typeof useRosterRequestSuspenseQuery>;
export type RosterRequestQueryResult = Apollo.QueryResult<RosterRequestQuery, RosterRequestQueryVariables>;
export const RosterRequestFileUrlDocument = gql`
    query rosterRequestFileUrl($id: ID!) {
  rosterRequestFileUrl(id: $id)
}
    `;

/**
 * __useRosterRequestFileUrlQuery__
 *
 * To run a query within a React component, call `useRosterRequestFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterRequestFileUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterRequestFileUrlQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRosterRequestFileUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RosterRequestFileUrlQuery, RosterRequestFileUrlQueryVariables> & ({ variables: RosterRequestFileUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RosterRequestFileUrlQuery, RosterRequestFileUrlQueryVariables>(RosterRequestFileUrlDocument, options);
      }
export function useRosterRequestFileUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RosterRequestFileUrlQuery, RosterRequestFileUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RosterRequestFileUrlQuery, RosterRequestFileUrlQueryVariables>(RosterRequestFileUrlDocument, options);
        }
export function useRosterRequestFileUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RosterRequestFileUrlQuery, RosterRequestFileUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RosterRequestFileUrlQuery, RosterRequestFileUrlQueryVariables>(RosterRequestFileUrlDocument, options);
        }
export type RosterRequestFileUrlQueryHookResult = ReturnType<typeof useRosterRequestFileUrlQuery>;
export type RosterRequestFileUrlLazyQueryHookResult = ReturnType<typeof useRosterRequestFileUrlLazyQuery>;
export type RosterRequestFileUrlSuspenseQueryHookResult = ReturnType<typeof useRosterRequestFileUrlSuspenseQuery>;
export type RosterRequestFileUrlQueryResult = Apollo.QueryResult<RosterRequestFileUrlQuery, RosterRequestFileUrlQueryVariables>;
export const RosterRequestsDocument = gql`
    query rosterRequests($limit: Int!, $offset: Int!, $sort: SortInput, $filter: RosterRequestsFilterInput) {
  rosterRequests(limit: $limit, offset: $offset, sort: $sort, filter: $filter) {
    items {
      id
      createdAt
      details
      id
      requestType
      requestedBy {
        id
        picture
        username
        profile {
          firstName
          lastName
          id
        }
      }
      status
      assignedGroup
      controlNumber
    }
    total
  }
}
    `;

/**
 * __useRosterRequestsQuery__
 *
 * To run a query within a React component, call `useRosterRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRosterRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRosterRequestsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRosterRequestsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RosterRequestsQuery, RosterRequestsQueryVariables> & ({ variables: RosterRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RosterRequestsQuery, RosterRequestsQueryVariables>(RosterRequestsDocument, options);
      }
export function useRosterRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RosterRequestsQuery, RosterRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RosterRequestsQuery, RosterRequestsQueryVariables>(RosterRequestsDocument, options);
        }
export function useRosterRequestsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RosterRequestsQuery, RosterRequestsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RosterRequestsQuery, RosterRequestsQueryVariables>(RosterRequestsDocument, options);
        }
export type RosterRequestsQueryHookResult = ReturnType<typeof useRosterRequestsQuery>;
export type RosterRequestsLazyQueryHookResult = ReturnType<typeof useRosterRequestsLazyQuery>;
export type RosterRequestsSuspenseQueryHookResult = ReturnType<typeof useRosterRequestsSuspenseQuery>;
export type RosterRequestsQueryResult = Apollo.QueryResult<RosterRequestsQuery, RosterRequestsQueryVariables>;
export const SavedHotelDocument = gql`
    query savedHotel($id: ID!) {
  savedHotel(id: $id) {
    ... on AmadeusHotel {
      amadeusHotelId
      name
      chainCode
      chainName
      hotelChainGroup {
        name
      }
      databaseId: id
      doNotBook
      formattedAddress
      email
      phone
      amenities
      imageUrl
      verified
    }
    ... on ManualHotel {
      id
      name
      chainCode
      chainName
      hotelChainGroup {
        name
      }
      doNotBook
      formattedAddress
      email
      phone
      amenities
    }
  }
}
    `;

/**
 * __useSavedHotelQuery__
 *
 * To run a query within a React component, call `useSavedHotelQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedHotelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedHotelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSavedHotelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SavedHotelQuery, SavedHotelQueryVariables> & ({ variables: SavedHotelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SavedHotelQuery, SavedHotelQueryVariables>(SavedHotelDocument, options);
      }
export function useSavedHotelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SavedHotelQuery, SavedHotelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SavedHotelQuery, SavedHotelQueryVariables>(SavedHotelDocument, options);
        }
export function useSavedHotelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SavedHotelQuery, SavedHotelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SavedHotelQuery, SavedHotelQueryVariables>(SavedHotelDocument, options);
        }
export type SavedHotelQueryHookResult = ReturnType<typeof useSavedHotelQuery>;
export type SavedHotelLazyQueryHookResult = ReturnType<typeof useSavedHotelLazyQuery>;
export type SavedHotelSuspenseQueryHookResult = ReturnType<typeof useSavedHotelSuspenseQuery>;
export type SavedHotelQueryResult = Apollo.QueryResult<SavedHotelQuery, SavedHotelQueryVariables>;
export const UsersWithProfileDocument = gql`
    query usersWithProfile {
  users {
    id
    username
    email
    picture
    blocked
    roles
    profile {
      id
      firstName
      lastName
      client {
        id
      }
    }
  }
}
    `;

/**
 * __useUsersWithProfileQuery__
 *
 * To run a query within a React component, call `useUsersWithProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersWithProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersWithProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersWithProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersWithProfileQuery, UsersWithProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersWithProfileQuery, UsersWithProfileQueryVariables>(UsersWithProfileDocument, options);
      }
export function useUsersWithProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersWithProfileQuery, UsersWithProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersWithProfileQuery, UsersWithProfileQueryVariables>(UsersWithProfileDocument, options);
        }
export function useUsersWithProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersWithProfileQuery, UsersWithProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsersWithProfileQuery, UsersWithProfileQueryVariables>(UsersWithProfileDocument, options);
        }
export type UsersWithProfileQueryHookResult = ReturnType<typeof useUsersWithProfileQuery>;
export type UsersWithProfileLazyQueryHookResult = ReturnType<typeof useUsersWithProfileLazyQuery>;
export type UsersWithProfileSuspenseQueryHookResult = ReturnType<typeof useUsersWithProfileSuspenseQuery>;
export type UsersWithProfileQueryResult = Apollo.QueryResult<UsersWithProfileQuery, UsersWithProfileQueryVariables>;